
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("e4JJO", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");


var $ij2FZ = parcelRequire("ij2FZ");

const $8d8bfd1ce8e7d438$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $8d8bfd1ce8e7d438$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            const linkCount = node.marks?.some((mark)=>mark.type === 'link') ? currentValue.linkCount + 1 : currentValue.linkCount;
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $8d8bfd1ce8e7d438$var$wordCount(node.text),
                linkCount: linkCount
            };
        case 'mention':
            return {
                ...currentValue,
                mentionCount: currentValue.mentionCount + 1
            };
        case 'inlineCard':
        case 'embedCard':
            return {
                ...currentValue,
                linkCount: currentValue.linkCount + 1
            };
        case 'inlineExtension':
            if (node.attrs?.extensionKey === (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY) && node.attrs?.parameters?.slug) return {
                ...currentValue,
                explicitSkills: [
                    ...currentValue.explicitSkills,
                    node.attrs.parameters.slug
                ]
            };
            return currentValue;
    }
    return currentValue;
};
const $8d8bfd1ce8e7d438$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        adfLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        linkCount: 0,
        mentionCount: 0,
        explicitSkills: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$8d8bfd1ce8e7d438$var$processADFNode(currentValue, node), initialFeatures);
};
const $8d8bfd1ce8e7d438$export$c5df045f791f45da = (adf)=>(0, $1A9t2.reduce)(adf, (currentValue, node)=>node.type === 'text' && node.text ? currentValue + node.text : currentValue, '');
/**
 * Backtick-wrapped placeholders in prompt cards (e.g. `document`, `person`) are meant to be replaced by the user.
 * When comparing sent text to the card prompt, we treat these as variable and only require fixed segments to match.
 */ const $8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX = /`[^`]*`/g;
const $8d8bfd1ce8e7d438$export$2def72d3ef808307 = (normalizedSentText, normalizedOriginalPrompt)=>{
    if (normalizedSentText === normalizedOriginalPrompt) return 'asIs';
    if (normalizedOriginalPrompt.length === 0) return null;
    const fixedSegments = normalizedOriginalPrompt.split($8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX);
    const hasPlaceholders = fixedSegments.length > 1;
    if (hasPlaceholders) {
        let searchFrom = 0;
        let firstSegmentMatchedAtStart = true;
        for (const segment of fixedSegments){
            const trimmed = segment.trim();
            if (trimmed.length === 0) continue;
            const idx = normalizedSentText.indexOf(trimmed, searchFrom);
            if (idx === -1) {
                // User truncated or edited after matching some of the card — if we matched at least one
                // fixed segment, they started from the card so treat as tweaked
                if (searchFrom > 0) return 'tweaked';
                // No segment matched yet; check containment (strip placeholders so "on `x`" vs "on x" match)
                const originalWithoutPlaceholders = normalizedOriginalPrompt.replace($8d8bfd1ce8e7d438$var$BACKTICK_PLACEHOLDER_REGEX, ' ').replace(/\s+/g, ' ').trim();
                if (normalizedOriginalPrompt.includes(normalizedSentText) || normalizedSentText.includes(normalizedOriginalPrompt) || originalWithoutPlaceholders.includes(normalizedSentText) || normalizedSentText.includes(originalWithoutPlaceholders) || originalWithoutPlaceholders.startsWith(normalizedSentText) || normalizedSentText.startsWith(originalWithoutPlaceholders)) return 'tweaked';
                return null;
            }
            if (searchFrom === 0 && idx !== 0) firstSegmentMatchedAtStart = false;
            searchFrom = idx + trimmed.length;
        }
        // Trailing content after the last fixed segment
        if (normalizedSentText.length > searchFrom) return 'tweaked';
        return firstSegmentMatchedAtStart ? 'placeholdersFilled' : 'tweaked';
    }
    if (normalizedSentText.includes(normalizedOriginalPrompt) || normalizedOriginalPrompt.includes(normalizedSentText)) return 'tweaked';
    return null;
};
const $8d8bfd1ce8e7d438$export$89d0962bb7c449e3 = (normalizedSentText, normalizedOriginalPrompt)=>$8d8bfd1ce8e7d438$export$2def72d3ef808307(normalizedSentText, normalizedOriginalPrompt) !== null;
module.exports["extractContentFeatures"] = $8d8bfd1ce8e7d438$export$a148305df2eb5487;
module.exports["extractPlainTextFromAdf"] = $8d8bfd1ce8e7d438$export$c5df045f791f45da;
module.exports["getPromptCardSendType"] = $8d8bfd1ce8e7d438$export$2def72d3ef808307;

});

parcelRegister("2CHXX", function(module, exports) {

var $1P1Tu = parcelRequire("1P1Tu");


var $bPHr8 = parcelRequire("bPHr8");

const $50c358168d133df8$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $50c358168d133df8$var$initialState = {
    conversations: {
        EMPTY_CONVERSATION_ID: {
            id: $50c358168d133df8$export$a08ae3ac6db36809,
            messages: [],
            name: '',
            status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
            traces: [],
            timeCreated: new Date().toISOString()
        }
    },
    currentConversationId: $50c358168d133df8$export$a08ae3ac6db36809
};
let $50c358168d133df8$var$store;
const $50c358168d133df8$export$8572e013e9dc20c3 = (actions)=>{
    if (!$50c358168d133df8$var$store) $50c358168d133df8$var$store = (0, $1P1Tu.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $50c358168d133df8$var$initialState,
        actions: actions
    });
    return $50c358168d133df8$var$store;
};
module.exports["EMPTY_CONVERSATION_ID"] = $50c358168d133df8$export$a08ae3ac6db36809;
module.exports["createChatStore"] = $50c358168d133df8$export$8572e013e9dc20c3;

});

parcelRegister("bPHr8", function(module, exports) {
var $6ad1677b7b0380c5$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["initConversationChannelsData"] = "initConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    return StoreActionLoggableName;
}({});
const $6ad1677b7b0380c5$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $6ad1677b7b0380c5$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $6ad1677b7b0380c5$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $6ad1677b7b0380c5$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $6ad1677b7b0380c5$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $6ad1677b7b0380c5$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $6ad1677b7b0380c5$export$f2b8d80523e7041 = (message)=>$6ad1677b7b0380c5$export$75e97486ff2b4c62(message) || $6ad1677b7b0380c5$export$d99f52ae2a325014(message);
const $6ad1677b7b0380c5$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $6ad1677b7b0380c5$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $6ad1677b7b0380c5$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $6ad1677b7b0380c5$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $6ad1677b7b0380c5$export$908578fde1b22b55 = (message)=>$6ad1677b7b0380c5$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $6ad1677b7b0380c5$export$3db8a80b25c44828 = (message)=>$6ad1677b7b0380c5$export$20f0f8aded5b11e5(message) || $6ad1677b7b0380c5$export$908578fde1b22b55(message);
const $6ad1677b7b0380c5$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';
module.exports["StoreActionLoggableName"] = $6ad1677b7b0380c5$export$69799355b7de2229;
module.exports["isAnswerNowAvailable"] = $6ad1677b7b0380c5$export$8ec4190061b584d5;
module.exports["AnswerNowStatusType"] = $6ad1677b7b0380c5$export$fe950e85847f6d5d;
module.exports["CHAT_STORE_STATUS"] = $6ad1677b7b0380c5$export$817d6b1b984afeb7;
module.exports["isStoreHuman"] = $6ad1677b7b0380c5$export$75e97486ff2b4c62;
module.exports["isStoreAssistant"] = $6ad1677b7b0380c5$export$d99f52ae2a325014;
module.exports["isStoreError"] = $6ad1677b7b0380c5$export$9e2d714e96946d26;
module.exports["isStoreMessage"] = $6ad1677b7b0380c5$export$f2b8d80523e7041;
module.exports["isStoreFollowUp"] = $6ad1677b7b0380c5$export$7c65a4fb7b6131a1;
module.exports["getActionInvocationStatus"] = $6ad1677b7b0380c5$export$3070678f252266e3;

});

parcelRegister("jEzab", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $9823ae60ddf75b10$var$store = (0, $1P1Tu.createStore)({
    name: 'chatUseMessages',
    initialState: {},
    actions: {
        setMessages: (conversationId, messages)=>({ setState: setState })=>{
                setState({
                    [conversationId]: messages
                });
            },
        getMessages: (conversationId)=>({ getState: getState })=>{
                return getState()[conversationId] ?? [];
            }
    }
});
const $9823ae60ddf75b10$export$d5c60118ea64ef24 = (0, $9zUhf.createHook)($9823ae60ddf75b10$var$store, {
    selector: (state, { conversationId: conversationId })=>state[conversationId] ?? []
});
const $9823ae60ddf75b10$export$fcbbecdca7d55350 = (0, $9zUhf.createActionsHook)($9823ae60ddf75b10$var$store);
module.exports["useChatMessages"] = $9823ae60ddf75b10$export$d5c60118ea64ef24;
module.exports["useChatMessagesActions"] = $9823ae60ddf75b10$export$fcbbecdca7d55350;

});

parcelRegister("5MDfE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $cgtv4 = parcelRequire("cgtv4");

var $92b5895e6b5aadfd$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    conversationForbiddenTitle: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.title",
        defaultMessage: "This conversation is not available"
    },
    conversationForbiddenDescription: {
        id: "ai-mate.conversation-assistant.flag.conversation-forbidden.description",
        defaultMessage: "The conversation you tried to open may belong to another user or you may not have permission to view it."
    }
});


var $2a2a91121a59b721$export$33c7ec07de4be904 = /*#__PURE__*/ function(StoreErrorFlagId) {
    StoreErrorFlagId["CONVERSATION_FORBIDDEN"] = "conversationForbidden";
    return StoreErrorFlagId;
}({});
const $2a2a91121a59b721$export$4610738c067a7645 = ()=>{
    const { showFlag: showFlagFromFlags } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const showFlag = (0, $42omo.useCallback)((flagId)=>{
        switch(flagId){
            case "conversationForbidden":
                showFlagFromFlags({
                    id: 'conversation-assistant.conversation-forbidden',
                    title: formatMessage((0, $92b5895e6b5aadfd$export$2e2bcd8739ae039).conversationForbiddenTitle),
                    description: formatMessage((0, $92b5895e6b5aadfd$export$2e2bcd8739ae039).conversationForbiddenDescription),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        color: "var(--ds-icon-danger, #C9372C)",
                        label: ""
                    }),
                    isAutoDismiss: true
                });
                break;
        }
    }, [
        showFlagFromFlags,
        formatMessage
    ]);
    return showFlag;
};
module.exports["StoreErrorFlagId"] = $2a2a91121a59b721$export$33c7ec07de4be904;
module.exports["useShowStoreErrorFlag"] = $2a2a91121a59b721$export$4610738c067a7645;

});

parcelRegister("ajfvU", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $6FQwA = parcelRequire("6FQwA");


var $4pEXC = parcelRequire("4pEXC");


var $16lEl = parcelRequire("16lEl");


var $1yaYZ = parcelRequire("1yaYZ");


var $8IKbl = parcelRequire("8IKbl");


var $5MO1q = parcelRequire("5MO1q");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $99vXA = parcelRequire("99vXA");


var $2CHXX = parcelRequire("2CHXX");


var $bPHr8 = parcelRequire("bPHr8");


var $cBi7Q = parcelRequire("cBi7Q");


var $5MDfE = parcelRequire("5MDfE");


var $1K4cm = parcelRequire("1K4cm");

const $a37fef51f047b95d$export$bac56f3fc527f04b = (min, max)=>{
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
};



var $1cjt9 = parcelRequire("1cjt9");

const $e81fd5fde2bdb998$export$c9b02612b90eeb6c = (agentId)=>{
    if (!agentId) return false;
    return agentId !== (0, $1cjt9.DEFAULT_AGENT).id && agentId !== 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
};





const $9963cc910aac4af3$export$1afac255ab1e880e = ()=>{
    const lastMessageSentAt = localStorage.getItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT));
    if (!lastMessageSentAt) return null;
    const timestamp = parseInt(lastMessageSentAt);
    if (isNaN(timestamp)) return null;
    return timestamp;
};
const $9963cc910aac4af3$export$589976df4d188aac = (timestamp)=>{
    if (timestamp === null) {
        localStorage.removeItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT));
        return;
    }
    localStorage.setItem((0, $cBi7Q.LS_LAST_MESSAGE_SENT_AT), timestamp.toString());
};



var $iEWar = parcelRequire("iEWar");







const $90c63f46323387a6$export$60a662127f30e1e1 = (remoteConversation, localConversation)=>{
    return {
        id: remoteConversation.id,
        // Prioritize API data if present, otherwise use local or generate new
        name: remoteConversation.name ?? localConversation?.name ?? (0, $99vXA.generateConversationName)(),
        timeCreated: remoteConversation.time_created ?? localConversation?.timeCreated,
        lastMessage: remoteConversation.last_message ?? localConversation?.lastMessage ?? undefined,
        lastMessageType: remoteConversation.last_message_type ?? localConversation?.lastMessageType ?? [],
        lastMessageTimestamp: remoteConversation.last_message_timestamp ?? localConversation?.lastMessageTimestamp,
        lastAgentMessageStatus: remoteConversation.last_agent_message_status ?? localConversation?.lastAgentMessageStatus,
        read_status: remoteConversation.read_status ?? localConversation?.read_status,
        // Use local state data if it exists (messages, status are maintained locally)
        messages: localConversation?.messages ?? [],
        status: localConversation?.status ?? (0, $bPHr8.CHAT_STORE_STATUS).idle,
        traces: localConversation?.traces ?? [],
        ...localConversation?.sourceAgentId ? {
            sourceAgentId: localConversation.sourceAgentId
        } : {},
        ...localConversation?.sourceId ? {
            sourceId: localConversation.sourceId
        } : {},
        // Preserve runtime abort controller so Stop button works after channels rehydration (e.g. refocus)
        ...localConversation?.storeAbortController != null ? {
            storeAbortController: localConversation.storeAbortController
        } : {},
        agent: remoteConversation.agent
    };
};















var $fFa3V = parcelRequire("fFa3V");

/**
 * Abort-aware sleep that resolves after `ms` or rejects early if the signal is aborted.
 * Falls back to a regular setTimeout when no signal is provided.
 */ const $92b0a6aa5f3cefb4$var$abortableSleep = (ms, signal)=>new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        let cleanup = ()=>{};
        const timer = setTimeout(()=>{
            cleanup();
            resolve();
        }, ms);
        if (signal) {
            const onAbort = ()=>{
                clearTimeout(timer);
                cleanup();
                reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            };
            cleanup = (0, $fFa3V.bind)(signal, {
                type: 'abort',
                listener: onAbort,
                options: {
                    once: true
                }
            });
        }
    });
/**
 * Resolves when the browser reports it is online.
 * Returns immediately if already online, otherwise waits for the 'online' event.
 * Rejects if the signal is aborted while waiting.
 * @returns true if it had to wait for the 'online' event, false if already online.
 * Useful to distinguish between "was offline and recovered" vs "was already online".
 */ const $92b0a6aa5f3cefb4$var$waitForOnline = (signal)=>{
    if (typeof navigator === 'undefined' || navigator.onLine) return Promise.resolve(false);
    return new Promise((resolve, reject)=>{
        if (signal?.aborted) {
            reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
            return;
        }
        const onOnline = ()=>{
            cleanup();
            resolve(true);
        };
        const onAbort = ()=>{
            cleanup();
            reject(signal?.reason ?? new DOMException('Aborted', 'AbortError'));
        };
        const unbindOnline = (0, $fFa3V.bind)(window, {
            type: 'online',
            listener: onOnline,
            options: {
                once: true
            }
        });
        const unbindAbort = signal ? (0, $fFa3V.bind)(signal, {
            type: 'abort',
            listener: onAbort,
            options: {
                once: true
            }
        }) : ()=>{};
        const cleanup = ()=>{
            unbindOnline();
            unbindAbort();
        };
    });
};
const $92b0a6aa5f3cefb4$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, jitter: jitter = false, minDelay: minDelay = 500, pauseWhileOffline: pauseWhileOffline = false, postOnlineDelay: postOnlineDelay = 0, errorFilter: errorFilter, signal: signal, onRetry: onRetry })=>{
    // Mutable counter shared across recursive calls so that resetRetries() can
    // reset it from within fn() without needing to re-enter the call stack.
    const counter = {
        retryCount: retryCount,
        delay: delay
    };
    const resetRetries = ()=>{
        counter.retryCount = 0;
        counter.delay = delay;
    };
    const attempt = async ()=>{
        try {
            return await fn(resetRetries);
        } catch (error) {
            if (errorFilter && !errorFilter(error)) throw error;
            if (counter.retryCount >= maxRetries) throw error;
            onRetry?.(counter.retryCount + 1, error);
            if (pauseWhileOffline) {
                const recoveredFromOffline = await $92b0a6aa5f3cefb4$var$waitForOnline(signal);
                if (recoveredFromOffline && postOnlineDelay > 0) await $92b0a6aa5f3cefb4$var$abortableSleep(postOnlineDelay, signal);
            }
            const effectiveDelay = jitter ? Math.max(minDelay, Math.random() * counter.delay) : counter.delay;
            await $92b0a6aa5f3cefb4$var$abortableSleep(effectiveDelay, signal);
            counter.delay *= 2;
            counter.retryCount += 1;
            return attempt();
        }
    };
    return attempt();
};













var $dQl1W = parcelRequire("dQl1W");








var $deF0K = parcelRequire("deF0K");


var $3vCSA = parcelRequire("3vCSA");























var $dgaTK = parcelRequire("dgaTK");

const $35034bc3bb470a3a$export$3ba003c3111d103f = ()=>{
    const subExperienceCollect = (0, $dgaTK.collectAllWithSubExperienceAttributes)([
        (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER
    ]);
    return (events, experience)=>{
        // these experiences only run if the user chooses to open the preview while streaming is in progress. if they fail, bubble it up, but we dont rely on them for success/abort, because they may not even start
        (0, $dgaTK.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED, experience, events);
        (0, $dgaTK.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).PREVIEW_CONTENT, experience, events);
        subExperienceCollect(events, experience);
    };
};



var $4eSde = parcelRequire("4eSde");





var $e4JJO = parcelRequire("e4JJO");







var $eWKku = parcelRequire("eWKku");









var $ceMRi = parcelRequire("ceMRi");

const $33eac1626c414e6d$export$4a48e8ee48123078 = (config)=>{
    let previousMessageTimestamp = performance.now();
    let previousMessageTemplate;
    let previousMessageType;
    let maxDeadAirMs = 0;
    let maxPreviousMessageTemplate;
    let maxCurrentMessageTemplate;
    let maxPreviousMessageType;
    let maxCurrentMessageType;
    const shouldIgnoreMessage = (message)=>{
        return (0, $ljUdP.isConversationChannelDataMessage)(message) || (0, $ljUdP.isStreamHeartbeat)(message) || (0, $ljUdP.isStreamDynamicLayoutSubAgent)(message) || (0, $ljUdP.isStreamAnswerGenerationType)(message);
    };
    const shouldCountMessage = (message)=>{
        return (0, $ljUdP.isStreamResearchPayload)(message) || (0, $ljUdP.isStreamResearchPlan)(message) || (0, $ljUdP.isStreamTrace)(message) || (0, $ljUdP.isStreamAnswerPart)(message) || (0, $ljUdP.isStreamReasoningPart)(message) || (0, $ljUdP.isStreamActionPart)(message) || (0, $ljUdP.isStreamResponse)(message) || (0, $ljUdP.isFollowUpMessage)(message) || (0, $ljUdP.isStreamActionClassification)(message) || (0, $ljUdP.isStreamActionPrepare)(message) || (0, $ljUdP.isStreamActionComplete)(message) || (0, $ljUdP.isStreamActionError)(message) || (0, $ljUdP.isStreamError)(message);
    };
    const getMessageTemplate = (message)=>{
        return 'message' in message && message.message?.message_template;
    };
    const commonMetadata = {
        messageId: config.messageId,
        conversationId: config.conversationId,
        traceId: config.traceId,
        productKey: config.productKey,
        isExplicitDeepResearchEnabled: config.deepResearchEnabled,
        isExplicitThinkDeeperEnabled: config.thinkDeeperEnabled,
        isExplicitFastModeEnabled: config.fastModeEnabled,
        isWebSearchEnabled: config.webSearchEnabled,
        isAIFC: config.isAIFC,
        isExplicitThinkFasterEnabled: false,
        isImplicitThinkDeeper: false,
        hasSwitchedToFastThinking: false
    };
    const trackDeadAir = (deadAirMs, previousTemplate, currentTemplate, previousType, currentType)=>{
        const intervalMetric = (0, $1K4cm.deadAirMetrics).createDeadAirIntervalMetrics();
        const now = performance.now();
        intervalMetric.start({
            startTime: now - deadAirMs
        });
        intervalMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                previousMessageTemplate: previousTemplate ?? '',
                messageTemplate: currentTemplate ?? '',
                previousMessageType: previousType ?? '',
                messageType: currentType ?? ''
            }
        });
        if (deadAirMs > maxDeadAirMs) {
            maxDeadAirMs = deadAirMs;
            maxPreviousMessageTemplate = previousTemplate;
            maxCurrentMessageTemplate = currentTemplate;
            maxPreviousMessageType = previousType;
            maxCurrentMessageType = currentType;
        }
    };
    const update = (streamMessage)=>{
        if (shouldIgnoreMessage(streamMessage)) return;
        if (!shouldCountMessage(streamMessage)) {
            config.sendAnalyticsEvent({
                eventType: 'operational',
                action: 'unrecognized',
                actionSubject: 'deadAirTrackerMessage',
                attributes: {
                    messageType: streamMessage.type ?? 'unknown',
                    messageTemplate: getMessageTemplate(streamMessage) ?? 'unknown',
                    conversationId: config.conversationId,
                    traceId: config.traceId
                }
            });
            return;
        }
        const currentTimestamp = performance.now();
        const currentTemplate = getMessageTemplate(streamMessage);
        const currentMessageType = streamMessage.type;
        // Skip consecutive streaming messages (continuous token/content generation)
        // ANSWER_PART: Standard LLM response tokens
        // REASONING_PART: Think deeper extended reasoning phases (streamed thinking)
        // ACTION_PART: AIFC content generation chunks (whiteboards, documents, etc.)
        const isConsecutiveAnswerPart = previousMessageType === 'ANSWER_PART' && currentMessageType === 'ANSWER_PART';
        const isConsecutiveReasoningPart = previousMessageType === 'REASONING_PART' && currentMessageType === 'REASONING_PART';
        const isConsecutiveActionPart = previousMessageType === 'ACTION_PART' && currentMessageType === 'ACTION_PART';
        if (isConsecutiveAnswerPart || isConsecutiveReasoningPart || isConsecutiveActionPart) {
            previousMessageTimestamp = currentTimestamp;
            previousMessageTemplate = currentTemplate;
            previousMessageType = currentMessageType;
            return;
        }
        const deadAirMs = currentTimestamp - previousMessageTimestamp;
        // Skip negligible intervals (noise)
        if (!(0, $ceMRi.shouldExcludeInterval)(deadAirMs)) trackDeadAir(deadAirMs, previousMessageTemplate, currentTemplate, previousMessageType, currentMessageType);
        previousMessageTimestamp = currentTimestamp;
        previousMessageTemplate = currentTemplate;
        previousMessageType = currentMessageType;
    };
    const emitMaxDeadAir = ()=>{
        if (maxDeadAirMs === 0) return;
        const maxDeadAirMetric = (0, $1K4cm.deadAirMetrics).createDeadAirMaxMetrics();
        const now = performance.now();
        maxDeadAirMetric.start({
            startTime: now - maxDeadAirMs
        });
        maxDeadAirMetric.stop({
            stopTime: now,
            customData: {
                ...commonMetadata,
                maxDeadAirMs: maxDeadAirMs,
                previousMessageTemplate: maxPreviousMessageTemplate ?? '',
                messageTemplate: maxCurrentMessageTemplate ?? '',
                previousMessageType: maxPreviousMessageType ?? '',
                messageType: maxCurrentMessageType ?? ''
            }
        });
    };
    const complete = ()=>{
        emitMaxDeadAir();
    };
    const cancel = ()=>{
        emitMaxDeadAir();
    };
    return {
        update: update,
        complete: complete,
        cancel: cancel
    };
};





const $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    let resolveAbort;
    const confirmAbort = ()=>{
        resolveAbort();
    };
    const abort = ()=>{
        abortController.abort();
        return new Promise((resolve)=>{
            resolveAbort = resolve;
        });
    };
    return {
        abortController: abortController,
        storeAbortController: {
            abort: abort
        },
        confirmAbort: confirmAbort
    };
};



var $cteoa = parcelRequire("cteoa");

const $54793c520b6b8872$export$9ac25e0768639c5d = (traces)=>{
    const messages = traces.map((trace)=>trace.messageContent);
    return traces.filter((trace, i)=>messages.lastIndexOf(trace.messageContent) === i);
};
const $54793c520b6b8872$var$getConversationTraces = (state, conversationId)=>state.conversations[conversationId]?.traces ?? [];
/**
 * Helper function to stop/end metrics, that can only be called once
 */ const $54793c520b6b8872$var$getMetricEndHelper = (metrics)=>{
    let called = false;
    return (result, customData)=>{
        if (!called) {
            if (result === 'stop') metrics.stop({
                customData: customData
            });
            else metrics.cancel();
            called = true;
        }
    };
};
const $54793c520b6b8872$export$d30a5acf6cceb893 = (getState, conversationId, updateCurrentConversation)=>{
    const currentTraces = $54793c520b6b8872$var$getConversationTraces(getState(), conversationId);
    if (currentTraces.length > 0) updateCurrentConversation({
        traces: []
    });
};
const $54793c520b6b8872$export$a0e3245ee56765fd = (messageActionKey)=>{
    // WARNING: Changing the logic here can affect AIFC MAU and other AI metrics.
    // Please consult with the Create with Rovo team before making any changes.
    if (!messageActionKey) return undefined;
    if ((0, $3vCSA.isConfluenceCreatableAction)({
        key: messageActionKey
    })) // TODO All creatable actions should be as AIFC MAU here,
    // but we are temporarily changing this to Confluence only due to HOT-122605
    return 'AIFC';
    else if ((0, $3vCSA.isConfluencePageUpdateAction)({
        key: messageActionKey
    })) return 'Editor AI';
    else if ((0, $3vCSA.isConfluenceWhiteboardUpdateAction)({
        key: messageActionKey
    })) return 'Whiteboard AI';
    else if ((0, $3vCSA.isConfluenceDatabaseUpdateAction)({
        key: messageActionKey
    })) return 'Database AI';
    return undefined;
};
const $54793c520b6b8872$export$1303843c2f44065a = ({ editorContext: editorContext, whiteboardContext: whiteboardContext, databaseContext: databaseContext, browserUrl: browserUrl })=>{
    // Priority 1: Use existing context objects for reliable detection
    if (editorContext) return editorContext.isViewMode ? 'confluence-page-view' : 'confluence-page-edit';
    if (whiteboardContext) return whiteboardContext.isViewMode ? 'whiteboard-view' : 'whiteboard-edit';
    if (databaseContext) return 'database';
    // Priority 2: Fall back to URL-based detection when no context is available
    const url = browserUrl ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (url.includes('/wiki/') && url.includes('/edit')) return 'confluence-page-edit';
    if (url.includes('/wiki/')) return 'confluence-page-view';
    if (url.includes('/whiteboard/')) return 'whiteboard';
    if (url.includes('/database/')) return 'database';
    return 'unknown';
};
const $54793c520b6b8872$var$getInitialTrackingAttributes = (agentId, instrumentationId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, template, forcedContentType)=>{
    return {
        pluginsInvoked: new Set(),
        skillsInvoked: [],
        executedStratusSkill: false,
        hasSources: false,
        messageId: '',
        humanMessageId: '',
        requestId: undefined,
        messageActions: [],
        invokedFrom: undefined,
        instrumentationId: instrumentationId,
        messageSentTimeStamp: new Date().toISOString(),
        citedProductList: {},
        sourceProducts: {},
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        webSearchEnabled: webSearchEnabled,
        interactionSource: messageSources?.interactionSource,
        followUpSource: messageSources?.followUpSource ?? 'none',
        isFirstPrompt: isFirstPrompt,
        promptFeatures: (0, $e4JJO.extractContentFeatures)(prompt),
        fileCount: files?.length ?? 0,
        appFilters: appFilters ?? [],
        appFilterCount: appFilters?.length ?? 0,
        template: template,
        deepResearchInvoked: false,
        forcedContentType: forcedContentType
    };
};
const $54793c520b6b8872$var$getOptimisticMessageTypes = (deepResearchEnabled, webSearchEnabled)=>{
    const messageType = [];
    if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) {
        if (deepResearchEnabled) messageType.push('DEEP_RESEARCH');
        if (webSearchEnabled) messageType.push('WEB_SEARCH');
    }
    return {
        messageType: messageType
    };
};
const $54793c520b6b8872$var$initLatencyMetrics = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, agentId: agentId })=>{
    const rovoCustomAgent = (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId);
    const sendMessageLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createSendMessageMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstAnswerPartLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToFirstAnswerPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToFirstActionPartLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToFirstActionPartMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const timeToActionCompletionLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createTimeToActionCompletionMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled,
        isRovoCustomAgent: rovoCustomAgent
    });
    const betweenChunksLatencyMetrics = (0, $1K4cm.messageLatencyMetrics).createBetweenChunksLatencyMetrics({
        deepResearchEnabled: deepResearchEnabled,
        thinkDeeperEnabled: thinkDeeperEnabled,
        fastModeEnabled: fastModeEnabled
    });
    sendMessageLatencyMetrics.start();
    timeToFirstAnswerPartLatencyMetrics.start();
    if ((0, $dh538.fg)('aifc_create_enabled')) {
        timeToFirstActionPartLatencyMetrics.start();
        timeToActionCompletionLatencyMetrics.start();
    }
    const stopInteractionMetricsTimeToFirstAnswerPart = $54793c520b6b8872$var$getMetricEndHelper(timeToFirstAnswerPartLatencyMetrics);
    const stopInteractionMetricsTimeToFirstActionPart = $54793c520b6b8872$var$getMetricEndHelper(timeToFirstActionPartLatencyMetrics);
    const stopInteractionMetricsTimeToActionCompletion = $54793c520b6b8872$var$getMetricEndHelper(timeToActionCompletionLatencyMetrics);
    const cancelStreamingMetrics = ()=>{
        stopInteractionMetricsTimeToFirstAnswerPart('cancel');
        stopInteractionMetricsTimeToFirstActionPart('cancel');
        stopInteractionMetricsTimeToActionCompletion('cancel');
    };
    return {
        sendMessageLatencyMetrics: sendMessageLatencyMetrics,
        timeToFirstAnswerPartLatencyMetrics: timeToFirstAnswerPartLatencyMetrics,
        timeToFirstActionPartLatencyMetrics: timeToFirstActionPartLatencyMetrics,
        timeToActionCompletionLatencyMetrics: timeToActionCompletionLatencyMetrics,
        betweenChunksLatencyMetrics: betweenChunksLatencyMetrics,
        stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
        stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
        stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
        cancelStreamingMetrics: cancelStreamingMetrics
    };
};
const $54793c520b6b8872$var$hydrateStoreWithNewMessage = (dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, agentId, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages)=>{
    const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
    const updateCurrentConversation = (data)=>{
        dispatch(setConversationData({
            conversationId: conversationId,
            data: data
        }));
    };
    updateCurrentConversation({
        status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
        storeAbortController: storeAbortController,
        lastMessageType: messageType,
        lastAgentMessageStatus: 'IN_PROGRESS'
    });
    dispatch(addHumanMessage({
        id: tmpHumanMessageId,
        content: prompt,
        conversationId: conversationId,
        fileUploads: files
    }));
    dispatch(addAssistantMessage({
        id: tmpAssistantMessageId,
        content: '',
        conversationId: conversationId,
        agentNamedId: agentId
    }));
    dispatch(clearFollowUpMessages({
        conversationId: conversationId
    }));
    return {
        abortController: abortController,
        storeAbortController: storeAbortController,
        confirmAbort: confirmAbort,
        updateCurrentConversation: updateCurrentConversation
    };
};
const $54793c520b6b8872$var$handleEditorContextAnalytics = ({ source: source, contentContext: contentContext, isFirstPrompt: isFirstPrompt, userPreference: userPreference, sendAnalyticsEvent: sendAnalyticsEvent, activeTargetId: activeTargetId, isStagingArea: stagingAreaFromStore })=>{
    // If AIFC is not enabled, we should not send analytics
    if (!(0, $dh538.fg)('aifc_create_enabled')) return;
    const inStagingArea = contentContext === 'staging-area';
    // Source values for Inline Rovo
    const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP';
    const shouldProvideContext = // Inline Rovo
    sourceEligible || // Within staging area & not the first prompt
    inStagingArea && !isFirstPrompt || // Not within staging area, default to user preference
    !inStagingArea && !!userPreference;
    // If there's no editor context when we should be providing it,
    // something went wrong so send analytics to track
    if (shouldProvideContext) sendAnalyticsEvent({
        eventType: 'operational',
        action: 'missing',
        actionSubject: 'editorContext',
        attributes: {
            contentContext: contentContext,
            source: source,
            userPreference: userPreference,
            isFirstPrompt: isFirstPrompt,
            activeTargetId: activeTargetId,
            isStagingArea: stagingAreaFromStore
        }
    });
};
const $54793c520b6b8872$var$populateSendMessageContext = async (chatContextStoreActions, isFirstPrompt, source, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, activeTargetId)=>{
    const editorContext = await chatContextStoreActions.getEditorContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    let currentTarget = chatContextStoreActions.getTarget(contentContextValue);
    // Check if the specific target can provide context when multiple contexts are enabled
    if ((0, $dh538.fg)('aifc_multiple_context')) currentTarget = chatContextStoreActions.getTarget(contentContextValue, activeTargetId);
    // If there's no editor context available and the current target CAN
    // provide context, send analytics to track this error state
    if (!editorContext && currentTarget?.canProvideContext) $54793c520b6b8872$var$handleEditorContextAnalytics({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        userPreference: !!addCurrentPageAsContextUserPreference,
        sendAnalyticsEvent: sendAnalyticsEvent,
        activeTargetId: !!activeTargetId,
        isStagingArea: chatContextStoreActions.getIsStagingArea()
    });
    const whiteboardContext = await chatContextStoreActions.getWhiteboardContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const databaseContext = await chatContextStoreActions.getDatabaseContext({
        isFirstPrompt: isFirstPrompt,
        source: source,
        contentContext: contentContextValue,
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        activeTargetId: activeTargetId
    });
    const browserContext = await chatContextStoreActions.getBrowserContext({
        addCurrentPageAsContextUserPreference: !!addCurrentPageAsContextUserPreference,
        enabled: (0, $c6GJD.default).getExperimentValue('rovo_extension_dom_improvement', 'rovo_extension_dom_context_improvement_enabled', false, {
            fireExperimentExposure: false
        })
    });
    const jiraContext = await (async ()=>{
        // Only fetch Jira context when in staging area and product is Jira
        // and not the first prompt (refinement messages)
        if (!isFirstPrompt && (contentContextValue === 'staging-area' || (0, $dh538.fg)('jira-aifc-enable-preview-card-in-chat-v2')) && productKey === 'jira' && (0, $dh538.fg)('jira_aifc_enabled')) return chatContextStoreActions.getJiraContext?.();
        return undefined;
    })();
    const additionalCreationContext = editorContext?.additionalContext;
    if (editorContext && editorContext.additionalContext) delete editorContext.additionalContext;
    const useGenericEditorSkill = editorContext?.useGenericEditorSkill;
    if (editorContext && 'useGenericEditorSkill' in editorContext && (0, $dh538.fg)('platform_editor_ai_aifc_patch_ga_blockers')) delete editorContext.useGenericEditorSkill;
    // Bookmark
    return {
        browserContext: browserContext,
        editorContext: editorContext,
        whiteboardContext: whiteboardContext,
        databaseContext: databaseContext,
        additionalContext: {
            spaceCreateContext: await chatContextStoreActions.getSpaceCreateContext({
                isFirstPrompt: isFirstPrompt,
                contentContext: contentContextValue
            }),
            creationContext: {
                ...creationContextParams ? creationContextParams : {},
                isStagingArea: contentContextValue === 'staging-area',
                productKey: productKey,
                source: source,
                isViewMode: !!(editorContext?.isViewMode || whiteboardContext?.isViewMode),
                useGenericEditorSkill: useGenericEditorSkill,
                additionalContext: additionalCreationContext,
                ...jiraContext && {
                    jiraContext: jiraContext
                }
            },
            userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        aiFeatureContext: chatContextStoreActions.getAIFeatureContext(),
        jiraWorkflowContext: chatContextStoreActions.getJiraWorkflowContext(),
        dashboardContext: chatContextStoreActions.getDashboardContext(),
        useCurrentBrowsingContext: chatContextStoreActions.useCurrentBrowsingContext(!!addCurrentPageAsContextUserPreference)
    };
};
const $54793c520b6b8872$var$handleSendMessageServiceCallFailure = (error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId)=>{
    // Convert deep research related errors to DeepResearchError when deep research is enabled
    let convertedError = error;
    if (deepResearchEnabled) convertedError = new (0, $iEWar.DeepResearchError)(error.message, {
        traceId: error.errorAttributes?.traceId,
        requestId: error.errorAttributes?.requestId
    });
    // Returns bad request error because agent is deactivated or user has no permission
    const isAgentDeactivated = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
    const isNoAgentPermission = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
    if (isAgentDeactivated || isNoAgentPermission) {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: error,
            attributes: {
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                webSearchEnabled: webSearchEnabled,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: messageSources?.interactionSource !== 'chatInput',
            userGenerated: messageSources?.interactionSource === 'chatInput',
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled
        });
        updateCurrentConversation({
            status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
            traces: [],
            errorCode: (0, $dh538.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        return;
    } else if (error instanceof Error && error.name === 'AbortError') {
        // Check if the abort was programmatic or not. `abortController.signal.aborted` is a readonly field that is only set to true when called programmatically
        // The browser can abort requests to free up resources & save power (esp. on background tabs). When it does this, it **does not** set `abortController.signal.aborted` to true
        const isProgrammaticAbort = abortController.signal.aborted;
        experienceTracker.abort({
            name: sendMessageExperienceNameCompiled,
            reason: 'Aborted',
            attributes: {
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                isProgrammaticAbort: isProgrammaticAbort
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: messageSources?.interactionSource !== 'chatInput',
            userGenerated: messageSources?.interactionSource === 'chatInput',
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext
        });
        trackAIMAUEvent({
            type: 'dismissed',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled
        });
        updateCurrentConversation((0, $cteoa.clearStatus)({
            lastAgentMessageStatus: 'FAILED'
        }));
        if ((0, $dh538.fg)('rovo_chat_think_deeper_mode_trace_changes')) {
            $54793c520b6b8872$export$d30a5acf6cceb893(getState, conversationId, updateCurrentConversation);
            clearMessageResearch({
                messageId: tmpAssistantMessageId
            });
        }
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ABORTED);
        confirmAbort();
        return;
    } else {
        experienceTracker.fail({
            name: sendMessageExperienceNameCompiled,
            error: error,
            attributes: {
                deepResearchEnabled: deepResearchEnabled,
                fastModeEnabled: fastModeEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                webSearchEnabled: webSearchEnabled,
                isStreamAction: streamActionInfo.isAction,
                actionKey: streamActionInfo.actionKey,
                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
            }
        });
        if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
        // Delaying the initiated event firing allows us to create the pairing appropriately,
        // for any initiated events leading up to an error or dismiss state with a
        // hashed ID
        trackAIMAUEvent({
            type: 'initiated',
            subjectId: messageSources?.interactionSource,
            proactive: messageSources?.interactionSource !== 'chatInput',
            userGenerated: messageSources?.interactionSource === 'chatInput',
            timestamp: trackingAttributes.messageSentTimeStamp,
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled,
            pageContext: trackingAttributes.pageContext
        });
        trackAIMAUEvent({
            type: 'error',
            userGenerated: true,
            messageId: trackingAttributes.requestId,
            timestamp: new Date().toISOString(),
            singleInstrumentationID: trackingAttributes.instrumentationId,
            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
            fastModeEnabled: trackingAttributes.fastModeEnabled,
            webSearchEnabled: trackingAttributes.webSearchEnabled
        });
        sendMessageLatencyMetrics.cancel();
        cancelStreamingMetrics();
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        throw convertedError;
    }
};
const $54793c520b6b8872$var$processStream = async ({ prompt: prompt, generator: generator, productKey: productKey, answerIndex: answerIndex, tmpHumanMessageId: tmpHumanMessageId, tmpAssistantMessageId: tmpAssistantMessageId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled, traceId: traceId, updateCurrentConversation: updateCurrentConversation, trackingAttributes: trackingAttributes, conversationId: conversationId, getState: getState, promptStreamHook: promptStreamHook, experienceTracker: experienceTracker, setMessages: setMessages, getMessages: getMessages, processStreamResearch: processStreamResearch, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced, updateResearchMessageId: updateResearchMessageId, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, broadcastStreamLifecycle: broadcastStreamLifecycle, sendMessageLatencyMetrics: sendMessageLatencyMetrics, betweenChunksLatencyMetrics: betweenChunksLatencyMetrics, cancelStreamingMetrics: cancelStreamingMetrics, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, streamActionInfo: streamActionInfo, trackAIMAUEvent: trackAIMAUEvent, messageSources: messageSources, hasLoggedInitiatedEvent: hasLoggedInitiatedEvent, clearMessageResearch: clearMessageResearch, viewDeadAirBroker: viewDeadAirBroker })=>{
    updateCurrentConversation({
        ...!(0, $dh538.fg)('rovo_display_thinking_indicator') && {
            status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
        },
        // TODO: This is not localized in the BE yet
        // remove this default text in chat refresh, the BE will remove their version of it as well
        traces: deepResearchEnabled || (0, $dh538.fg)('rovo_chat_think_deeper_mode_trace_changes') ? [] : [
            {
                messageContent: 'Analyzing: Reviewing your question.'
            }
        ]
    });
    let hasReceivedFinalResponse = false;
    let isLuminaAnswerGenerationType = false;
    let agentMessageId;
    let lastEventId;
    let isReconnectSupported = false;
    const processStreamMarkdown = (0, $cteoa.createStreamMarkdownProcessor)();
    let latestStreamMessage;
    const streamStats = $54793c520b6b8872$var$getStreamStats();
    // Between-chunks inactivity watchdog (logs once per stall, re-arms on chunks)
    const inactivity = $54793c520b6b8872$export$23f1f8f522f4bdd({
        baseMs: 90000,
        sendAnalyticsEvent: (event)=>{
            sendAnalyticsEvent({
                ...event,
                attributes: {
                    ...event.attributes,
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent
                }
            });
        }
    });
    // Dead air tracking - monitors gaps between meaningful stream messages
    const deadAirTracker = (0, $dh538.fg)('rovo_chat_track_dead_air') ? (0, $33eac1626c414e6d$export$4a48e8ee48123078)({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        deepResearchEnabled: deepResearchEnabled ?? false,
        thinkDeeperEnabled: thinkDeeperEnabled ?? false,
        fastModeEnabled: fastModeEnabled ?? false,
        webSearchEnabled: webSearchEnabled ?? false,
        isAIFC: streamActionInfo.isAction,
        sendAnalyticsEvent: sendAnalyticsEvent
    }) : undefined;
    viewDeadAirBroker?.start({
        messageId: tmpAssistantMessageId,
        conversationId: conversationId,
        traceId: traceId ?? '',
        productKey: productKey ?? '',
        reasoningMode: deepResearchEnabled ? 'deep-research' : thinkDeeperEnabled ? 'think-deeper' : fastModeEnabled ? 'fast' : 'auto',
        isAIFCEnabled: streamActionInfo.isAction,
        isWebSearchEnabled: webSearchEnabled ?? false
    });
    const startStreamingProcessingAt = performance.now();
    // Arm the inactivity watchdog
    inactivity?.arm();
    // Start the between chunks latency metrics
    betweenChunksLatencyMetrics.start({
        startTime: startStreamingProcessingAt
    });
    /*****************************
   *
   * Stream processing START
   *
   *****************************/ try {
        for await (const streamObj of generator){
            // Track the last event ID for potential reconnection
            if ((0, $ljUdP.isSSEMessage)(streamObj) && streamObj.id) lastEventId = streamObj.id;
            const streamMessage = (0, $ljUdP.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
            latestStreamMessage = streamMessage;
            if ((0, $dh538.fg)('rovo_chat_track_dead_air')) deadAirTracker?.update(streamMessage);
            streamStats.update(streamMessage);
            // any chunk = proof of life
            inactivity?.onChunk();
            // Note: We do NOT skip stream messages during SWITCHING.
            // Stream processing continues normally until FAST_MODE_ENABLED is received,
            // at which point research steps are cleared and status is set to SWITCHED.
            // Usually the first stream part
            if ((0, $ljUdP.isConversationChannelDataMessage)(streamMessage)) {
                agentMessageId = streamMessage.assistant_message_id;
                updateCurrentConversation({
                    name: streamMessage.name,
                    lastMessageTimestamp: streamMessage.last_message_timestamp ?? new Date().toISOString(),
                    timeCreated: streamMessage.time_created
                });
                trackingAttributes.instrumentationId = agentMessageId;
                trackingAttributes.messageId = agentMessageId;
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: messageSources?.interactionSource !== 'chatInput',
                    userGenerated: messageSources?.interactionSource === 'chatInput',
                    timestamp: streamMessage.last_message_timestamp,
                    singleInstrumentationID: agentMessageId,
                    deepResearchEnabled: deepResearchEnabled ?? false,
                    thinkDeeperEnabled: thinkDeeperEnabled ?? false,
                    fastModeEnabled: fastModeEnabled ?? false,
                    webSearchEnabled: webSearchEnabled ?? false,
                    pageContext: trackingAttributes.pageContext
                });
                hasLoggedInitiatedEvent = true;
            } else if ((0, $dh538.fg)('rovo_display_thinking_indicator')) {
                const conversation = getState().conversations[getState().currentConversationId];
                if (conversation) {
                    if (conversation.status !== (0, $bPHr8.CHAT_STORE_STATUS).typingResponse) updateCurrentConversation({
                        status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
                    });
                }
            }
            if ((0, $ljUdP.isStreamReconnectSupportPart)(streamMessage)) isReconnectSupported = true;
            if ((0, $ljUdP.isStreamAnswerGenerationType)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) {
                isLuminaAnswerGenerationType = streamMessage.message.answer_generation_type === 'LUMINA';
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerGenerationType)(getMessages(conversationId), tmpAssistantMessageId, streamMessage.message.answer_generation_type));
            }
            if ((0, $ljUdP.isStreamResearchStart)(streamMessage) && // The same message_template is used for thinking deeper + deep research
            // so we need to check the specific trace message to differentiate them
            streamMessage.message.content === 'Starting deep research execution') trackingAttributes.deepResearchInvoked = true;
            if ((0, $ljUdP.isStreamResearchPayload)(streamMessage) || (0, $ljUdP.isStreamResponse)(streamMessage) || (0, $ljUdP.isStreamAnswerPart)(streamMessage) || (0, $ljUdP.isStreamReasoningPart)(streamMessage) || (0, $ljUdP.isStreamSkill)(streamMessage) || (0, $ljUdP.isStreamThinkDeeperTriggered)(streamMessage) && (0, $dh538.fg)('rovo_chat_think_deeper_mode_trace_changes')) processStreamResearch({
                messageId: tmpAssistantMessageId,
                streamMessage: streamMessage,
                isDeepResearch: deepResearchEnabled ?? false
            });
            // This is the first moment we have the network request id for E2E event tracking
            // Store requestId on human message for E2E event tracking
            if (!trackingAttributes.requestId && 'metadata' in streamMessage) trackingAttributes.requestId = streamMessage.metadata?.request_id;
            // Handle MEMORY_UPDATE trace messages - create a persistent StoreMemoryUpdate message
            if ((0, $ljUdP.isStreamMemoryUpdate)(streamMessage) && (0, $c6GJD.default).getExperimentValue('memory_management_ux', 'isEnabled', false)) {
                const memoryUpdateMessage = {
                    type: 'MEMORY_UPDATE',
                    content: streamMessage.message.content
                };
                setMessages(conversationId, (0, $cteoa.addMemorytoLatestAssistantMessage)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    memory: memoryUpdateMessage,
                    useIndex: answerIndex
                }));
            }
            // Usually the second stream part, before anything else occurs
            if ((0, $ljUdP.isStreamTrace)(streamMessage)) {
                if (!deepResearchEnabled) // we do not want traces that are not marked for deep research to be accumulated when starting research,
                // the ones that are marked are processed above in processStreamResearch
                updateCurrentConversation({
                    traces: $54793c520b6b8872$export$9ac25e0768639c5d([
                        ...$54793c520b6b8872$var$getConversationTraces(getState(), conversationId),
                        (0, $cteoa.getTraceFromStreamMessage)(streamMessage)
                    ])
                });
                promptStreamHook?.onTraceMessage?.(streamMessage, tmpAssistantMessageId);
                setMessages(conversationId, (0, $cteoa.addRequestIdToLatestHumanMessage)(getMessages(conversationId), trackingAttributes.requestId));
            }
            // Handle Answer Now fast mode traces for extended thinking
            // Answer Now feature - handle fast mode traces
            if ((0, $dh538.fg)('rovo_chat_enable_ans_now')) {
                if ((0, $ljUdP.isStreamFastModeResponseAvailable)(streamMessage) && agentMessageId) // Fast mode response is available - show Answer Now button
                // Store both IDs in AVAILABLE status:
                // - tmpMessageId: for store operations (finding/updating the message)
                // - remoteMessageId: for the Answer Now API call
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).AVAILABLE,
                    tmpMessageId: tmpAssistantMessageId,
                    remoteMessageId: agentMessageId
                }));
                if ((0, $ljUdP.isStreamFastModeEnabled)(streamMessage)) {
                    // Fast mode has been enabled:
                    // 1. Set status to SWITCHED (hides button)
                    // 2. Clear research steps for this message
                    setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpAssistantMessageId, {
                        type: (0, $bPHr8.AnswerNowStatusType).SWITCHED
                    }));
                    // Clear research steps when switching to fast mode
                    clearMessageResearch({
                        messageId: tmpAssistantMessageId
                    });
                }
            }
            if ((0, $ljUdP.isStreamResearchPlan)(streamMessage)) {
                const messages = (0, $cteoa.clearStoreAssistantMessageContent)(getMessages(conversationId), tmpAssistantMessageId);
                setMessages(conversationId, messages);
                processStreamResearch({
                    messageId: tmpAssistantMessageId,
                    streamMessage: streamMessage,
                    isDeepResearch: deepResearchEnabled ?? false
                });
            }
            let commonExperienceAttributes = {};
            if ((0, $ljUdP.isStreamActionClassification)(streamMessage)) {
                const actionKey = streamMessage.message.action_key;
                const actualContentType = (0, $deF0K.getAIFCContentType)({
                    key: actionKey
                });
                commonExperienceAttributes = {
                    actionKey: actionKey,
                    contentType: actualContentType,
                    isStagingArea: chatContextStoreActions.getIsStagingArea(),
                    product: productKey
                };
                if (trackingAttributes.forcedContentType) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'compared',
                    actionSubject: 'forcedContentType',
                    actionSubjectId: 'contentTypeMatch',
                    attributes: {
                        forcedContentType: trackingAttributes.forcedContentType,
                        actualContentType: actualContentType,
                        matched: trackingAttributes.forcedContentType === actualContentType,
                        actionKey: actionKey
                    }
                });
                const isUpdateAction = (0, $deF0K.isUpdatableAction)({
                    key: actionKey
                });
                if (isUpdateAction) {
                    experienceTracker.start({
                        name: (0, $16lEl.ExperienceName).AIFC_UPDATE_CONTENT,
                        id: conversationId,
                        collect: (0, $4eSde.createAifcExperienceCollect)(),
                        attributes: commonExperienceAttributes
                    });
                    // Start AIFC_ALL_DATA_HANDLED - this replaces all explicit AIFC_UPDATE_CONTENT succeed/fail/abort calls
                    // Product AIFC integration is responsible for succeeding this experience.
                    experienceTracker.start({
                        name: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
                        id: conversationId,
                        attributes: {
                            ...commonExperienceAttributes,
                            parentExperienceId: (0, $16lEl.ExperienceName).AIFC_UPDATE_CONTENT
                        }
                    });
                    experienceTracker.start({
                        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                        id: conversationId,
                        attributes: {
                            ...commonExperienceAttributes,
                            parentExperienceId: (0, $16lEl.ExperienceName).AIFC_UPDATE_CONTENT
                        }
                    });
                    // Start AIFC_INITIAL_DATA_RECEIVED with timeout to detect if content fails to start streaming within 90s.
                    // If timeout occurs, this experience will fail and AIFC_UPDATE_CONTENT will fail (due to collect function).
                    // Product AIFC integration is responsible for succeeding this experience.
                    // Note: Deep research is excluded as it could take longer so timing out is less sensible.
                    if (!deepResearchEnabled && (0, $dh538.fg)('aifc-experience-timeout')) experienceTracker.start({
                        name: (0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
                        id: `${conversationId}-initial`,
                        timeout: 90000,
                        // 90 second timeout
                        attributes: {
                            ...commonExperienceAttributes,
                            parentExperienceId: (0, $16lEl.ExperienceName).AIFC_UPDATE_CONTENT
                        }
                    });
                }
                const isCreateAction = (0, $deF0K.isCreatableAction)({
                    key: actionKey
                });
                if (isCreateAction) {
                    const isStagingArea = chatContextStoreActions.getIsStagingArea();
                    const humanMessageCount = getMessages(conversationId).filter((message)=>message.type === 'HUMAN').length;
                    // initial prompt from staging area has its own AIFC_GENERATE_CONTENT experience - dont start this one
                    if (!isStagingArea || humanMessageCount > 1) {
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
                            id: conversationId,
                            collect: (0, $35034bc3bb470a3a$export$3ba003c3111d103f)(),
                            attributes: commonExperienceAttributes
                        });
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                            id: conversationId,
                            attributes: {
                                ...commonExperienceAttributes,
                                parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                            }
                        });
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).PREVIEW_CARD_RENDER,
                            id: conversationId,
                            timeout: deepResearchEnabled ? undefined : 60000,
                            // 60 second timeout
                            attributes: {
                                ...commonExperienceAttributes,
                                parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                            }
                        });
                        // Product AIFC integration is responsible for succeeding this experience.
                        experienceTracker.start({
                            name: (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED,
                            id: conversationId,
                            attributes: {
                                ...commonExperienceAttributes,
                                parentExperienceId: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
                            }
                        });
                    } else // update AIFC_GENERATE_CONTENT now that intent detection is complete. This experience starts as the user sends the message on the initial prompt screen
                    experienceTracker.updateAttributes({
                        name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                        attributes: commonExperienceAttributes
                    });
                }
            }
            if (((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) && (0, $dh538.fg)('aifc_create_enabled')) {
                // Update action tracking info
                if (!streamActionInfo.isAction) {
                    streamActionInfo.isAction = true;
                    streamActionInfo.actionKey = streamMessage.message.key;
                }
                // track attribute for action prepare
                if ((0, $ljUdP.isStreamActionPart)(streamMessage)) stopInteractionMetricsTimeToFirstActionPart('stop', {
                    actionType: 'action-part',
                    conversationId: conversationId,
                    actionPartKey: streamMessage.message.key
                });
                if ((0, $dh538.fg)('aifc_set_accumulated_data_on_message')) {
                    const actionKey = streamMessage.message.key;
                    const lastAction = (0, $cteoa.findLastAssistantAction)(getMessages(conversationId), (action)=>action.key === actionKey);
                    if (lastAction && (0, $3vCSA.isAccumulatedAction)(actionKey)) {
                        const isAccumulatedActionType = (0, $3vCSA.getAccumulatedActionTypeGuard)(actionKey);
                        if (isAccumulatedActionType(streamMessage.message.data)) {
                            const primaryAccumulatedData = (0, $3vCSA.getPrimaryAccumulatedValue)(lastAction);
                            if (primaryAccumulatedData?.value) streamMessage.message.data.previousAccumulatedData = primaryAccumulatedData.value;
                        }
                    }
                }
                processMessageStreamAction?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, (0, $dh538.fg)('aifc_header_image_pseudo_title_enabled') ? prompt : undefined, {
                    singleInstrumentationId: trackingAttributes.instrumentationId
                });
                promptStreamHook?.onActionPart?.(streamMessage, tmpAssistantMessageId, conversationId);
                setMessages(conversationId, (0, $cteoa.addActionPart)({
                    chat: getMessages(conversationId),
                    messageId: tmpAssistantMessageId,
                    actionPart: streamMessage,
                    ...(0, $dh538.fg)('aifc_set_accumulated_data_on_message') ? {
                        actionUpdaterOverride: (0, $3vCSA.customActionUpdater)
                    } : {}
                }));
            }
            if ((0, $ljUdP.isStreamActionComplete)(streamMessage) && (0, $dh538.fg)('aifc_create_enabled')) {
                processMessageStreamComplete?.(tmpAssistantMessageId, streamMessage, traceId, trackingAttributes.requestId, {
                    singleInstrumentationId: trackingAttributes.instrumentationId
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE
                });
            }
            if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                stopInteractionMetricsTimeToFirstAnswerPart('stop', {
                    answerType: 'stream-answer-part',
                    conversationId: conversationId
                });
                // Clear Answer Now status when ANSWER_PART is received
                // This handles the case where the stream starts answering without user clicking Answer Now
                const currentMessages = getMessages(conversationId);
                // Clear Answer Now status when ANSWER_PART is received (feature gated)
                if ((0, $dh538.fg)('rovo_chat_enable_ans_now')) {
                    const assistantMessage = currentMessages.find((msg)=>msg.type === 'ASSISTANT' && msg.content?.message?.message?.id === tmpAssistantMessageId);
                    if (assistantMessage && 'answerNowStatus' in assistantMessage && assistantMessage.answerNowStatus) setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpAssistantMessageId, undefined));
                }
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                $54793c520b6b8872$export$d30a5acf6cceb893(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let processedStreamResult = null;
                if (!isLuminaAnswerGenerationType && (0, $dh538.fg)('rovo_enable_component_streaming')) {
                    processedStreamResult = processStreamMarkdown(processedStreamMessage);
                    processedStreamMessage = processedStreamResult.processedStreamMessage;
                }
                if (!isLuminaAnswerGenerationType) promptStreamHook?.onAnswerPart?.(processedStreamMessage, tmpAssistantMessageId, conversationId);
                if (processedStreamResult && processedStreamResult.markdownData && (0, $dh538.fg)('rovo_enable_component_streaming')) setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownData)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    answerPart: processedStreamMessage,
                    markdownData: processedStreamResult.markdownData,
                    useIndex: answerIndex
                }));
                else setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    answerPart: streamMessage,
                    useIndex: answerIndex
                }));
            }
            /**********************************************************
       *
       * FINAL_RESPONSE processing
       *
       **********************************************************/ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                const agentMessageId = streamMessage?.message?.message?.id.toString();
                const pluginInvocations = streamMessage?.message?.message?.plugin_invocations;
                const minionOrchestrationOutputs = streamMessage?.message?.message?.minion_outputs;
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                $54793c520b6b8872$export$d30a5acf6cceb893(getState, conversationId, updateCurrentConversation);
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = !isLuminaAnswerGenerationType ? (0, $cteoa.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: agentMessageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent
                }) : {
                    processedStreamMessage: streamMessage,
                    markdownData: {}
                };
                // Finish view dead air tracking before rendering final response
                // This ensures the last tracked interval is up to FINAL_RESPONSE arrival,
                // and any DOM updates from replaceAnswerData are not tracked
                viewDeadAirBroker?.finish('completed');
                promptStreamHook?.onFinalResponse?.(processedStreamMessage, tmpAssistantMessageId);
                setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: tmpAssistantMessageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined,
                    onMessageIdChanged: onTempMessageIdReplacedOverride || containerOnTempMessageIdReplaced
                }));
                if (humanMessageId) setMessages(conversationId, (0, $cteoa.updateHumanMessageId)({
                    chat: getMessages(conversationId),
                    oldId: tmpHumanMessageId,
                    newId: humanMessageId
                }));
                if ((0, $dh538.fg)('aifc_create_enabled')) {
                    const allMessages = getMessages(conversationId);
                    const isValidAction = (0, $cteoa.handleStagingAreaActionValidation)(allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey);
                    if (!isValidAction) return {
                        hasReceivedFinalResponse: hasReceivedFinalResponse,
                        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent
                    };
                    const finalActions = processedStreamMessage.message.message.actions || [];
                    if (finalActions.length > 0) stopInteractionMetricsTimeToActionCompletion('stop', {
                        conversationId: conversationId,
                        actionType: 'final-actions',
                        actionCount: finalActions.length,
                        actionKeys: finalActions.map((a)=>a.key),
                        actionPartKey: streamActionInfo.actionKey
                    });
                    else stopInteractionMetricsTimeToActionCompletion('cancel');
                }
                // Update tracking attributes
                if (!hasLoggedInitiatedEvent) {
                    trackingAttributes.messageId = agentMessageId;
                    trackingAttributes.instrumentationId = agentMessageId;
                }
                trackingAttributes.humanMessageId = humanMessageId;
                trackingAttributes.hasSources = !!streamMessage?.message?.message?.sources?.length;
                trackingAttributes.citedProductList = (0, $cteoa.constructCitedProductList)(streamMessage?.message?.message?.sources);
                trackingAttributes.sourceProducts = (0, $cteoa.constructSourceProducts)(streamMessage?.message?.message?.sources);
                trackingAttributes.messageActions = streamMessage.message.message?.actions?.map((action)=>action.key);
                trackingAttributes.invokedFrom = $54793c520b6b8872$export$a0e3245ee56765fd(trackingAttributes.messageActions?.[0]);
                trackingAttributes.scenarioId = streamMessage.message.message?.scenario?.id;
                if ((0, $dh538.fg)('rovo_chat_analytics_source_extended')) {
                    trackingAttributes.sources = streamMessage?.message?.message?.sources?.map((x)=>x.ari).filter(Boolean);
                    trackingAttributes.usesJsm = false;
                }
                if (pluginInvocations) pluginInvocations.forEach((pluginInvocation)=>{
                    if (pluginInvocation.plugin_name) trackingAttributes.pluginsInvoked.add(pluginInvocation.plugin_name);
                    if (pluginInvocation.plugin_output && (0, $cteoa.containsServiceDeskSource)(pluginInvocation.plugin_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) trackingAttributes.usesJsm = true;
                });
                trackingAttributes.executedStratusSkill = (minionOrchestrationOutputs && minionOrchestrationOutputs.some((output)=>output.skill_type === 'STRATUS')) ?? false;
                minionOrchestrationOutputs && minionOrchestrationOutputs.flat().forEach((output)=>{
                    trackingAttributes.pluginsInvoked.add(output.minion_id);
                    // NOTE: statsig does not allow tracking arrays of objects so this attribute is only useful in databricks
                    trackingAttributes.skillsInvoked.push({
                        minionId: output.minion_id,
                        skillName: output.skill_alias,
                        skillType: output.skill_type,
                        invocationType: output.directly_invoked ? 'explicit' : 'implicit',
                        internalTools: output.internal_tools?.map((tool)=>({
                                name: tool.name,
                                isConsequential: tool.is_consequential
                            })) ?? []
                    });
                    if (output.minion_output && (0, $cteoa.containsServiceDeskSource)(output.minion_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) trackingAttributes.usesJsm = true;
                });
                updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
            }
            if ((0, $ljUdP.isStreamDynamicLayoutSubAgent)(streamMessage) && (0, $dh538.fg)('rovo_chat_enable_lumina')) setMessages(conversationId, (0, $cteoa.addSubAgentMessageToStoreAssistantMessage)(getMessages(conversationId), tmpAssistantMessageId, streamMessage));
            if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                const messages = getMessages(conversationId);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                $54793c520b6b8872$export$d30a5acf6cceb893(getState, conversationId, updateCurrentConversation);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: streamMessage,
                        id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                        humanMessageId: trackingAttributes.humanMessageId
                    }
                ]);
            }
            if ((0, $ljUdP.isStreamActionError)(streamMessage)) {
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId);
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                const actionError = new (0, $iEWar.StreamErrorException)(streamMessage.message.data?.message || 'Action execution failed', {
                    detail: {
                        message: {
                            content: streamMessage?.message?.data?.message || 'Action execution failed',
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: chatContextStoreActions.getIsStagingArea(),
                            productKey: productKey
                        }
                    },
                    traceId: traceId
                });
                experienceTracker.fail({
                    name: sendMessageExperienceNameCompiled,
                    error: actionError,
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isDeepResearchEnabled: deepResearchEnabled,
                        isThinkDeeperEnabled: thinkDeeperEnabled,
                        isFastModeEnabled: fastModeEnabled,
                        isWebSearchEnabled: webSearchEnabled,
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey
                    }
                });
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    error: actionError,
                    attributes: {
                        productKey: productKey,
                        isStreamAction: streamActionInfo.isAction,
                        actionKey: streamActionInfo.actionKey,
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        latestStreamMessageMillisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        latestStreamMessageType: latestStreamMessage?.type
                    }
                });
                throw actionError;
            }
            if ((0, $ljUdP.isStreamError)(streamMessage)) {
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                // AUP violations are still considered successful
                if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                    experienceTracker.succeed({
                        name: sendMessageExperienceNameCompiled
                    });
                    experienceTracker.succeed({
                        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE
                    });
                }
                sendMessageLatencyMetrics.cancel();
                betweenChunksLatencyMetrics.cancel();
                if ((0, $dh538.fg)('rovo_chat_track_dead_air')) deadAirTracker?.cancel();
                viewDeadAirBroker?.finish('errored');
                cancelStreamingMetrics();
                promptStreamHook?.onError?.(streamMessage, tmpAssistantMessageId);
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                throw new (0, $iEWar.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
    } catch (error) {
        /* for await catch block */ if (error instanceof (0, $iEWar.StreamErrorException)) throw error;
        // this is for any errors that happening during processing the stream
        // e.g. BE terminates streaming suddenly
        sendMessageLatencyMetrics.cancel();
        betweenChunksLatencyMetrics.cancel();
        if ((0, $dh538.fg)('rovo_chat_track_dead_air')) deadAirTracker?.cancel();
        viewDeadAirBroker?.finish('aborted');
        cancelStreamingMetrics();
        if ((0, $cteoa.isClientSideStreamingError)(error)) {
            const reconnectionPossible = agentMessageId && isReconnectSupported;
            if (reconnectionPossible && (0, $c6GJD.default).getExperimentValue('rovo_sse_reconnect_experiment', 'isEnabled', false)) {
                // The store still holds the assistant message under tmpAssistantMessageId (assigned
                // before the stream started). The reconnection API and subsequent stream chunks
                // reference the real server-assigned agentMessageId. Align both the chat store and
                // the research store now so the reconnection handler can look up data by server ID.
                setMessages(conversationId, (0, $cteoa.updateStoreAssistantMessageId)({
                    chat: getMessages(conversationId),
                    oldId: tmpAssistantMessageId,
                    newId: agentMessageId
                }));
                updateResearchMessageId({
                    messageId: tmpAssistantMessageId,
                    newMessageId: agentMessageId
                });
                // Throw StreamDisconnectedError for client-side streaming errors to trigger automatic reconnection
                throw new (0, $iEWar.StreamDisconnectedError)(error.message ?? 'Stream client side error', {
                    agentMessageId: agentMessageId,
                    conversationId: conversationId,
                    answerIndex: answerIndex,
                    lastEventId: lastEventId,
                    originalError: error,
                    traceId: traceId,
                    detail: {
                        millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                        type: latestStreamMessage?.type ?? ''
                    }
                });
            }
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'rovoChatStream',
                attributes: {
                    ...streamStats.getStats(),
                    isDeepResearchEnabled: deepResearchEnabled,
                    isThinkDeeperEnabled: thinkDeeperEnabled,
                    isFastModeEnabled: fastModeEnabled,
                    isWebSearchEnabled: webSearchEnabled,
                    isAIFCStreaminAction: streamActionInfo.isAction,
                    isReconnectable: reconnectionPossible,
                    conversationId: conversationId,
                    instrumentationId: trackingAttributes.instrumentationId,
                    requestId: trackingAttributes.requestId,
                    interactionSource: trackingAttributes.interactionSource,
                    contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                    userAgent: navigator?.userAgent,
                    error: error.message
                }
            });
        }
        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
        throw new (0, $iEWar.StreamGeneratorError)(error.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, error);
    } finally{
        inactivity?.stop();
        betweenChunksLatencyMetrics.stop({
            stopTime: startStreamingProcessingAt + streamStats.getStats().averageGapMs
        });
        if ((0, $dh538.fg)('rovo_chat_track_dead_air')) deadAirTracker?.complete();
        viewDeadAirBroker?.finish('completed');
    }
    /**********************************************************
   *
   * Stream processing END
   *
   **********************************************************/ updateCurrentConversation({
        sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
    });
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse,
        hasLoggedInitiatedEvent: hasLoggedInitiatedEvent
    };
};
const $54793c520b6b8872$export$9558791053c77c34 = ({ prompt: prompt, agent: /*
  As of RAGE-60 the default agent is no longer required to be sent to the backend, however
  it is still required for other local logic
  TODO: https://product-fabric.atlassian.net/browse/RAGE-418
  */ agent = (0, $1cjt9.DEFAULT_AGENT), agentId: agentIdParam, conversationId: conversationIdParam, storeUserMessages: storeUserMessages, messageSources: messageSources, files: files, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, webSearchEnabled: webSearchEnabled, appFilters: appFilters, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, productKey: productKey, source: source, promptStreamHook: promptStreamHook, creationContextParams: creationContextParams, contentContext: contentContext, minionAlias: minionAlias, onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride, contentId: contentId, setConversationData: setConversationData, createConversationOptimistically: createConversationOptimistically, addHumanMessage: addHumanMessage, addAssistantMessage: addAssistantMessage, clearFollowUpMessages: clearFollowUpMessages, setSelectedConversation: setSelectedConversation, reconnectToInProgressStream: reconnectToInProgressStream, updateConversation: updateConversation })=>async ({ dispatch: dispatch, getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, chatContextStoreActions: chatContextStoreActions, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, markIncompleteResearchesErrored: markIncompleteResearchesErrored, updateResearchMessageId: updateResearchMessageId, clearMessageResearch: clearMessageResearch, getChatInitiator: getChatInitiator, processMessageStreamAction: processMessageStreamAction, processMessageStreamComplete: processMessageStreamComplete, broadcastStreamStatus: broadcastStreamStatus, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage, onTempMessageIdReplaced: containerOnTempMessageIdReplaced, browserContextSanitizer: browserContextSanitizer, viewDeadAirBroker: viewDeadAirBroker })=>{
        const agentId = agentIdParam ?? agent.id;
        const sendMessageExperienceNameCompiled = (0, $16lEl.sendMessageExperienceName)({
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            isCustomRovoAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)
        });
        const { messageType: messageType } = $54793c520b6b8872$var$getOptimisticMessageTypes(deepResearchEnabled, webSearchEnabled);
        (0, $9963cc910aac4af3$export$589976df4d188aac)(Date.now());
        let pageContext;
        const sendMessageFn = async ({ conversationId: conversationId })=>{
            const currentConversation = (0, $cteoa.getConversation)(getState(), conversationId);
            if (currentConversation?.storeAbortController) // Silently aborting if there is another operation in progress
            return;
            const tmpHumanMessageId = (0, $cteoa.generateId)();
            const tmpAssistantMessageId = (0, $cteoa.generateTmpMessageId)(conversationId);
            let generator;
            let responseData;
            let hasLoggedInitiatedEvent = false;
            const isFirstPrompt = (0, $cteoa.isEmptyConversation)(conversationId);
            const contentContextFromStore = chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global';
            const contentContextValue = contentContext ?? contentContextFromStore;
            let trackingAttributes = $54793c520b6b8872$var$getInitialTrackingAttributes(agentId, tmpAssistantMessageId, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, messageSources, isFirstPrompt, prompt, files, appFilters, {
                templateId: creationContextParams?.templateInput?.templateId,
                templateType: creationContextParams?.templateInput?.templateType
            }, creationContextParams?.forcedContentType);
            if ((0, $dh538.fg)('rovo_chat_analytics_attributes_contexts')) trackingAttributes.contextProvided = Object.entries(chatContextStoreActions.getAllContext()).reduce((acc, [key, value])=>{
                acc[key] = Boolean(value);
                return acc;
            }, {});
            // Handle early creation of conversation data when starting from an empty state
            if (isFirstPrompt) {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                conversationId = (0, $dQl1W.v4)();
                onNewConversationStartingWithSendMessage(conversationId, {
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabled,
                    useCurrentPageContext: addCurrentPageAsContextUserPreference,
                    appFilters: appFilters
                });
                dispatch(createConversationOptimistically({
                    id: conversationId,
                    status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
                    sourceAgentId: currentConversation?.sourceAgentId ?? agentId,
                    lastMessageType: messageType,
                    lastAgentMessageStatus: 'IN_PROGRESS',
                    ...!agent.is_default && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? {
                        agent: {
                            agent_id: agent.id,
                            agent_named_id: agent.named_id,
                            agent_name: agent.name,
                            creator_type: agent.creator_type,
                            identity_account_id: agent.identity_account_id ?? undefined,
                            is_default: agent.is_default
                        }
                    } : {}
                }));
            }
            const { betweenChunksLatencyMetrics: betweenChunksLatencyMetrics, sendMessageLatencyMetrics: sendMessageLatencyMetrics, stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart, stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart, stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion, cancelStreamingMetrics: cancelStreamingMetrics } = $54793c520b6b8872$var$initLatencyMetrics({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                agentId: agentId
            });
            experienceTracker.start({
                name: sendMessageExperienceNameCompiled,
                id: conversationId,
                attributes: {
                    conversationId: conversationId,
                    interactionSource: messageSources?.interactionSource,
                    featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                }
            });
            const chatInitiator = getChatInitiator();
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    timestamp: undefined,
                    messageId: trackingAttributes.humanMessageId,
                    interactionSource: trackingAttributes.interactionSource,
                    followUpSource: trackingAttributes.followUpSource,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    contextProvided: trackingAttributes.contextProvided,
                    initiator: chatInitiator,
                    isFirstPrompt: trackingAttributes.isFirstPrompt,
                    promptFeatures: trackingAttributes.promptFeatures,
                    fileCount: trackingAttributes.fileCount,
                    appFilters: trackingAttributes.appFilters,
                    appFilterCount: trackingAttributes.appFilterCount,
                    template: trackingAttributes.template,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    conversationChannelId: conversationId
                }
            });
            const { abortController: abortController, confirmAbort: confirmAbort, updateCurrentConversation: updateCurrentConversation } = $54793c520b6b8872$var$hydrateStoreWithNewMessage(dispatch, conversationId, messageType, tmpHumanMessageId, tmpAssistantMessageId, prompt, files, agentId, setConversationData, addHumanMessage, addAssistantMessage, clearFollowUpMessages);
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Broadcast stream status to content targets for state sharing
            const broadcastStreamLifecycle = (0, $cteoa.createBroadcastStreamLifecycle)({
                broadcastStreamStatus: broadcastStreamStatus,
                chatContextStoreActions: chatContextStoreActions,
                contentContextValue: contentContextValue,
                targetId: contentId,
                assistantMessageId: tmpAssistantMessageId
            });
            // Initialize action tracking
            let streamActionInfo = {
                isAction: false
            };
            const minionAliasConfig = minionAlias ? {
                stratus_config: {
                    minion_alias: minionAlias
                }
            } : undefined;
            // Create message stream
            try {
                const sendMessageContext = await $54793c520b6b8872$var$populateSendMessageContext(chatContextStoreActions, isFirstPrompt, source, addCurrentPageAsContextUserPreference, contentContextValue, creationContextParams, productKey, sendAnalyticsEvent, contentId);
                // Derive page context for analytics from the available context objects
                pageContext = $54793c520b6b8872$export$1303843c2f44065a({
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    databaseContext: sendMessageContext.databaseContext,
                    browserUrl: sendMessageContext.browserContext?.context?.browserUrl
                });
                trackingAttributes.pageContext = pageContext;
                // Check if the Jira refresh experiment is enabled but default is set to `true` to pass all non-Jira products
                const result = await assistanceService.sendMessageStream({
                    message: prompt,
                    agentId: agentId === (0, $1cjt9.DEFAULT_AGENT).id ? undefined : agentId,
                    controller: abortController,
                    conversationId: conversationId,
                    storeMessage: storeUserMessages,
                    citationsEnabled: true,
                    minionAliasConfig: minionAliasConfig,
                    fileIds: files?.map((file)=>file.id),
                    deepResearchEnabled: deepResearchEnabled,
                    thinkDeeperEnabled: thinkDeeperEnabled,
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode,
                    fastModeEnabled: fastModeEnabled,
                    webSearchEnabled: webSearchEnabled,
                    appFilters: appFilters?.map((app)=>app.source),
                    browserContext: sendMessageContext.browserContext,
                    editorContext: sendMessageContext.editorContext,
                    whiteboardContext: sendMessageContext.whiteboardContext,
                    databaseContext: sendMessageContext.databaseContext,
                    additionalContext: sendMessageContext.additionalContext,
                    aiFeatureContext: sendMessageContext.aiFeatureContext,
                    jiraWorkflowContext: sendMessageContext.jiraWorkflowContext,
                    dashboardContext: sendMessageContext.dashboardContext,
                    useCurrentBrowsingContext: sendMessageContext.useCurrentBrowsingContext,
                    browserContextSanitizer: browserContextSanitizer,
                    optInToDeepResearchV2: true,
                    optInThinkDeeperMessages: (0, $c6GJD.default).getExperimentValue('rovo_chat_thinking_deeper_messages_experiment', 'enabled', false),
                    optInAnsNow: (0, $dh538.fg)('rovo_chat_enable_ans_now'),
                    optInSSEStream: true
                });
                generator = result.generator;
                responseData = result.responseData;
            } catch (error) {
                if ((0, $dh538.fg)('aifc_show_error_ui_for_inline_rovo')) promptStreamHook?.onError?.(error, tmpAssistantMessageId);
                $54793c520b6b8872$var$handleSendMessageServiceCallFailure(error, deepResearchEnabled, thinkDeeperEnabled, fastModeEnabled, webSearchEnabled, streamActionInfo, chatContextStoreActions, experienceTracker, sendMessageExperienceNameCompiled, trackingAttributes, updateCurrentConversation, sendMessageLatencyMetrics, cancelStreamingMetrics, broadcastStreamLifecycle, confirmAbort, trackAIMAUEvent, messageSources, abortController, hasLoggedInitiatedEvent, tmpAssistantMessageId, clearMessageResearch, getState, conversationId);
                return;
            }
            const { hasReceivedFinalResponse: hasReceivedFinalResponse, hasLoggedInitiatedEvent: hasLoggedInitiatedEventForStream } = await $54793c520b6b8872$var$processStream({
                prompt: prompt,
                generator: generator,
                productKey: productKey,
                answerIndex: answerIndex,
                tmpHumanMessageId: tmpHumanMessageId,
                tmpAssistantMessageId: tmpAssistantMessageId,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                deepResearchEnabled: deepResearchEnabled,
                webSearchEnabled: webSearchEnabled,
                sendMessageExperienceNameCompiled: sendMessageExperienceNameCompiled,
                traceId: responseData?.traceId,
                updateCurrentConversation: updateCurrentConversation,
                trackingAttributes: trackingAttributes,
                conversationId: conversationId,
                getState: getState,
                promptStreamHook: promptStreamHook,
                experienceTracker: experienceTracker,
                setMessages: setMessages,
                getMessages: getMessages,
                processStreamResearch: processStreamResearch,
                processMessageStreamAction: processMessageStreamAction,
                processMessageStreamComplete: processMessageStreamComplete,
                containerOnTempMessageIdReplaced: containerOnTempMessageIdReplaced,
                updateResearchMessageId: updateResearchMessageId,
                sendAnalyticsEvent: sendAnalyticsEvent,
                chatContextStoreActions: chatContextStoreActions,
                stopInteractionMetricsTimeToFirstActionPart: stopInteractionMetricsTimeToFirstActionPart,
                stopInteractionMetricsTimeToFirstAnswerPart: stopInteractionMetricsTimeToFirstAnswerPart,
                stopInteractionMetricsTimeToActionCompletion: stopInteractionMetricsTimeToActionCompletion,
                broadcastStreamLifecycle: broadcastStreamLifecycle,
                sendMessageLatencyMetrics: sendMessageLatencyMetrics,
                betweenChunksLatencyMetrics: betweenChunksLatencyMetrics,
                cancelStreamingMetrics: cancelStreamingMetrics,
                onTempMessageIdReplacedOverride: onTempMessageIdReplacedOverride,
                streamActionInfo: streamActionInfo,
                trackAIMAUEvent: trackAIMAUEvent,
                messageSources: messageSources,
                hasLoggedInitiatedEvent: hasLoggedInitiatedEvent,
                clearMessageResearch: clearMessageResearch,
                viewDeadAirBroker: viewDeadAirBroker
            });
            hasLoggedInitiatedEvent = hasLoggedInitiatedEventForStream;
            // TODO: This should be behind the !aborted logic, but due to a bug in the BE service, aborted requests
            // will client connection with the server yet still complete in the background. This results in the UI showing
            // no message updates, until reload when the actual resolved message can be sesen.
            // Once that is fixed, we can place this behind the !aborted logic.
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    // messageId must remain the ID received from the server in the FINAL_RESPONSE
                    // in order to map correctly to our event funnel, e.g `agentMessage received` -> `agentResponse content copied`
                    messageId: trackingAttributes.messageId,
                    humanMessageId: trackingAttributes.humanMessageId,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    requestId: trackingAttributes.requestId,
                    hasSources: trackingAttributes.hasSources,
                    citedProductList: trackingAttributes.citedProductList,
                    sourceProducts: trackingAttributes.sourceProducts,
                    timestamp: new Date().toISOString(),
                    messageActions: trackingAttributes.messageActions,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    initiator: chatInitiator,
                    deepResearchInvoked: trackingAttributes.deepResearchInvoked,
                    scenarioId: trackingAttributes.scenarioId
                }
            });
            updateCurrentConversation((0, $cteoa.clearStatus)({
                lastAgentMessageStatus: 'SUCCESSFUL'
            }));
            if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) dispatch(updateConversation({
                conversationId: conversationId,
                data: {
                    read_status: getState().currentConversationId === conversationId
                }
            }));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
            if (abortController.signal.aborted) {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: messageSources?.interactionSource !== 'chatInput',
                    userGenerated: messageSources?.interactionSource === 'chatInput',
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext
                });
                trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: true,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled
                });
                confirmAbort();
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ABORTED);
                // Call the cancel API if we have a message ID
                if (trackingAttributes.messageId && (0, $c6GJD.default).getExperimentValue('rovo_sse_reconnect_experiment', 'isEnabled', false)) assistanceService.cancelMessageStream({
                    conversationId: conversationId,
                    messageId: trackingAttributes.messageId
                }).catch((error)=>{
                    // Log but don't throw - the abort is already happening
                    (0, $1yaYZ.logException)({
                        name: 'rovoCancelMessageStream',
                        exception: error,
                        tags: {
                            conversationId: conversationId,
                            messageId: trackingAttributes.messageId
                        }
                    });
                });
                experienceTracker.abort({
                    name: sendMessageExperienceNameCompiled,
                    reason: 'Aborted',
                    attributes: {
                        featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown',
                        isProgrammaticAbort: true // always true because we're within abortController.signal.aborted (further explained in similar abort for AbortError case)
                    }
                });
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                    reason: 'stream aborted'
                });
                // Always mark incomplete researches as errored on abort — the backend can
                // autonomously trigger think-deeper even in auto mode
                markIncompleteResearchesErrored({
                    messageId: tmpAssistantMessageId
                });
                // Clear research data to remove lingering think deeper state
                if ((0, $dh538.fg)('rovo_chat_think_deeper_mode_trace_changes')) clearMessageResearch({
                    messageId: tmpAssistantMessageId
                });
                return;
            } else {
                if (!hasLoggedInitiatedEvent) // See: https://hello.atlassian.net/wiki/spaces/~321863207/pages/4188127855/Analytics+2024-11-16
                // Delaying the initiated event firing allows us to create the pairing appropriately,
                // for any initiated events leading up to an error or dismiss state with a
                // hashed ID
                trackAIMAUEvent({
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: messageSources?.interactionSource !== 'chatInput',
                    userGenerated: messageSources?.interactionSource === 'chatInput',
                    timestamp: trackingAttributes.messageSentTimeStamp,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    pageContext: trackingAttributes.pageContext
                });
                //If we're done processing the stream and no answer part has been processed, then it means that the BE is hanging. Throw an error
                if (!hasReceivedFinalResponse) {
                    const agentDetails = await assistanceService.getAgentDetails(agentId);
                    if (agentDetails.deactivated) {
                        // If agent is deactivated, throw correct error
                        const agentError = new (0, $iEWar.NoFinalResponseError)('The selected agent may no longer be available.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: agentError,
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: true,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled
                        });
                        updateCurrentConversation({
                            status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
                            traces: []
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                        return;
                    } else {
                        // Agent is active, BE hanging
                        const timeoutError = new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                            traceId: responseData?.traceId
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: timeoutError,
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                isStreamAction: streamActionInfo.isAction,
                                actionKey: streamActionInfo.actionKey,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: false,
                            messageId: trackingAttributes.requestId,
                            timestamp: new Date().toISOString(),
                            singleInstrumentationID: trackingAttributes.instrumentationId,
                            deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                            thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                            fastModeEnabled: trackingAttributes.fastModeEnabled,
                            webSearchEnabled: trackingAttributes.webSearchEnabled
                        });
                        sendMessageLatencyMetrics.cancel();
                        cancelStreamingMetrics();
                        broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).ERRORED);
                        throw timeoutError;
                    }
                }
                /**
       * IMPORTANT: CRITICAL ANALYTICS EVENT
       *
       * This event is essential for business metrics and monitoring.
       *
       * DO NOT MODIFY the structure, content, or emission logic of this event without:
       *   - Careful review of potential impacts on data quality, privacy, and business reporting.
       *   - Explicit approval from both analytics and security stakeholders.
       *
       * Reference: Incident HOT-120175 (UGC page title and URLs leak)
       * Event Registry: https://data-portal.internal.atlassian.com/analytics/registry/68936?tabIndex=Details
       */ trackAIMAUEvent({
                    type: 'viewed',
                    subjectId: messageSources?.followUpSource,
                    messageId: trackingAttributes.messageId,
                    source: messageSources?.interactionSource,
                    messageActions: trackingAttributes.messageActions,
                    invokedFrom: trackingAttributes.invokedFrom,
                    proactive: messageSources?.interactionSource !== 'chatInput',
                    userGenerated: messageSources?.interactionSource === 'chatInput',
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString(),
                    citedProductList: trackingAttributes.citedProductList,
                    sourceProducts: trackingAttributes.sourceProducts,
                    pluginsInvoked: Array.from(trackingAttributes.pluginsInvoked),
                    skillsInvoked: trackingAttributes.skillsInvoked,
                    responseSources: trackingAttributes.sources,
                    usesJsm: trackingAttributes.usesJsm,
                    deepResearchEnabled: trackingAttributes.deepResearchEnabled,
                    thinkDeeperEnabled: trackingAttributes.thinkDeeperEnabled,
                    fastModeEnabled: trackingAttributes.fastModeEnabled,
                    webSearchEnabled: trackingAttributes.webSearchEnabled,
                    conversationChannelId: conversationId,
                    scenarioId: trackingAttributes.scenarioId,
                    pageContext: trackingAttributes.pageContext
                });
                // Experience is aborted in `abortRequests`
                experienceTracker.succeed({
                    name: sendMessageExperienceNameCompiled
                });
                // Broadcast that the stream has completed successfully
                broadcastStreamLifecycle((0, $eWKku.StreamLifecycleState).COMPLETED);
            }
            sendMessageLatencyMetrics.stop({
                customData: messageSources?.interactionSource ? {
                    interactionSource: messageSources.interactionSource
                } : undefined
            });
        };
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        try {
            await sendMessageFn({
                conversationId: conversationId
            });
        } catch (error) {
            // Handle automatic reconnection for client-side streaming errors.
            if (error instanceof (0, $iEWar.StreamDisconnectedError)) {
                const reconnectionOnComplete = (result)=>{
                    if (result.success) {
                        const meta = result.streamMeta;
                        trackAIMAUEvent({
                            type: 'viewed',
                            subjectId: messageSources?.followUpSource,
                            messageId: error.agentMessageId,
                            source: messageSources?.interactionSource,
                            messageActions: meta?.messageActions,
                            proactive: messageSources?.interactionSource !== 'chatInput',
                            userGenerated: messageSources?.interactionSource === 'chatInput',
                            singleInstrumentationID: error.agentMessageId,
                            timestamp: new Date().toISOString(),
                            deepResearchEnabled: deepResearchEnabled,
                            thinkDeeperEnabled: thinkDeeperEnabled,
                            fastModeEnabled: fastModeEnabled,
                            webSearchEnabled: webSearchEnabled,
                            conversationChannelId: error.conversationId,
                            citedProductList: meta?.citedProductList ?? {},
                            sourceProducts: meta?.sourceProducts ?? {},
                            pluginsInvoked: meta?.pluginsInvoked,
                            skillsInvoked: meta?.skillsInvoked,
                            responseSources: meta?.responseSources,
                            usesJsm: meta?.usesJsm,
                            scenarioId: meta?.scenarioId,
                            pageContext: pageContext
                        });
                        experienceTracker.succeed({
                            name: sendMessageExperienceNameCompiled
                        });
                    } else {
                        sendAnalyticsEvent({
                            eventType: 'track',
                            action: 'failed',
                            actionSubject: 'rovoChatStream',
                            attributes: {
                                isDeepResearchEnabled: deepResearchEnabled,
                                isThinkDeeperEnabled: thinkDeeperEnabled,
                                isWebSearchEnabled: webSearchEnabled,
                                isAIFCStreaminAction: false,
                                isReconnectable: true,
                                conversationId: conversationId,
                                instrumentationId: error.agentMessageId,
                                requestId: error.agentMessageId,
                                interactionSource: messageSources?.interactionSource,
                                contentContext: chatContextStoreActions.getIsStagingArea() ? 'staging-area' : 'global',
                                userAgent: navigator?.userAgent,
                                error: error.message
                            }
                        });
                        trackAIMAUEvent({
                            type: 'error',
                            userGenerated: false,
                            messageId: error.agentMessageId,
                            singleInstrumentationID: error.agentMessageId,
                            timestamp: new Date().toISOString(),
                            deepResearchEnabled: deepResearchEnabled,
                            thinkDeeperEnabled: thinkDeeperEnabled,
                            fastModeEnabled: fastModeEnabled,
                            webSearchEnabled: webSearchEnabled
                        });
                        experienceTracker.fail({
                            name: sendMessageExperienceNameCompiled,
                            error: result.error ?? new Error('Reconnection failed'),
                            attributes: {
                                deepResearchEnabled: deepResearchEnabled,
                                thinkDeeperEnabled: thinkDeeperEnabled,
                                fastModeEnabled: fastModeEnabled,
                                webSearchEnabled: webSearchEnabled,
                                featureArea: chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown'
                            }
                        });
                    }
                };
                await dispatch(reconnectToInProgressStream({
                    conversationId: error.conversationId,
                    messageId: error.agentMessageId,
                    answerIndex: error.answerIndex,
                    isDeepResearch: deepResearchEnabled,
                    lastEventId: error.lastEventId,
                    abortCurrentRequest: true,
                    onComplete: reconnectionOnComplete
                }));
                return;
            }
            if ((0, $ljUdP.isChannelNotFoundError)(error)) {
                const createdChannel = await assistanceService.createConversationChannel();
                setState({
                    conversations: {
                        ...getState().conversations,
                        [createdChannel.id]: {
                            id: createdChannel.id,
                            name: createdChannel.name,
                            timeCreated: createdChannel.time_created,
                            status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                            traces: [],
                            messages: [],
                            ...createdChannel.agent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? {
                                agent: createdChannel.agent
                            } : {}
                        }
                    }
                });
                setMessages(createdChannel.id, []);
                dispatch(setSelectedConversation({
                    conversationId: createdChannel.id
                }));
                await sendMessageFn({
                    conversationId: createdChannel.id
                });
            } else throw error;
        }
    };
const $54793c520b6b8872$var$getStreamStats = ()=>{
    const stats = {
        totalChunks: 0,
        traceChunks: 0,
        answerChunks: 0,
        actionChunks: 0,
        researchChunks: 0,
        otherChunks: 0,
        firstChunkAt: undefined,
        lastChunkAt: undefined,
        sumInterChunkMs: 0,
        pluginsObserved: new Set()
    };
    const update = (streamMessage)=>{
        const now = performance.now();
        stats.totalChunks += 1;
        if (stats.firstChunkAt === undefined) stats.firstChunkAt = now;
        if (stats.lastChunkAt !== undefined) stats.sumInterChunkMs += now - stats.lastChunkAt;
        stats.lastChunkAt = now;
        if ((0, $ljUdP.isStreamTrace)(streamMessage)) stats.traceChunks += 1;
        else if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) stats.answerChunks += 1;
        else if ((0, $ljUdP.isStreamResearchPayload)(streamMessage)) stats.researchChunks += 1;
        else if ((0, $ljUdP.isStreamActionPart)(streamMessage) || (0, $ljUdP.isStreamActionPrepare)(streamMessage)) // Count action-related chunks (prepare/part)
        stats.actionChunks += 1;
        else // Count unknown chunks
        stats.otherChunks += 1;
        // Observe plugin names if present early (often only present on final response)
        const invocations = (0, $ljUdP.isStreamResponse)(streamMessage) ? streamMessage.message?.message?.plugin_invocations : [];
        if (Array.isArray(invocations)) invocations.forEach((p)=>p?.plugin_name && stats.pluginsObserved.add(p.plugin_name));
    };
    const getStats = ()=>{
        const avgGapMs = stats.totalChunks > 1 ? Math.round(stats.sumInterChunkMs / (stats.totalChunks - 1)) : 0;
        return {
            ...stats,
            pluginsObserved: Array.from(stats.pluginsObserved),
            averageGapMs: avgGapMs
        };
    };
    return {
        update: update,
        getStats: getStats
    };
};
const $54793c520b6b8872$export$23f1f8f522f4bdd = (config)=>{
    let armed = false;
    let firstChunkArrived = false;
    let timer;
    let stallCount = 0;
    const clearTimer = ()=>{
        if (timer !== undefined) {
            clearTimeout(timer);
            timer = undefined;
        }
    };
    const schedule = (stage)=>{
        clearTimer();
        const timeoutMs = config.baseMs;
        timer = setTimeout(()=>{
            stallCount += 1;
            config.sendAnalyticsEvent({
                eventType: 'track',
                action: 'timeout',
                actionSubject: 'rovoChatStream',
                attributes: {
                    stallCount: stallCount,
                    stage: stage,
                    timeoutMs: timeoutMs
                }
            });
            // Keep armed so we continue to detect subsequent stalls until chunks resume
            schedule('betweenChunks');
        }, timeoutMs);
    };
    return {
        arm: ()=>{
            if (armed) return;
            armed = true;
            // Start pre-first-chunk watchdog waiting for the first stream event
            schedule('newResponse');
        },
        onChunk: ()=>{
            if (!armed) return;
            if (firstChunkArrived === false) {
                firstChunkArrived = true;
                // After the first chunk, schedule timeout waiting for the next event
                schedule('firstGap');
                return;
            }
            // For subsequent chunks, re-arm the between-chunks watchdog
            schedule('betweenChunks');
        },
        stop: ()=>{
            clearTimer();
            armed = false;
        }
    };
};






const $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1 = async ({ generator: generator, messageId: messageId, conversationId: conversationId, isDeepResearch: isDeepResearch, isStagingArea: isStagingArea, answerIndex: answerIndex, traceId: traceId, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, getState: getState, updateCurrentConversation: updateCurrentConversation, sendAnalyticsEvent: sendAnalyticsEvent, onStreamEvent: onStreamEvent })=>{
    const processStreamMarkdown = (0, $cteoa.createStreamMarkdownProcessor)();
    let latestStreamMessage;
    let hasReceivedFinalResponse = false;
    try {
        for await (const streamObj of generator){
            const streamMessage = streamObj.data;
            latestStreamMessage = streamMessage;
            onStreamEvent('chunk', streamMessage, streamObj.id);
            /**
       * Research payload processing
       */ if ((0, $ljUdP.isStreamResearchPayload)(streamMessage) || (0, $ljUdP.isStreamResponse)(streamMessage) || (0, $ljUdP.isStreamAnswerPart)(streamMessage) || (0, $ljUdP.isStreamReasoningPart)(streamMessage)) processStreamResearch({
                messageId: messageId,
                streamMessage: streamMessage,
                isDeepResearch: isDeepResearch ?? false
            });
            /**
       * Research plan processing
       */ if ((0, $ljUdP.isStreamResearchPlan)(streamMessage)) {
                const messages = (0, $cteoa.clearStoreAssistantMessageContent)(getMessages(conversationId), messageId);
                setMessages(conversationId, messages);
                processStreamResearch({
                    messageId: messageId,
                    streamMessage: streamMessage,
                    isDeepResearch: isDeepResearch ?? false
                });
            }
            /**
       *  ANSWER_PART  processing
       */ if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $54793c520b6b8872$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                let processedStreamMessage = streamMessage;
                let processedStreamResult = null;
                if ((0, $dh538.fg)('rovo_enable_component_streaming')) {
                    processedStreamResult = processStreamMarkdown(processedStreamMessage);
                    processedStreamMessage = processedStreamResult.processedStreamMessage;
                }
                if (processedStreamResult && processedStreamResult.markdownData && (0, $dh538.fg)('rovo_enable_component_streaming')) setMessages(conversationId, (0, $cteoa.addAnswerPartWithMarkdownData)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    answerPart: processedStreamMessage,
                    markdownData: processedStreamResult.markdownData,
                    useIndex: answerIndex
                }));
                else setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    answerPart: streamMessage,
                    useIndex: answerIndex
                }));
            }
            /**
       * FINAL_RESPONSE processing
       */ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                hasReceivedFinalResponse = true;
                const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                const { processedStreamMessage: processedStreamMessage, markdownData: markdownData } = (0, $cteoa.processStreamResponseMarkdown)({
                    streamMessage: streamMessage,
                    messageId: messageId,
                    conversationId: conversationId,
                    sendAnalyticsEvent: sendAnalyticsEvent
                });
                setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                    chat: getMessages(conversationId),
                    answerId: messageId,
                    content: processedStreamMessage,
                    useIndex: answerIndex,
                    humanMessageId: humanMessageId,
                    markdownData: Object.keys(markdownData).length > 0 ? markdownData : undefined
                }));
                // Update the StoreHuman entry's ID from the temporary client-generated ID
                // to the real server-assigned ID. After a page reload this is a no-op because
                // the store already contains the real ID.
                if (humanMessageId) {
                    const currentHumanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
                    if (currentHumanMessageId && currentHumanMessageId !== humanMessageId) setMessages(conversationId, (0, $cteoa.updateHumanMessageId)({
                        chat: getMessages(conversationId),
                        oldId: currentHumanMessageId,
                        newId: humanMessageId
                    }));
                }
            }
            /**
       * Follow up processing
       */ if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                const messages = getMessages(conversationId);
                // Only clear traces if they are not already empty to avoid unnecessary state updates
                (0, $54793c520b6b8872$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                setMessages(conversationId, [
                    ...messages,
                    {
                        type: 'FOLLOW_UP',
                        content: streamMessage,
                        id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                        agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages)
                    }
                ]);
            }
            /**
       * Action error processing
       */ if ((0, $ljUdP.isStreamActionError)(streamMessage)) {
                const actionError = new (0, $iEWar.StreamErrorException)(streamMessage.message.data?.message || 'Action execution failed', {
                    detail: {
                        message: {
                            content: streamMessage?.message?.data?.message || 'Action execution failed',
                            message_template: streamMessage?.message?.key
                        },
                        metadata: {
                            ...streamMessage.metadata,
                            isStagingArea: isStagingArea
                        }
                    },
                    traceId: traceId
                });
                throw actionError;
            }
            if ((0, $ljUdP.isStreamError)(streamMessage)) {
                onStreamEvent('error', streamMessage, streamObj.id);
                const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                throw new (0, $iEWar.StreamErrorException)(message?.content || 'Unknown', {
                    detail: {
                        message: message,
                        metadata: metadata,
                        millisOffset: millisOffset,
                        type: type
                    },
                    traceId: traceId
                });
            }
        }
    } catch (error) {
        if (error instanceof (0, $iEWar.StreamErrorException)) throw error;
        throw new (0, $iEWar.StreamGeneratorError)(error.message ?? 'Stream generator error', {
            traceId: traceId,
            detail: {
                millisOffset: latestStreamMessage && 'millisOffset' in latestStreamMessage ? latestStreamMessage.millisOffset : undefined,
                type: latestStreamMessage?.type ?? ''
            }
        }, error);
    }
    return {
        hasReceivedFinalResponse: hasReceivedFinalResponse
    };
};
const $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98 = (params)=>{
    const timeToConnectToStreamMetrics = (0, $1K4cm.reconnectionMetrics).createTimeToConnectToStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    const timeToResumeStreamMetrics = (0, $1K4cm.reconnectionMetrics).createTimeToResumeStreamMetrics({
        deepResearchEnabled: params.isDeepResearchEnabled,
        thinkDeeperEnabled: params.thinkDeeperEnabled,
        fastModeEnabled: params.fastModeEnabled
    });
    return {
        timeToConnectToStreamMetrics: timeToConnectToStreamMetrics,
        timeToResumeStreamMetrics: timeToResumeStreamMetrics
    };
};
const $f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS = 3;
const $f0918ff6cbefa0f7$var$RETRY_BASE_DELAY_MS = 1000;
const $f0918ff6cbefa0f7$var$POST_ONLINE_DELAY_MS = 2000;
const $f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED = 'chat-unmounted';
const $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8 = (error)=>{
    if (error instanceof Error && error.name === 'AbortError') return false;
    // StreamGeneratorError wraps the original error as `cause` — check the underlying error
    if (error instanceof (0, $iEWar.StreamGeneratorError)) return (0, $cteoa.isClientSideStreamingError)(error.cause ?? error);
    return (0, $cteoa.isClientSideStreamingError)(error);
};
const $f0918ff6cbefa0f7$export$d8454bf5b2ffdf29 = ({ conversationId: conversationId, messageId: messageId, answerIndex: _answerIndex, isDeepResearch: isDeepResearch, lastEventId: lastEventId, setConversationData: setConversationData, abortCurrentRequest: abortCurrentRequest, onComplete: onComplete, isAutoReconnect: isAutoReconnect })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, trackAIMAUEvent: trackAIMAUEvent, getMessages: getMessages, setMessages: setMessages, processStreamResearch: processStreamResearch, chatContextStoreActions: chatContextStoreActions, markIncompleteResearchesErrored: markIncompleteResearchesErrored, endReconnection: endReconnection, startReconnection: startReconnection, isReconnecting: isReconnecting, getIsChatMounted: getIsChatMounted })=>{
        const currentConversation = getState().conversations[conversationId];
        if (abortCurrentRequest && currentConversation?.storeAbortController) currentConversation.storeAbortController.abort();
        // Skip reconnection if there is another operation in progress
        if (currentConversation?.storeAbortController && !abortCurrentRequest || isReconnecting(conversationId)) return;
        startReconnection(conversationId, messageId);
        const reconnectionPerformanceMetrics = $f0918ff6cbefa0f7$export$4f5dbc9d3a9c9f98({
            isDeepResearchEnabled: isDeepResearch,
            thinkDeeperEnabled: false,
            fastModeEnabled: false
        });
        let totalAttempts = 0;
        const reconnectStartedAt = new Date().toISOString();
        const metrics = {
            // Reconnection metrics
            onReconnectStarted: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.start();
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    id: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch
                    }
                });
                // Only fire MAU events for page-load auto-reconnects, not send-message reconnects.
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'initiated',
                    userGenerated: false,
                    proactive: true,
                    triggeredByAutoReconnect: true,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: reconnectStartedAt
                });
            },
            // Was able to connect to active stream
            onReconnectEstablished: ()=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.stop();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.start();
            },
            onReconnectFailed: (error)=>{
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    error: error,
                    attributes: {
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch,
                        totalAttempts: totalAttempts
                    }
                });
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'error',
                    userGenerated: false,
                    proactive: true,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString()
                });
            },
            onReconnectChunkReceived: ()=>{
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.stop();
            },
            onReconnectAborted: ()=>{
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    reason: 'Aborted'
                });
                reconnectionPerformanceMetrics.timeToResumeStreamMetrics.cancel();
                reconnectionPerformanceMetrics.timeToConnectToStreamMetrics.cancel();
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'dismissed',
                    userGenerated: false,
                    proactive: true,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    timestamp: new Date().toISOString()
                });
            },
            onReconnectSucceeded: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM,
                    attributes: {
                        totalAttempts: totalAttempts,
                        conversationId: conversationId,
                        messageId: messageId,
                        isDeepResearch: isDeepResearch
                    }
                });
                if (isAutoReconnect) trackAIMAUEvent({
                    type: 'viewed',
                    userGenerated: false,
                    proactive: true,
                    triggeredByAutoReconnect: true,
                    messageId: messageId,
                    singleInstrumentationID: messageId,
                    deepResearchEnabled: isDeepResearch ?? false,
                    citedProductList: streamMeta?.citedProductList ?? {},
                    sourceProducts: streamMeta?.sourceProducts ?? {},
                    pluginsInvoked: streamMeta?.pluginsInvoked,
                    skillsInvoked: streamMeta?.skillsInvoked,
                    responseSources: streamMeta?.responseSources,
                    usesJsm: streamMeta?.usesJsm,
                    messageActions: streamMeta?.messageActions,
                    conversationChannelId: conversationId,
                    timestamp: new Date().toISOString()
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch(setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const cancelMessageStream = ()=>{
            assistanceService.cancelMessageStream({
                conversationId: conversationId,
                messageId: messageId
            }).catch((err)=>{
                (0, $1yaYZ.logException)({
                    name: 'rovoCancelMessageStream',
                    exception: err,
                    tags: {
                        conversationId: conversationId,
                        messageId: messageId
                    }
                });
            });
        };
        const messages = getMessages(conversationId);
        const answerIndex = _answerIndex ?? (0, $cteoa.findStoreMessageIndex)(messages, messageId);
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
        let traceId;
        let streamMeta;
        let currentLastEventId = lastEventId;
        let reconnectSucceeded = false;
        const connectAndProcessStream = async ()=>{
            const { generator: generator, responseData: responseData } = await assistanceService.reconnectToMessageStream({
                conversationId: conversationId,
                messageId: messageId,
                lastEventId: currentLastEventId,
                controller: abortController
            });
            traceId = responseData?.traceId;
            metrics.onReconnectEstablished();
            const { hasReceivedFinalResponse: hasReceivedFinalResponse } = await $f0918ff6cbefa0f7$export$f74ad34bb7f49ad1({
                generator: generator,
                traceId: responseData?.traceId,
                messageId: messageId,
                conversationId: conversationId,
                answerIndex: answerIndex,
                isStagingArea: chatContextStoreActions.getIsStagingArea(),
                isDeepResearch: isDeepResearch,
                getState: getState,
                setMessages: setMessages,
                getMessages: getMessages,
                processStreamResearch: processStreamResearch,
                sendAnalyticsEvent: sendAnalyticsEvent,
                updateCurrentConversation: updateCurrentConversation,
                onStreamEvent: (event, streamMessage, eventId)=>{
                    // Update currentLastEventId progressively as we process each event
                    // so that retries can resume from the last successfully processed event
                    if (eventId) currentLastEventId = eventId;
                    if (event === 'chunk') {
                        metrics.onReconnectChunkReceived();
                        if (streamMessage && (0, $ljUdP.isStreamResponse)(streamMessage)) streamMeta = (0, $cteoa.extractStreamMeta)(streamMessage);
                    }
                    if (event === 'error') {
                        if ((0, $ljUdP.isStreamAUPError)(streamMessage)) {
                            reconnectSucceeded = true;
                            metrics.onReconnectSucceeded();
                        }
                    }
                }
            });
            if (abortController.signal.aborted) throw new DOMException('Reconnect aborted', 'AbortError');
            if (!hasReceivedFinalResponse) throw new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: traceId
            });
        };
        //** CONNECT TO STREAM (with retry) */
        try {
            metrics.onReconnectStarted();
            updateCurrentConversation({
                status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse,
                traces: [
                    {
                        messageContent: 'Resuming response...',
                        status: 'loading'
                    }
                ],
                storeAbortController: storeAbortController
            });
            await (0, $92b0a6aa5f3cefb4$export$4dfcad98182a1ece)({
                fn: connectAndProcessStream,
                maxRetries: $f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS,
                delay: $f0918ff6cbefa0f7$var$RETRY_BASE_DELAY_MS,
                postOnlineDelay: $f0918ff6cbefa0f7$var$POST_ONLINE_DELAY_MS,
                errorFilter: (error)=>{
                    // Don't retry if the chat is unmounted — lazy reconnection will handle it when user returns
                    if (!getIsChatMounted()) {
                        abortController.abort($f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED);
                        return false;
                    }
                    return $f0918ff6cbefa0f7$export$4eef7b24ec94bbe8(error);
                },
                jitter: true,
                signal: abortController.signal,
                pauseWhileOffline: true,
                onRetry: (attempt, _error)=>{
                    totalAttempts = attempt + 1;
                    sendAnalyticsEvent({
                        eventType: 'track',
                        action: 'retrying',
                        actionSubject: 'rovoChatReconnection',
                        attributes: {
                            conversationId: conversationId,
                            messageId: messageId,
                            isDeepResearch: isDeepResearch,
                            attempt: attempt,
                            maxAttempts: $f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS,
                            hasLastEventId: !!currentLastEventId
                        }
                    });
                    updateCurrentConversation({
                        traces: [
                            {
                                messageContent: `Connection lost. Retrying... (${attempt}/${$f0918ff6cbefa0f7$var$MAX_RECONNECT_ATTEMPTS})`,
                                status: 'loading'
                            }
                        ]
                    });
                }
            });
            metrics.onReconnectSucceeded();
            onComplete?.({
                success: true,
                streamMeta: streamMeta
            });
        } catch (error) {
            if (error instanceof Error && error.name === 'AbortError' || abortController.signal.aborted) {
                confirmAbort();
                updateCurrentConversation({
                    lastAgentMessageStatus: 'FAILED'
                });
                metrics.onReconnectAborted();
                // Only cancel the message stream if the abort reason is not the chat unmounted reason
                if (abortController.signal.reason !== $f0918ff6cbefa0f7$var$RECONNECT_ABORT_REASON_CHAT_UNMOUNTED) cancelMessageStream();
                return;
            }
            if (!reconnectSucceeded) metrics.onReconnectFailed(error);
            if (isDeepResearch) markIncompleteResearchesErrored({
                messageId: messageId
            });
            onComplete?.({
                success: reconnectSucceeded,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        } finally{
            endReconnection(conversationId);
            updateCurrentConversation((0, $cteoa.clearStatus)({}));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
    };

























const $434fbbd3906b07f0$var$getErrorReason = ({ error: error, storeError: storeError, currentConversationId: currentConversationId, conversations: conversations })=>{
    if ((0, $ljUdP.isHipaaError)(error)) return 'hipaa';
    if ((0, $ljUdP.isAUPViolationError)(error)) return 'aupViolation';
    if ((0, $ljUdP.isChannelNotFoundError)(error)) return 'channelNotFound';
    if (!conversations?.[currentConversationId] || (0, $cteoa.isEmptyConversation)(currentConversationId)) return 'noActiveConversation';
    if (storeError.status_code === 429 || (0, $ljUdP.isRateLimitedError)(error)) return 'rateLimited';
    return 'generic';
};
const $434fbbd3906b07f0$var$reportChatError = (sendAnalyticsEvent, reason, storeError)=>{
    if (!(0, $dh538.fg)('ai_mate_unhandled_error_reporting')) return;
    sendAnalyticsEvent({
        eventType: 'operational',
        action: 'unhandledError',
        actionSubject: 'aiMate',
        attributes: {
            reason: reason,
            statusCode: storeError.status_code,
            messageTemplate: storeError.message_template,
            errorType: storeError.errorType,
            traceId: storeError.traceId,
            errorContent: storeError.content,
            ...storeError.storeActionExecutionError ? {
                actionLoggableName: storeError.storeActionExecutionError.actionLoggableName
            } : {}
        }
    });
};
const $434fbbd3906b07f0$export$769f721a7d2183c3 = (props)=>{
    const { args: args, api: api, actionLoggableName: actionLoggableName, error: error, containerProps: containerProps, actionErrorHandler: actionErrorHandler, setConversationData: setConversationData } = props;
    const { getState: getState, setState: setState, dispatch: dispatch } = api;
    (0, $1yaYZ.addSentryBreadcrumb)(`createSafeAction: ${actionLoggableName} errored`);
    const storeError = (0, $cteoa.createStoreError)(error, undefined, actionLoggableName);
    const errorReason = $434fbbd3906b07f0$var$getErrorReason({
        error: error,
        storeError: storeError,
        currentConversationId: getState().currentConversationId,
        conversations: getState().conversations
    });
    // ============================================
    // PHASE 1: Mandatory checks (cannot be overridden)
    // ============================================
    // Handle experience tracking
    // Rate limits are ignored because they trigger a retry, not an experience termination
    if (props?.experienceName && errorReason !== 'rateLimited') {
        if (errorReason === 'aupViolation') {
            const aupError = error;
            containerProps.experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
                reason: aupError.detail.message.message_template,
                attributes: {
                    ...aupError.errorAttributes,
                    errorType: error instanceof (0, $iEWar.StreamErrorException) ? 'StreamErrorException' : ''
                }
            });
        } else containerProps.experienceTracker.fail({
            name: props.experienceName(args),
            error: error instanceof Error ? error : new Error(String(error))
        });
    }
    // Handle restricted use errors
    if (errorReason === 'hipaa') {
        containerProps.setConversationError({
            type: 'hipaa',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'hipaa', storeError);
        return;
    }
    // ============================================
    // PHASE 2: Action-specific error handling (optional)
    // ============================================
    if (actionErrorHandler) {
        const result = actionErrorHandler({
            args: args,
            error: error,
            storeError: storeError,
            containerProps: containerProps,
            errorReason: errorReason
        });
        if (!result?.proceedToDefaultHandling) return;
    }
    // ============================================
    // PHASE 3: Default error handlers
    // ============================================
    if (errorReason === 'channelNotFound') {
        containerProps.setConversationError({
            type: 'conversationNotFound',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'channelNotFound', storeError);
        return;
    }
    if (errorReason === 'noActiveConversation') {
        containerProps.setConversationError({
            type: 'conversationEmptyOrNotPresentInStore',
            underlyingError: storeError
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'noActiveConversation', storeError);
        if (storeError.message_template === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).ROVO_PRODUCT_NOT_ACTIVE) containerProps.setRovoEnabled(false, storeError.message_template);
        return;
    }
    const currentConversationId = getState().currentConversationId;
    if (errorReason === 'rateLimited') {
        const rateLimitState = props?.getRateLimitState?.(args) ?? {};
        setState({
            conversations: {
                ...getState().conversations,
                [currentConversationId]: {
                    ...getState().conversations[currentConversationId],
                    ...(0, $cteoa.clearStatus)({
                        lastAgentMessageStatus: 'FAILED'
                    })
                }
            }
        });
        containerProps.setConversationError({
            type: 'rateLimited',
            underlyingError: storeError,
            rateLimitedActionType: rateLimitState.isDeepResearchAttempt ? 'deep-research' : 'generic'
        });
        $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'rateLimited', storeError);
        return;
    }
    dispatch(setConversationData({
        conversationId: currentConversationId,
        data: {
            ...(0, $cteoa.clearStatus)({
                lastAgentMessageStatus: 'FAILED'
            })
        }
    }));
    containerProps.setMessages(currentConversationId, [
        ...containerProps.getMessages(currentConversationId),
        storeError
    ]);
    const errorAttributes = error?.errorAttributes;
    containerProps.experienceTracker.fail({
        name: (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        error: error instanceof Error ? error : new Error(String(error)),
        attributes: {
            latestStreamMessageType: errorAttributes?.latestStreamMessageType,
            latestStreamMessageMillisOffset: errorAttributes?.latestStreamMessageMillisOffset
        }
    });
    $434fbbd3906b07f0$var$reportChatError(containerProps.sendAnalyticsEvent, 'generic', storeError);
};





/**
 * Util action to initialize conversation with conversationId
 */ const $0b6866794de633f9$var$initializeConversationData = ({ conversationId: conversationId, data: conversationData })=>({ getState: getState, setState: setState })=>{
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    ...conversationData
                }
            }
        });
    };
/**
 * Util action to allow updating the conversation based on `conversationId`
 * without needing to keep spreading the existing
 *
 * Similar to `initializeConversationData`, the difference is, it will not allow the the data to be updated if there is no existing conversation
 */ const $0b6866794de633f9$var$setConversationData = ({ conversationId: conversationId, data: conversationData })=>({ getState: getState, setState: setState })=>{
        if (!getState().conversations[conversationId]) return;
        setState({
            conversations: {
                ...getState().conversations,
                [conversationId]: {
                    ...getState().conversations[conversationId] ?? {},
                    ...conversationData
                }
            }
        });
    };
/**
 * Utils function to remove conversation from store
 */ const $0b6866794de633f9$var$removeConversationFromStore = ({ conversationId: conversationId })=>({ getState: getState, setState: setState })=>{
        const { [conversationId]: _, ...otherConversations } = getState().conversations;
        setState({
            conversations: otherConversations
        });
    };
const $0b6866794de633f9$export$f65ce059a9114838 = (actionLoggableName, actionHOF, props)=>(...args)=>async (api, containerProps)=>{
            /*
    Add custom logic here
   */ // General try/catch statement to handle unexpected errors
            try {
                (0, $1yaYZ.addSentryBreadcrumb)(`createSafeAction: executing ${actionLoggableName}`);
                // Here we call the action callback
                // Same as dispatch(actionHOF)
                const action = actionHOF(...args);
                // Here we execute the action i.e. what happens internally when the action is dispatched
                const result = await action(api, containerProps);
                return result;
            } catch (error) {
                (0, $434fbbd3906b07f0$export$769f721a7d2183c3)({
                    args: args,
                    api: api,
                    actionLoggableName: actionLoggableName,
                    error: error,
                    containerProps: containerProps,
                    setConversationData: $0b6866794de633f9$var$setConversationData,
                    experienceName: props?.experienceName,
                    getRateLimitState: props?.getRateLimitState,
                    actionErrorHandler: props?.actionErrorHandler
                });
                return undefined;
            }
        };
/**
 * ************************************************************
 * Private Actions
 * ************************************************************
 */ const $0b6866794de633f9$var$addStoreChatItem = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addStoreChatItem, ({ message: message, conversationId: conversationIdParam })=>({ getState: getState }, { setMessages: setMessages, getMessages: getMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        setMessages(conversationId, [
            ...getMessages(conversationId),
            message
        ]);
    });
const $0b6866794de633f9$var$addHumanMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addHumanMessage, ({ id: id, content: content, conversationId: conversationIdParam, isFromSeededConversation: isFromSeededConversation = false, requestId: requestId, fileUploads: fileUploads })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreHuman)(id, content, isFromSeededConversation, requestId, fileUploads),
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$addAssistantMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addAssistantMessage, ({ id: id, content: content, conversationId: conversationIdParam, agentNamedId: agentNamedId })=>({ getState: getState, dispatch: dispatch })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreAssistant)({
                id: id,
                content: content,
                agentNamedId: agentNamedId,
                conversationId: conversationId
            }),
            conversationId: conversationId
        }));
    });
/**
 * ************************************************************
 * Public Actions
 * ************************************************************
 */ const $0b6866794de633f9$var$clearFollowUpMessages = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).clearFollowUpMessages, ({ conversationId: conversationIdParam })=>({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>!(0, $bPHr8.isStoreFollowUp)(message));
        setMessages(conversationId, filteredMessages);
    });
const $0b6866794de633f9$var$isNtpFullChatParityWithModeEnabled = ()=>(0, $c6GJD.default).getExperimentValue('rovo-extension-ntp-full-chat-parity-with-mode', 'chatModeEnabled', false, {
        fireExperimentExposure: false
    });
/**
 * Send a message to the assistant and add it to react-sweet-state
 *
 * @param agentId -- this parameter will be prioritised over agent.id
 */ const $0b6866794de633f9$var$sendMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).sendMessage, (props)=>(0, $54793c520b6b8872$export$9558791053c77c34)({
        ...props,
        setConversationData: $0b6866794de633f9$var$setConversationData,
        createConversationOptimistically: $0b6866794de633f9$var$createConversationOptimistically,
        addHumanMessage: $0b6866794de633f9$var$addHumanMessage,
        addAssistantMessage: $0b6866794de633f9$var$addAssistantMessage,
        clearFollowUpMessages: $0b6866794de633f9$var$clearFollowUpMessages,
        setSelectedConversation: $0b6866794de633f9$var$setSelectedConversation,
        reconnectToInProgressStream: $0b6866794de633f9$var$reconnectToInProgressStream,
        updateConversation: $0b6866794de633f9$var$updateConversation
    }), {
    experienceName: (args)=>(0, $16lEl.sendMessageExperienceName)({
            deepResearchEnabled: args[0]?.deepResearchEnabled,
            thinkDeeperEnabled: args[0]?.thinkDeeperEnabled,
            fastModeEnabled: args[0]?.fastModeEnabled
        }),
    getRateLimitState: (args)=>({
            isDeepResearchAttempt: args[0]?.deepResearchEnabled
        })
});
/**
 * Similar action to `sendMessage` with the barebone functionalities to confirm tools/skills/actions
 *
 * Initially this will assume that this function only created on existing conversation
 */ const $0b6866794de633f9$var$sendMessageConfirmedTools = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).sendMessageConfirmedTools, ({ conversationId: conversationIdParam, agentId: agentId, confirmed_tools: confirmed_tools, messageSources: messageSources })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages, trackAIMAUEvent: trackAIMAUEvent, trackAgentEvent: trackAgentEvent })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        // Collection of callbacks for experience and performance tracking
        const expAndPerfTrackers = {
            start: ()=>{
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    id: conversationId,
                    attributes: {
                        conversationId: conversationId,
                        interactionSource: messageSources?.interactionSource
                    }
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.start();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.start();
            },
            firstAnswerPartReceived: ()=>{
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            succeed: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
            },
            aupError: ()=>{
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            },
            agentDeactivated: ({ error: error })=>{
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    error: error
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            abort: ()=>{
                experienceTracker.abort({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    reason: 'Aborted'
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.cancel();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.cancel();
            },
            fail: ({ error: error })=>{
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                    error: error
                });
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFinishStream.stop();
                (0, $1K4cm.interactionMetrics).sendConfirmedToolsTimeToFirstAnswerPart.stop();
            }
        };
        const trackingAttributes = {
            isRovoCustomAgent: (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId),
            sendMessageReason: 'TOOLS_CONFIRMATION'
        };
        const agentAnalyticsAttributes = {
            touchPoint: 'chatSendMessageConfirmedTools',
            tools: confirmed_tools.tools.map((tool)=>({
                    toolId: tool.tool_id ?? 'UNKNOWN_TOOL_ID',
                    toolSource: tool.tool_source ?? 'UNKNOWN_TOOL_SOURCE',
                    resolutionType: tool.resolution?.type ?? 'UNKNOWN_RESOLUTION_TYPE'
                }))
        };
        // Collection of callbacks for analytics tracking
        const analyticsTrackers = {
            /**
     * There are 2 AIMAU events here, because in resumption we're doing 2 things
     * 1. We're confirming the previous tools result
     * 2. And the confirmation triggers a LLM chat streaming
     */ initiated: ({ timestamp: timestamp })=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'actioned',
                    actionResult: 'toolsExecutionConfirmed',
                    proactive: true,
                    singleInstrumentationID: trackingAttributes.instrumentationId
                });
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'initiated',
                    subjectId: messageSources?.interactionSource,
                    proactive: true,
                    userGenerated: false,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: timestamp
                });
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionConfirmed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            },
            aborted: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'dismissed',
                    proactive: true,
                    userGenerated: false,
                    messageId: trackingAttributes.messageId,
                    singleInstrumentationID: trackingAttributes.instrumentationId
                });
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionStreamStopped',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            },
            viewed: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'viewed',
                    proactive: true,
                    userGenerated: false,
                    source: messageSources?.interactionSource,
                    messageId: trackingAttributes.messageId,
                    subjectId: messageSources?.followUpSource,
                    citedProductList: {},
                    sourceProducts: {},
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString()
                });
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultViewed',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId,
                        scenarioId: trackingAttributes.scenarioId
                    }
                });
            },
            error: ()=>{
                trackAIMAUEvent({
                    ...trackingAttributes,
                    type: 'error',
                    proactive: true,
                    userGenerated: false,
                    messageId: trackingAttributes.requestId,
                    singleInstrumentationID: trackingAttributes.instrumentationId,
                    timestamp: new Date().toISOString()
                });
                if (agentId && (0, $e81fd5fde2bdb998$export$c9b02612b90eeb6c)(agentId)) trackAgentEvent({
                    action: 'toolsExecutionResultError',
                    actionSubject: 'rovoAgent',
                    attributes: {
                        ...trackingAttributes,
                        ...agentAnalyticsAttributes,
                        agentId: agentId,
                        singleInstrumentationId: trackingAttributes.instrumentationId
                    }
                });
            }
        };
        const updateCurrentConversation = (data)=>{
            dispatch($0b6866794de633f9$var$setConversationData({
                conversationId: conversationId,
                data: data
            }));
        };
        const { abortController: abortController, storeAbortController: storeAbortController, confirmAbort: confirmAbort } = (0, $3ba7c8b5e2cd14b7$export$cb6128fc3a3c8081)();
        let hasReceivedFinalResponse = false;
        let generator;
        let responseData;
        let hasLoggedInitiatedEvent = false;
        try {
            expAndPerfTrackers.start();
            // change the conversation status
            updateCurrentConversation({
                storeAbortController: storeAbortController,
                status: (0, $bPHr8.CHAT_STORE_STATUS).awaitingResponse,
                lastAgentMessageStatus: 'IN_PROGRESS'
            });
            // Only add assistant message
            const tmpAssistantMessageId = (0, $cteoa.generateTmpMessageId)(conversationId);
            dispatch($0b6866794de633f9$var$addAssistantMessage({
                id: tmpAssistantMessageId,
                content: '',
                conversationId: conversationId,
                agentNamedId: agentId
            }));
            dispatch($0b6866794de633f9$var$clearFollowUpMessages({
                conversationId: conversationId
            }));
            trackingAttributes.messageId = tmpAssistantMessageId;
            trackingAttributes.instrumentationId = tmpAssistantMessageId;
            // Assumed the insert is successful and inserts at the last position
            const answerIndex = getMessages(conversationId).length - 1;
            // Call the BE endpoint
            trackingAttributes.initiatedTimestamp = new Date().toISOString();
            const response = await assistanceService.sendMessageConfirmedTools({
                conversationId: conversationId,
                agentId: agentId,
                confirmed_tools: confirmed_tools,
                controller: abortController,
                optInSSEStream: true
            });
            generator = response.generator;
            responseData = response.responseData;
            /**
     * --------
     * Stream processing START
     * --------
     */ updateCurrentConversation({
                status: (0, $bPHr8.CHAT_STORE_STATUS).typingResponse
            });
            for await (const streamObj of generator){
                const streamMessage = (0, $ljUdP.isSSEMessage)(streamObj) ? streamObj.data : streamObj;
                /**
       * Conversation channel data processing (usually the first stream part)
       */ if ((0, $ljUdP.isConversationChannelDataMessage)(streamMessage)) {
                    const agentMessageId = streamMessage.assistant_message_id;
                    trackingAttributes.instrumentationId = agentMessageId;
                    trackingAttributes.messageId = agentMessageId;
                    analyticsTrackers.initiated({
                        timestamp: trackingAttributes.initiatedTimestamp
                    });
                    hasLoggedInitiatedEvent = true;
                }
                /**
       * Trace processing
       */ if ((0, $ljUdP.isStreamTrace)(streamMessage)) {
                    if (!trackingAttributes.requestId) trackingAttributes.requestId = streamMessage.metadata?.request_id;
                    updateCurrentConversation({
                        traces: (0, $54793c520b6b8872$export$9ac25e0768639c5d)([
                            ...getState().conversations[conversationId]?.traces ?? [],
                            (0, $cteoa.getTraceFromStreamMessage)(streamMessage)
                        ])
                    });
                }
                /**
       * Answer part processing
       */ if ((0, $ljUdP.isStreamAnswerPart)(streamMessage)) {
                    expAndPerfTrackers.firstAnswerPartReceived();
                    (0, $54793c520b6b8872$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, (0, $cteoa.addAnswerPart)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        answerPart: streamMessage,
                        useIndex: answerIndex
                    }));
                }
                /**
       * Final response processing
       */ if ((0, $ljUdP.isStreamResponse)(streamMessage)) {
                    hasReceivedFinalResponse = true;
                    const humanMessageId = streamMessage?.message?.human_message?.id.toString();
                    (0, $54793c520b6b8872$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, (0, $cteoa.replaceAnswerData)({
                        chat: getMessages(conversationId),
                        answerId: tmpAssistantMessageId,
                        content: streamMessage,
                        useIndex: answerIndex,
                        humanMessageId: humanMessageId
                    }));
                    trackingAttributes.humanMessageId = humanMessageId;
                    trackingAttributes.scenarioId = streamMessage.message.message?.scenario?.id;
                    if (!hasLoggedInitiatedEvent) {
                        const agentMessageId = streamMessage?.message?.message?.id.toString();
                        trackingAttributes.messageId = agentMessageId;
                        trackingAttributes.instrumentationId = agentMessageId;
                    }
                }
                /**
       * Follow up processing
       */ if ((0, $ljUdP.isFollowUpMessage)(streamMessage)) {
                    const messages = getMessages(conversationId);
                    (0, $54793c520b6b8872$export$d30a5acf6cceb893)(getState, conversationId, updateCurrentConversation);
                    setMessages(conversationId, [
                        ...messages,
                        {
                            type: 'FOLLOW_UP',
                            content: streamMessage,
                            id: (0, $a37fef51f047b95d$export$bac56f3fc527f04b)(0, 1000000),
                            agentMessageId: (0, $cteoa.getLastAgentMessageID)(messages),
                            humanMessageId: trackingAttributes.humanMessageId
                        }
                    ]);
                }
                /**
       * Error processing
       */ if ((0, $ljUdP.isStreamError)(streamMessage)) {
                    const { message: message, metadata: metadata, millisOffset: millisOffset, type: type } = streamMessage;
                    // AUP violations are still considered successful
                    if ((0, $ljUdP.isStreamAUPError)(streamMessage)) expAndPerfTrackers.aupError();
                    throw new (0, $iEWar.StreamErrorException)(message?.content || 'Unknown', {
                        detail: {
                            message: message,
                            metadata: metadata,
                            millisOffset: millisOffset,
                            type: type
                        },
                        traceId: response.responseData?.traceId
                    });
                }
            }
        } catch (error) {
            const isAgentDeactivated = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_DEACTIVATED);
            const isNoAgentPermission = error instanceof (0, $flpNp.ApiError) && error.errorAttributes.errorCode?.includes((0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).AGENT_FORBIDDEN) && (0, $dh538.fg)('convo-ai-enable-agents-use-permission');
            if (isAgentDeactivated || isNoAgentPermission) {
                expAndPerfTrackers.agentDeactivated({
                    error: error
                });
                updateCurrentConversation({
                    status: (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError,
                    traces: [],
                    errorCode: (0, $dh538.fg)('convo-ai-enable-agents-use-permission') ? error.errorAttributes.errorCode : undefined
                });
                !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                    timestamp: trackingAttributes.initiatedTimestamp
                });
                analyticsTrackers.error();
                return;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                expAndPerfTrackers.abort();
                confirmAbort();
                !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                    timestamp: trackingAttributes.initiatedTimestamp
                });
                analyticsTrackers.aborted();
                return;
            }
            expAndPerfTrackers.fail({
                error: error instanceof Error ? error : new Error(String(error))
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        } finally{
            updateCurrentConversation((0, $cteoa.clearStatus)({}));
            setMessages(conversationId, (0, $cteoa.markStreamingMessagesAsComplete)(getMessages(conversationId)));
        }
        /**
   * --------
   * Stream processing END
   * --------
   */ // if stream finishes without FINAL_RESPONSE, BE is hanging
        if (!hasReceivedFinalResponse) {
            const error = new (0, $iEWar.NoFinalResponseError)('The response took too long and timed out. Try refreshing the page.', {
                traceId: responseData?.traceId
            });
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).SEND_CONFIRMED_TOOLS_MESSAGE,
                error: error
            });
            !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
                timestamp: trackingAttributes.initiatedTimestamp
            });
            analyticsTrackers.error();
            throw error;
        }
        !hasLoggedInitiatedEvent && analyticsTrackers.initiated({
            timestamp: trackingAttributes.initiatedTimestamp
        });
        analyticsTrackers.viewed();
        expAndPerfTrackers.succeed();
    });
const $0b6866794de633f9$var$removeMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).removeMessage, ({ messageId: messageId, conversationId: conversationIdParam })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const filteredMessages = messages.filter((message)=>{
            if ((0, $bPHr8.isStoreError)(message) || (0, $bPHr8.isStoreFollowUp)(message)) return message.id !== messageId;
            else if ((0, $bPHr8.isStoreHuman)(message)) return message.content.id !== String(messageId);
            else return true;
        });
        setMessages(conversationId, filteredMessages);
    });
/**
 * Reconnects to an in-progress message stream when loading a conversation
 * where the last message has async_status 'IN_PROGRESS'
 * Currently only connects to Deep Research messages
 */ const $0b6866794de633f9$var$reconnectToInProgressStream = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).reconnectToInProgressStream, ({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, isDeepResearch: isDeepResearch, abortCurrentRequest: abortCurrentRequest, answerIndex: answerIndex, onComplete: onComplete, isAutoReconnect: isAutoReconnect })=>(0, $f0918ff6cbefa0f7$export$d8454bf5b2ffdf29)({
        conversationId: conversationId,
        messageId: messageId,
        lastEventId: lastEventId,
        isDeepResearch: isDeepResearch,
        abortCurrentRequest: abortCurrentRequest,
        answerIndex: answerIndex,
        onComplete: onComplete,
        isAutoReconnect: isAutoReconnect,
        setConversationData: $0b6866794de633f9$var$setConversationData
    }), {
    experienceName: ()=>(0, $16lEl.ExperienceName).RECONNECT_TO_ACTIVE_STREAM
});
const $0b6866794de633f9$var$fetchConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).fetchConversation, ({ conversationId: conversationIdParam, messageIdSelectedForPreview: messageIdSelectedForPreview })=>async ({ getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, setMessages: setMessages, showFlag: showFlag })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const conversation = getState().conversations[conversationId];
        if (conversation?.status !== (0, $bPHr8.CHAT_STORE_STATUS).idle || (0, $cteoa.isEmptyConversation)(conversationId)) return;
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).FETCH_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        if (conversation.storeAbortController) await conversation.storeAbortController?.abort();
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: conversationId,
            data: {
                id: conversationId,
                name: conversation.name,
                timeCreated: conversation.timeCreated,
                status: (0, $bPHr8.CHAT_STORE_STATUS).loadingChat,
                traces: messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled') ? [] : [
                    {
                        messageContent: 'Reloading chat',
                        status: 'loading'
                    }
                ],
                sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId)),
                messages: []
            }
        }));
        let serviceChat;
        try {
            serviceChat = await assistanceService.getChat(conversationId);
        } catch (e) {
            if ((0, $ljUdP.isChannelNotFoundError)(e)) {
                //We succeed this event because in sendMessage, we create a new channel if we receive a 404 response
                // Users will not see this error, so exclude it from Sentry
                //This is a fix due to an incompatible BE API change
                sendAnalyticsEvent({
                    eventType: 'operational',
                    action: 'notFound',
                    actionSubject: 'rovoChatFetchConversation'
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).FETCH_CHAT
                });
                dispatch($0b6866794de633f9$var$createConversationOptimistically({
                    sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
                }));
                dispatch($0b6866794de633f9$var$removeConversationFromStore({
                    conversationId: conversationId
                }));
                if ((0, $dh538.fg)('rovo_supress_deleted_convo_errors')) return;
            }
            if (e instanceof (0, $flpNp.ApiError) && e.errorAttributes?.statusCode === 403 && (0, $dh538.fg)('rovo_chat_improved_conversation_403_handling')) {
                const rovoParams = (0, $6FQwA.getRovoParams)();
                const isConversationIdInRovoParams = !!rovoParams?.conversationId;
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'forbidden',
                    actionSubject: 'rovoChatFetchConversation',
                    attributes: {
                        isConversationIdInRovoParams: isConversationIdInRovoParams
                    }
                });
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).FETCH_CHAT,
                    error: e
                });
                dispatch($0b6866794de633f9$var$removeConversationFromStore({
                    conversationId: conversationId
                }));
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
                }));
                if (isConversationIdInRovoParams) (0, $6FQwA.updatePageRovoParams)({
                    conversationId: undefined
                });
                showFlag?.((0, $5MDfE.StoreErrorFlagId).CONVERSATION_FORBIDDEN);
                return;
            }
            throw e;
        }
        // There's a bug currently in the playwright pubsub test where when adding in a new
        // async function to sendMessageStream it causes the message to be dropped
        const status = getState().conversations[conversationId]?.status;
        if (status !== (0, $bPHr8.CHAT_STORE_STATUS).loadingChat) return;
        const latestMessages = serviceChat;
        const messages = [];
        for (const message of latestMessages){
            if ((0, $ljUdP.isHumanMessage)(message)) messages.push((0, $cteoa.createStoreHumanWithContent)(message));
            else if ((0, $ljUdP.isStreamResponse)(message)) {
                // Process boundary content for historical assistant messages
                let processedMessage = message;
                const markdownData = {};
                // Apply the same boundary content extraction logic as streaming messages
                if ((0, $dh538.fg)('rovo_enable_data_sculptor')) {
                    const sculptorMsg = (0, $cteoa.extractMarkdownContent)({
                        streamMessage: processedMessage,
                        boundaryStart: '[^sculptor:start^]',
                        boundaryEnd: '[^sculptor:end^]',
                        replacementContent: '[^sculptor^]'
                    });
                    processedMessage = sculptorMsg.processedStreamMessage;
                    sculptorMsg.boundaryContents.forEach((content, index)=>{
                        markdownData[`sculptor-${index}`] = content;
                    });
                }
                const expandOpenTag = "\u259E";
                const expandCloseTag = "\u259A";
                const expandPlaceholder = '[^expand^]';
                const expandMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: expandOpenTag,
                    boundaryEnd: expandCloseTag,
                    replacementContent: expandPlaceholder
                });
                processedMessage = expandMsg.processedStreamMessage;
                expandMsg.boundaryContents.forEach((content, index)=>{
                    markdownData[`expand-${index}`] = content;
                });
                const chartPlaceholder = '[^chart^]';
                // When processing conversation history, process both unicode and non-unicode tags
                // to handle previous conversations that used the non-unicode tag
                // Once di_chat_chart_tag_unicode is rolled out, chartMsg can be removed after 30 days
                let chartIndex = 0;
                const chartMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: '[^chart:start^]',
                    boundaryEnd: '[^chart:end^]',
                    replacementContent: chartPlaceholder
                });
                processedMessage = chartMsg.processedStreamMessage;
                chartMsg.boundaryContents.forEach((content)=>{
                    markdownData[`chart-${chartIndex}`] = content;
                    chartIndex++;
                });
                if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'extracted',
                    actionSubject: 'vizPluginChartNonUnicode',
                    attributes: {
                        messageId: message?.message?.message?.id.toString(),
                        conversationId: conversationId,
                        chartCount: chartMsg.boundaryContents.length,
                        timestamp: new Date().toISOString()
                    }
                });
                const unicodeChartMsg = (0, $cteoa.extractMarkdownContent)({
                    streamMessage: processedMessage,
                    boundaryStart: "\u25F4",
                    boundaryEnd: "\u25F6",
                    replacementContent: chartPlaceholder
                });
                processedMessage = unicodeChartMsg.processedStreamMessage;
                unicodeChartMsg.boundaryContents.forEach((content)=>{
                    markdownData[`chart-${chartIndex}`] = content;
                    chartIndex++;
                });
                // Create StoreAssistant with processed boundary data
                const storeAssistant = (0, $cteoa.createStoreAssistantWithContent)(processedMessage);
                if (Object.keys(markdownData).length > 0) storeAssistant.markdownData = markdownData;
                messages.push(storeAssistant);
            }
        }
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: {
                ...(0, $cteoa.clearStatus)({
                    lastAgentMessageStatus: 'SUCCESSFUL'
                }),
                sourceAgentId: (0, $cteoa.getSourceAgentId)(getMessages(conversationId), (0, $cteoa.getConversation)(getState(), conversationId))
            }
        }));
        // Check if the last message has async_status 'IN_PROGRESS' and reconnect to the stream
        const lastMessage = latestMessages.at(-1);
        const isDeepResearch = lastMessage?.message?.message?.message_metadata?.deep_research;
        if ((0, $ljUdP.isInProgressStreamResponse)(lastMessage) && isDeepResearch && (0, $c6GJD.default).getExperimentValue('rovo_sse_reconnect_experiment', 'isEnabled', false)) {
            const messageId = lastMessage.message.message.id;
            // Clear the "Message is in progress" content of the last agent message
            const updatedMessages = (0, $cteoa.clearStoreAssistantMessageContent)(messages, messageId);
            setMessages(conversationId, updatedMessages);
            dispatch($0b6866794de633f9$var$reconnectToInProgressStream({
                conversationId: conversationId,
                messageId: messageId,
                isDeepResearch: isDeepResearch,
                isAutoReconnect: true
            }));
        } else setMessages(conversationId, messages);
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).FETCH_CHAT
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).FETCH_CHAT
});
// Abort requests for a specific conversation, or ALL conversations if no conversationId is passed
const $0b6866794de633f9$var$abortRequests = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).abortRequests, ({ conversationId: conversationId, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, deepResearchEnabled: deepResearchEnabled } = {})=>({ getState: getState }, { experienceTracker: experienceTracker })=>{
        const conversations = getState().conversations;
        const abortConversationStream = (conversation)=>{
            if (conversation?.storeAbortController) {
                experienceTracker.start({
                    name: (0, $16lEl.ExperienceName).ABORT_AGENT_STREAM,
                    id: conversation?.id,
                    attributes: {
                        conversationId: conversation?.id
                    }
                });
                conversation.storeAbortController.abort();
                experienceTracker.abort({
                    name: (0, $16lEl.sendMessageExperienceName)({
                        deepResearchEnabled: deepResearchEnabled,
                        thinkDeeperEnabled: thinkDeeperEnabled,
                        fastModeEnabled: fastModeEnabled
                    }),
                    reason: 'Aborted',
                    attributes: {
                        isProgrammaticAbort: true
                    }
                });
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).ABORT_AGENT_STREAM
                });
            }
        };
        if (conversationId) abortConversationStream(conversations[conversationId]);
        else Object.values(conversations).forEach(abortConversationStream);
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).ABORT_AGENT_STREAM
});
/**
 * Triggers Answer Now functionality to fast-forward extended thinking.
 * This action performs an optimistic update:
 * 1. Sets answerNowStatus to SWITCHING immediately
 * 2. Calls the Answer Now API endpoint
 * 3. Sets status to ERRORED if API call fails (hides button, prevents retry)
 *
 * Note: Research steps and message content are NOT cleared here - they continue
 * to be displayed during SWITCHING. Clearing happens when FAST_MODE_ENABLED is received.
 */ const $0b6866794de633f9$var$answerNow = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).answerNow, ({ conversationId: conversationIdParam, tmpMessageId: tmpMessageId, remoteMessageId: remoteMessageId })=>async ({ getState: getState, setState: setState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, getMessages: getMessages, setMessages: setMessages })=>{
        const conversationId = conversationIdParam ?? getState().currentConversationId;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        // Helper to update conversation traces
        const updateConversationTrace = (traceMessage)=>{
            const state = getState();
            const conversation = state.conversations[conversationId];
            if (conversation) setState({
                conversations: {
                    ...state.conversations,
                    [conversationId]: {
                        ...conversation,
                        traces: [
                            {
                                messageContent: traceMessage
                            }
                        ]
                    }
                }
            });
        };
        // Verify the message exists and has answerNowStatus === AVAILABLE
        // Also prevents duplicate requests if status is already SWITCHING
        const messages = getMessages(conversationId);
        const targetMessage = messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
        if (!targetMessage || !(0, $bPHr8.isStoreAssistant)(targetMessage) || !(0, $bPHr8.isAnswerNowAvailable)(targetMessage.answerNowStatus)) return;
        // Optimistic update: Set SWITCHING status first and update trace message
        const updatedMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(getMessages(conversationId), tmpMessageId, {
            type: (0, $bPHr8.AnswerNowStatusType).SWITCHING
        });
        setMessages(conversationId, updatedMessages);
        updateConversationTrace('Generating answer now!');
        // Start experience tracking
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).ANSWER_NOW,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                remoteMessageId: remoteMessageId,
                tmpMessageId: tmpMessageId
            }
        });
        try {
            // Call the Answer Now API with the remote (BE-provided) message ID
            await assistanceService.answerNow(conversationId, remoteMessageId);
            // Only set SWITCHING_REQUESTED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $bPHr8.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $bPHr8.AnswerNowStatusType).SWITCHING) {
                const successMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).SWITCHING_REQUESTED
                });
                setMessages(conversationId, successMessages);
            }
            // Track success
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).ANSWER_NOW
            });
        } catch (error) {
            // Only set ERRORED if status is still SWITCHING (race condition guard)
            const currentMessages = getMessages(conversationId);
            const currentMessage = currentMessages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content?.message?.message?.id === tmpMessageId);
            if (currentMessage && (0, $bPHr8.isStoreAssistant)(currentMessage) && currentMessage.answerNowStatus?.type === (0, $bPHr8.AnswerNowStatusType).SWITCHING) {
                const erroredMessages = (0, $cteoa.updateStoreAssistantMessageAnswerNowStatus)(currentMessages, tmpMessageId, {
                    type: (0, $bPHr8.AnswerNowStatusType).ERRORED
                });
                setMessages(conversationId, erroredMessages);
                updateConversationTrace('Generating faster answer failed, continuing with current mode');
            }
            // Track failure
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).ANSWER_NOW,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    });
const $0b6866794de633f9$var$addErrorMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addErrorMessage, ({ error: error, conversationId: conversationId, errorPrefix: errorPrefix })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$addStoreChatItem({
            message: (0, $cteoa.createStoreError)(error, errorPrefix),
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$initConversationChannelsData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).initConversationChannelsData, ({ autoSelectConversation: autoSelectConversation = true, isInitialLoad: isInitialLoad = false } = {})=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { siteId: siteId, assistanceService: assistanceService, experienceTracker: experienceTracker, setChatStatus: setChatStatus, initChatInitiator: initChatInitiator, insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder, setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview })=>{
        if (isInitialLoad) experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD
        });
        else experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
        const rovoParams = (0, $6FQwA.getRovoParams)();
        let initWithParams = false;
        // Capture conversation IDs before API call to detect changes during the call
        const conversationsBeforeAPICall = new Set(Object.keys(getState().conversations));
        let channelsFromAPI = await assistanceService.getConversationChannels();
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const channelIds = new Set(channelsFromAPI.map((channel)=>channel.id));
        // Identify conversations deleted during the API call (were there before but aren't now)
        const conversationsDeletedDuringCall = new Set(Array.from(conversationsBeforeAPICall).filter((id)=>!conversations[id] && !(0, $cteoa.isEmptyConversation)(id)));
        // Identify conversations created during the API call (exist in state but weren't there before and aren't in API response)
        const conversationsCreatedDuringCall = new Set(Object.keys(conversations).filter((id)=>!conversationsBeforeAPICall.has(id) && !channelIds.has(id)));
        const processedChannels = channelsFromAPI.filter((channel)=>!conversationsDeletedDuringCall.has(channel.id)) // Exclude deleted conversations
        .reduce((acc, channel)=>{
            acc[channel.id] = (0, $c6GJD.default).getExperimentValue('rovo_chat_perf_init_load_optimization', 'isBackgroundConversationsFetchEnabled', false) ? (0, $90c63f46323387a6$export$60a662127f30e1e1)(channel, conversations[channel.id]) : conversations[channel.id] ?? {
                name: channel.name ?? (0, $99vXA.generateConversationName)(),
                id: channel.id,
                messages: [],
                status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                traces: [],
                timeCreated: channel.time_created,
                lastMessage: channel.last_message,
                lastMessageType: channel.last_message_type ?? [],
                lastMessageTimestamp: channel.last_message_timestamp,
                agent: channel.agent,
                lastAgentMessageStatus: channel.last_agent_message_status,
                read_status: channel.read_status
            };
            return acc;
        }, {});
        // Preserve conversations created during the API call to avoid race condition
        const conversationsToPreserve = Array.from(conversationsCreatedDuringCall).reduce((acc, id)=>{
            acc[id] = conversations[id];
            return acc;
        }, {});
        // Hydrate the store with the fetched conversation channels
        // whilst preserving the empty state and and any conversations created during the API call, so drafts are never lost
        // due to rehydration (e.g window refocus) when this is called
        setState({
            conversations: {
                EMPTY_CONVERSATION_ID: conversations[0, $2CHXX.EMPTY_CONVERSATION_ID],
                ...processedChannels,
                ...conversationsToPreserve
            }
        });
        if (rovoParams.stagingAreaOpen && (0, $dh538.fg)('aifc_create_enabled')) {
            setStagingAreaMode('inline', 'rovoChat');
            (0, $6FQwA.updatePageRovoParams)({
                stagingAreaOpen: undefined
            });
        }
        if (rovoParams.messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled')) {
            setMessageIdSelectedForPreview(rovoParams.messageIdSelectedForPreview);
            (0, $6FQwA.updatePageRovoParams)({
                messageIdSelectedForPreview: undefined
            });
        }
        if (rovoParams.triggerOpen) // if the rovo chat was actually open with url param
        initChatInitiator(rovoParams.initiator);
        // Process params as a priority
        if (autoSelectConversation && rovoParams.pathway === 'chat') {
            // Skip standard init if we're processing params
            // TODO: Logic will simplify dramatically when FF are cleaned up this just ensures a safe killswitch
            initWithParams = true;
            if (rovoParams.conversationId) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId
            }));
            else dispatch($0b6866794de633f9$var$createConversationOptimistically({
                sourceAgentId: rovoParams.agentId
            }));
            if (rovoParams.prompt) {
                // For cases where the prompt is a json string containing ADF, we need to parse it
                const shouldParse = (0, $cteoa.isValidAdfJsonString)(rovoParams.prompt);
                const prompt = shouldParse ? JSON.parse(rovoParams.prompt) : rovoParams.prompt;
                if (rovoParams.insertPrompt === 'highlight-action') insertHighlightActionsEditorPlaceholder(prompt);
                else dispatch($0b6866794de633f9$var$sendMessage({
                    prompt: (0, $4pEXC.encodeAdf)(prompt),
                    agentId: rovoParams.agentId,
                    // Default to false as a URL could be clicked from anywhere
                    // and we don't want store messages without the user knowing
                    // Getting preferences in the store would also required the hook to be passed
                    // on the  store container which is unncessary
                    storeUserMessages: false,
                    messageSources: {
                        interactionSource: 'urlParam'
                    }
                }));
            }
        }
        if (!initWithParams) {
            // If conversation isn't empty state and it doesn't exist on the server, then assume deleted
            // BUT: exclude conversations that were created during the API call
            const conversationDeleted = !(0, $cteoa.isEmptyConversation)(currentConversationId) && !channelIds.has(currentConversationId) && !conversationsCreatedDuringCall.has(currentConversationId);
            // Fallback conversation used when we cannot reliably select one
            // due to being deleted, or because there's no target chat in localStorage
            const fallbackConversation = Object.keys(processedChannels).find((id)=>!(0, $cteoa.isEmptyConversation)(id));
            const targetChatId = localStorage?.getItem((0, $cBi7Q.getChatLoadPreferenceKey)(siteId)) ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
            const targetChatExists = (0, $cteoa.isEmptyConversation)(targetChatId) || channelIds.has(targetChatId) || conversationsCreatedDuringCall.has(targetChatId);
            // Detect if conversation is idle, to prevent auto-selection occurring
            // when still awaiting a response to help prevent optimistic conversations
            // closing because the API doens't ye thave the new conversation ID for it
            // to show up in channelsFromAPI
            const currentConversationIdle = conversations[currentConversationId]?.status === (0, $bPHr8.CHAT_STORE_STATUS).idle;
            // WHEN autoSselectConversation is true (default behaviour, except for window refocus event)
            // AND current conversation is not the target conversation
            // OR the currently selected conversation is deleted (e.g. an old window is refocussed)
            const shouldSelectChat = autoSelectConversation && currentConversationId !== targetChatId || currentConversationIdle && conversationDeleted;
            const lastMessageSentAt = (0, $9963cc910aac4af3$export$1afac255ab1e880e)();
            const timeoutBeforeNewChat = (0, $cBi7Q.SHORTER_TIMEOUT_BEFORE_NEW_CHAT);
            if (autoSelectConversation && lastMessageSentAt && Date.now() - lastMessageSentAt >= timeoutBeforeNewChat) {
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
                }));
                (0, $9963cc910aac4af3$export$589976df4d188aac)(null);
            } else if (shouldSelectChat) {
                if (targetChatExists) // Prefer last seen chat
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: targetChatId
                }));
                else if (fallbackConversation) // Otherwise, fallback to the first non-empty conversation
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: fallbackConversation
                }));
                else dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
                }));
            }
        }
        // Set online status later, to ensure that pubsub listener doesn't race condition with store init state
        setChatStatus('online');
        experienceTracker.succeed({
            name: isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
    }, {
    experienceName: (args)=>args?.[0]?.isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
const $0b6866794de633f9$var$fetchConversationChannelsData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).initConversationChannelsData, ({ isInitialLoad: isInitialLoad = false } = {})=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        if (isInitialLoad) experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD
        });
        else experienceTracker.start({
            id: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
            name: (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
        // Capture conversation IDs before API call to detect changes during the call
        const conversationsBeforeAPICall = new Set(Object.keys(getState().conversations));
        let channelsFromAPI = await assistanceService.getConversationChannels();
        const { conversations: conversations, currentConversationId: currentConversationId } = getState();
        const channelIds = new Set(channelsFromAPI.map((channel)=>channel.id));
        // Identify conversations deleted during the API call (were there before but aren't now)
        const conversationsDeletedDuringCall = new Set(Array.from(conversationsBeforeAPICall).filter((id)=>!conversations[id] && !(0, $cteoa.isEmptyConversation)(id)));
        // Identify conversations created during the API call (exist in state but weren't there before and aren't in API response)
        const conversationsCreatedDuringCall = new Set(Object.keys(conversations).filter((id)=>!conversationsBeforeAPICall.has(id) && !channelIds.has(id)));
        // Preserve all local conversations not yet on the server
        // (they may have just finished processing or be in-flight)
        // e.g. optimistic conversation when URL params are used to open a chat
        const optimisticConversationsToPreserve = new Set(Object.keys(conversations).filter((id)=>!channelIds.has(id) && !(0, $cteoa.isEmptyConversation)(id)));
        const conversationIdsToPreserve = new Set([
            ...conversationsCreatedDuringCall,
            ...optimisticConversationsToPreserve
        ]);
        const conversationsToPreserve = Object.fromEntries(Array.from(conversationIdsToPreserve, (id)=>[
                id,
                conversations[id]
            ]));
        const processedChannels = channelsFromAPI.filter((channel)=>!conversationsDeletedDuringCall.has(channel.id)) // Exclude deleted conversations
        .reduce((acc, channel)=>{
            acc[channel.id] = (0, $90c63f46323387a6$export$60a662127f30e1e1)(channel, conversations[channel.id]);
            return acc;
        }, {});
        // Hydrate the store with the fetched conversation channels
        // whilst preserving the empty state and and any conversations created during the API call, so drafts are never lost
        // due to rehydration (e.g window refocus) when this is called
        setState({
            conversations: {
                EMPTY_CONVERSATION_ID: conversations[0, $2CHXX.EMPTY_CONVERSATION_ID],
                ...processedChannels,
                ...conversationsToPreserve
            }
        });
        const currentConversationDeleted = !(0, $cteoa.isEmptyConversation)(currentConversationId) && !channelIds.has(currentConversationId) && !conversationIdsToPreserve.has(currentConversationId);
        if (currentConversationDeleted && !isInitialLoad) dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
        }));
        experienceTracker.succeed({
            name: isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS
        });
    }, {
    experienceName: (args)=>args?.[0]?.isInitialLoad ? (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS_INITIAL_LOAD : (0, $16lEl.ExperienceName).GET_CONVERSATION_CHANNELS,
    actionErrorHandler: (context)=>{
        const { onError: onError, ...args } = context.args?.[0] ?? {};
        return onError ? onError({
            ...context,
            args: args
        }) : {
            proceedToDefaultHandling: true
        };
    }
});
const $0b6866794de633f9$var$getTimeoutBeforeExpiration = ()=>{
    return 0, $cBi7Q.SHORTER_TIMEOUT_BEFORE_NEW_CHAT;
};
/*
 * This action runs on initial load to hydrate this in-memory store (chatStore)
 * with data from either URL parameters or LocalStorage. URL parameters take precedence.
 *
 * Setting the currentConversationId (using setSelectedConversation or createConversationOptimistically)
 * may implicitly trigger fetching of conversation messages.
 *
 * Any change to currentConversationId will trigger a useEffect in ChatHistory,
 * which then executes the `fetchConversation` action.
 */ const $0b6866794de633f9$var$hydrateConversationWithExternalParams = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).hydrateConversation, ({ autoSelectConversation: autoSelectConversation })=>async ({ getState: getState, dispatch: dispatch }, { siteId: siteId, experienceTracker: experienceTracker, setChatStatus: setChatStatus, initChatInitiator: initChatInitiator, insertHighlightActionsEditorPlaceholder: insertHighlightActionsEditorPlaceholder, setStagingAreaMode: setStagingAreaMode, setMessageIdSelectedForPreview: setMessageIdSelectedForPreview, getStoreUserMessagesPreference: getStoreUserMessagesPreference })=>{
        experienceTracker.start({
            id: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION,
            name: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
        });
        const rovoParamsUnsanitized = (0, $6FQwA.getRovoParams)();
        const rovoParams = Object.fromEntries(Object.entries(rovoParamsUnsanitized).filter(([, v])=>v !== 'undefined'));
        let initWithParams = autoSelectConversation && rovoParams.pathway === 'chat';
        const { currentConversationId: currentConversationId } = getState();
        if (rovoParams.stagingAreaOpen && (0, $dh538.fg)('aifc_create_enabled')) {
            setStagingAreaMode('inline', 'rovoChat');
            (0, $6FQwA.updatePageRovoParams)({
                stagingAreaOpen: undefined
            });
        }
        if (rovoParams.messageIdSelectedForPreview && (0, $dh538.fg)('aifc_create_enabled')) {
            setMessageIdSelectedForPreview(rovoParams.messageIdSelectedForPreview);
            (0, $6FQwA.updatePageRovoParams)({
                messageIdSelectedForPreview: undefined
            });
        }
        if (rovoParams.triggerOpen) // if the rovo chat was actually open with url param
        initChatInitiator(rovoParams.initiator);
        // Process params as a priority
        if (initWithParams) {
            const localConversation = rovoParams.conversationId ? getState().conversations[rovoParams.conversationId] : undefined;
            if (rovoParams.conversationId && localConversation) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId
            }));
            else dispatch($0b6866794de633f9$var$createConversationOptimistically({
                id: rovoParams.conversationId,
                sourceAgentId: rovoParams.agentId
            }));
            if (rovoParams.prompt) {
                // For cases where the prompt is a json string containing ADF, we need to parse it
                const shouldParse = (0, $cteoa.isValidAdfJsonString)(rovoParams.prompt);
                const prompt = shouldParse ? JSON.parse(rovoParams.prompt) : rovoParams.prompt;
                if (rovoParams.insertPrompt === 'highlight-action') insertHighlightActionsEditorPlaceholder(prompt);
                else dispatch($0b6866794de633f9$var$sendMessage({
                    prompt: (0, $4pEXC.encodeAdf)(prompt),
                    agentId: rovoParams.agentId,
                    // Use the user's preference for storing messages
                    storeUserMessages: getStoreUserMessagesPreference?.() ?? false,
                    messageSources: {
                        interactionSource: 'urlParam'
                    }
                }));
            }
        } else if (autoSelectConversation) {
            const timeoutBeforeNewChat = $0b6866794de633f9$var$getTimeoutBeforeExpiration();
            const targetConversationId = localStorage?.getItem((0, $cBi7Q.getChatLoadPreferenceKey)(siteId)) ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
            const lastMessageSentAt = (0, $9963cc910aac4af3$export$1afac255ab1e880e)();
            const hasTargetChanged = targetConversationId !== currentConversationId;
            const isTargetExpired = lastMessageSentAt && Date.now() - lastMessageSentAt >= timeoutBeforeNewChat;
            const isTargetConversationEmpty = (0, $cteoa.isEmptyConversation)(targetConversationId);
            const hasLocalTargetConversation = Boolean(getState().conversations[targetConversationId]);
            // start new conversation: if recent expired
            if (isTargetExpired) {
                dispatch($0b6866794de633f9$var$setSelectedConversation({
                    conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
                }));
                (0, $9963cc910aac4af3$export$589976df4d188aac)(null);
            // start new conversation: if target conversation was set to new (e.g. in another tab)
            } else if (hasTargetChanged && isTargetConversationEmpty) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: (0, $2CHXX.EMPTY_CONVERSATION_ID)
            }));
            else if (hasTargetChanged && hasLocalTargetConversation) dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: targetConversationId
            }));
            else if (hasTargetChanged) dispatch($0b6866794de633f9$var$createConversationOptimistically({
                id: targetConversationId
            }));
        }
        // Set online status later, to ensure that pubsub listener doesn't race condition with store init state
        setChatStatus('online');
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).HYDRATE_CONVERSATION
});
const $0b6866794de633f9$var$addAgentMessage = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).addAgentMessage, ({ conversationId: conversationId, agentNamedId: agentNamedId, content: content })=>({ dispatch: dispatch })=>{
        dispatch($0b6866794de633f9$var$addAssistantMessage({
            id: (0, $cteoa.generateId)(),
            content: content,
            conversationId: conversationId,
            agentNamedId: agentNamedId
        }));
    });
const $0b6866794de633f9$var$handleChatOpenPubsubAction = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).handleChatOpenPubsubAction, ({ conversationId: conversationId })=>async ({ getState: getState, dispatch: dispatch })=>{
        // IF convo id is the current chat
        // refetch the chat, do not create new one
        if (conversationId === getState().currentConversationId) {
            dispatch($0b6866794de633f9$var$fetchConversation({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat already exist in conversation
        // switch to that convo -> and it will trigger refetch when ChatHistory is rendered
        if (getState().conversations[conversationId]) {
            dispatch($0b6866794de633f9$var$setSelectedConversation({
                conversationId: conversationId
            }));
            return;
        }
        // IF chat does not exist yet
        // Create conversation optimistically, which will switch to that conversation
        // By switching conversation, it will render ChatHistory
        // ChatHistory will auto fetch the chat data
        // if not found during `sendMessage`, it will auto create one and retry when encountered `404`
        dispatch($0b6866794de633f9$var$createConversationOptimistically({
            id: conversationId
        }));
    });
const $0b6866794de633f9$var$createConversationOptimistically = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).createConversationOptimistically, (options)=>async ({ dispatch: dispatch }, { setMessages: setMessages })=>{
        const conversationId = options?.id ?? (0, $2CHXX.EMPTY_CONVERSATION_ID);
        const time = new Date().toISOString();
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: conversationId,
            data: {
                id: conversationId,
                lastMessageTimestamp: options.lastMessageTimestamp ?? time,
                name: options.name ?? (0, $99vXA.generateConversationName)(),
                sourceAgentId: options.sourceAgentId,
                sourceId: options.sourceId ?? undefined,
                status: options?.status ?? (0, $bPHr8.CHAT_STORE_STATUS).idle,
                timeCreated: options?.timeCreated ?? time,
                traces: [],
                messages: [],
                lastMessageType: options?.lastMessageType ?? [],
                lastAgentMessageStatus: options?.lastAgentMessageStatus,
                ...options?.agent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? {
                    agent: options.agent
                } : {}
            }
        }));
        setMessages(conversationId, []);
        dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: conversationId
        }));
    });
const $0b6866794de633f9$var$createSeededConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).createSeededConversation, (options)=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker, sendAnalyticsEvent: sendAnalyticsEvent, setMessages: setMessages, getChatInitiator: getChatInitiator, onNewConversationStartingWithSendMessage: onNewConversationStartingWithSendMessage })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL,
            id: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
        const createdConversation = await assistanceService.createConversationChannel(options);
        const humanMessage = createdConversation.messages?.find((message)=>(0, $ljUdP.isHumanMessage)(message));
        const assistantMessage = createdConversation.messages?.find((message)=>(0, $ljUdP.isAssistantMessage)(message));
        const humanMessageId = humanMessage ? humanMessage.id : '';
        const assistantMessageId = assistantMessage ? assistantMessage.id : '';
        dispatch($0b6866794de633f9$var$initializeConversationData({
            conversationId: createdConversation.id,
            data: {
                id: createdConversation.id,
                name: createdConversation.name,
                timeCreated: createdConversation.time_created,
                status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
                traces: [],
                sourceId: options.sourceId ?? undefined,
                sourceAgentId: options.agentId,
                messages: [],
                ...createdConversation.agent && (0, $dh538.fg)('rovo_chat_chat_history_refresh') ? {
                    agent: createdConversation.agent
                } : {}
            }
        }));
        const chatInitiator = getChatInitiator();
        setMessages(createdConversation.id, options.dialogues.flatMap((dialogue)=>{
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'sent',
                actionSubject: 'message',
                attributes: {
                    messageId: humanMessageId,
                    interactionSource: 'movedOver',
                    followUpSource: options.followUpSource,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'received',
                actionSubject: 'agentMessage',
                attributes: {
                    messageId: assistantMessageId,
                    humanMessageId: humanMessageId,
                    pluginsInvoked: [],
                    hasSources: false,
                    timestamp: new Date().toISOString(),
                    initiator: chatInitiator
                }
            });
            return [
                (0, $cteoa.createStoreHuman)((0, $cteoa.generateId)(), dialogue.human_message.content, true),
                (0, $cteoa.createStoreAssistant)({
                    id: (0, $cteoa.generateId)(),
                    content: dialogue.agent_message.content
                })
            ];
        }));
        dispatch($0b6866794de633f9$var$setSelectedConversation({
            conversationId: createdConversation.id
        }));
        if ($0b6866794de633f9$var$isNtpFullChatParityWithModeEnabled() && options.mode && onNewConversationStartingWithSendMessage) onNewConversationStartingWithSendMessage(createdConversation.id, options.mode);
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
        });
    }, {
    experienceName: ()=>(0, $16lEl.ExperienceName).CREATE_SEEDED_CONVERSATION_CHANNEL
});
const $0b6866794de633f9$var$setSelectedConversation = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).setSelectedConversation, ({ conversationId: conversationId, sourceAgentId: sourceAgentId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { siteId: siteId })=>{
        let resolvedConversationId = conversationId;
        // Fallback to empty if target conversation doesn't exist
        if (!getState().conversations[conversationId]) resolvedConversationId = (0, $2CHXX.EMPTY_CONVERSATION_ID);
        // Select the conversation
        setState({
            currentConversationId: resolvedConversationId
        });
        // Select the agent if applicable
        if (sourceAgentId) dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: resolvedConversationId,
            data: {
                sourceAgentId: sourceAgentId
            }
        }));
        if ((0, $dh538.fg)('rovo_chat_chat_history_refresh')) {
            if (resolvedConversationId !== (0, $2CHXX.EMPTY_CONVERSATION_ID)) dispatch($0b6866794de633f9$var$updateConversation({
                conversationId: resolvedConversationId,
                data: {
                    read_status: true
                }
            }));
        }
        // Store preference
        localStorage?.setItem((0, $cBi7Q.getChatLoadPreferenceKey)(siteId), resolvedConversationId);
    });
const $0b6866794de633f9$var$updateActionInvocationStatus = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionInvocationStatus, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, status: status })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        updatedMessages[agentMessage.index] = {
            ...agentMessage.result,
            invokedActions: {
                ...agentMessage.result.invokedActions,
                [invocationId]: status
            }
        };
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateActionData = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).updateActionData, ({ conversationId: conversationId, messageId: messageId, invocationId: invocationId, data: data })=>async ({ getState: getState }, { getMessages: getMessages, setMessages: setMessages })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const messages = getMessages(conversationId);
        const agentMessage = (0, $cteoa.getAgentMessageById)(messages, messageId);
        if (!agentMessage.result) return;
        const updatedMessages = [
            ...messages
        ];
        agentMessage.result.content.message.message.actions?.forEach((action)=>{
            if (action.invocationId === invocationId) action.data = {
                ...action.data,
                ...data
            };
        });
        updatedMessages[agentMessage.index] = agentMessage.result;
        setMessages(conversationId, updatedMessages);
    });
const $0b6866794de633f9$var$updateConversation = ({ conversationId: conversationId, data: data })=>async ({ dispatch: dispatch }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker?.start({
            name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        try {
            await assistanceService?.updateConversationChannel(conversationId, data);
        } catch (error) {
            experienceTracker?.fail({
                name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL,
                error: error
            });
            throw error;
        }
        dispatch($0b6866794de633f9$var$setConversationData({
            conversationId: conversationId,
            data: data
        }));
        experienceTracker?.succeed({
            name: (0, $16lEl.ExperienceName).UPDATE_CONVERSATION_CHANNEL
        });
    };
const $0b6866794de633f9$var$resolveConversationAction = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).resolveConversationAction, ({ conversationId: conversationId, messageId: messageId, payload: payload, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false, skipExperienceTracking: skipExperienceTracking = false })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker, trackAIMAUEvent: trackAIMAUEvent, sendAnalyticsEvent: sendAnalyticsEvent, getMessages: getMessages, broadcastConfirmedActions: broadcastConfirmedActions, chatContextStoreActions: chatContextStoreActions })=>{
        let actionCallbackData;
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return;
        const humanMessageId = (0, $cteoa.getAssociatedHumanMessageId)(getMessages(conversationId), messageId);
        const featureArea = chatContextStoreActions.getIsStagingArea() ? 'aifc-staging-area' : 'unknown';
        const attributes = {
            conversationId: conversationId,
            resolution: payload.context.resolution,
            actionKey: payload.context.key
        };
        if (!skipExperienceTracking) experienceTracker.start({
            name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            id: conversationId,
            attributes: attributes
        });
        try {
            const { invocationId: invocationId } = payload.context;
            // Set actions loading state
            dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                status: 'started'
            }));
            const response = await assistanceService.resolveConversationAction(conversationId, payload);
            const { message: message } = response;
            dispatch($0b6866794de633f9$var$updateActionData({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: invocationId,
                data: payload.context.data
            }));
            /*
    	For the update work item action, we do not want to display multiple agent messages for bulk actions.
    	As a temporary fix for EAP, we are disabling the response message for the update work item action. The
    	BE returns an empty message string for our action, and this override ensures the invocation status is not
    	errored. This has been approved by the ai-mate team.
    	https://atlassian.slack.com/archives/C0677M19GU9/p1763685677656329
    		TODO: We should refactor this to use the skipSuccessOptimisticAssistantResponse prop in the future
    	for the update work action renderers. https://jplat.atlassian.net/browse/GRAVITYAI-4373
    */ const jiraUpdateSingleFieldsActionOverride = payload.context.key === (0, $8IKbl.ActionKeys).UpdateWorkItemFields || payload.context.key === (0, $8IKbl.ActionKeys).UpdateWorkItemAllFieldTypes;
            // Display a new agent message from the response to reflect the change in chat history
            if ((0, $ljUdP.isAssistantMessage)(message) && (!!message.content || jiraUpdateSingleFieldsActionOverride)) {
                if (!skipSuccessOptimisticAssistantResponse) dispatch($0b6866794de633f9$var$addAssistantMessage({
                    agentNamedId: message.author?.named_id,
                    content: message.content,
                    conversationId: conversationId,
                    id: message.id
                }));
                actionCallbackData = actionContentProcessor?.(message) ?? undefined;
                dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: invocationId,
                    status: (0, $cteoa.deriveInvocationStatus)(message, payload.context)
                }));
                if ((0, $ljUdP.isActionExecutedSuccessfully)(message)) broadcastConfirmedActions?.(conversationId, [
                    payload.context
                ]);
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'success',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            } else {
                dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                    conversationId: conversationId,
                    messageId: messageId,
                    invocationId: payload.context.invocationId,
                    status: 'errored'
                }));
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'error',
                    actionSubject: 'rovoChatMessageAction',
                    attributes: {
                        recipientAgentNamedId: payload.context.recipient_agent_named_id,
                        actionKey: payload.context.key,
                        resolutionType: payload.context.resolution.type,
                        featureArea: featureArea,
                        humanMessageId: humanMessageId,
                        messageId: messageId
                    }
                });
            }
        } catch (error) {
            if (!skipExperienceTracking) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
                error: error,
                attributes: attributes
            });
            trackAIMAUEvent({
                type: 'error',
                userGenerated: true,
                source: 'messageActionsResolver',
                subjectId: payload.context.resolution.type,
                singleInstrumentationID: messageId
            });
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'error',
                actionSubject: 'rovoChatMessageAction',
                attributes: {
                    recipientAgentNamedId: payload.context.recipient_agent_named_id,
                    actionKey: payload.context.key,
                    resolutionType: payload.context.resolution.type,
                    featureArea: featureArea,
                    humanMessageId: humanMessageId,
                    messageId: messageId
                }
            });
            dispatch($0b6866794de633f9$var$updateActionInvocationStatus({
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                status: 'errored'
            }));
            throw new (0, $iEWar.MessageActionError)({
                message: `Message action error: ${error.message} for actionKey: ${payload.context.key}`,
                conversationId: conversationId,
                messageId: messageId,
                invocationId: payload.context.invocationId,
                actionKey: payload.context.key,
                cause: error
            });
        }
        if (!skipExperienceTracking) experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).RESOLVE_CONVERSATION_ACTION,
            attributes: attributes
        });
        return actionCallbackData;
    });
const $0b6866794de633f9$var$bulkResolveConversationActions = $0b6866794de633f9$export$f65ce059a9114838((0, $bPHr8.StoreActionLoggableName).bulkResolveConversationActions, ({ conversationId: conversationId, messageId: messageId, payloads: payloads, actionContentProcessor: actionContentProcessor, skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse = false })=>async ({ dispatch: dispatch, getState: getState }, { experienceTracker: experienceTracker })=>{
        const currentConversation = getState().conversations[conversationId];
        if (!currentConversation) return [];
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            id: conversationId,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        // Execute all actions sequentially
        const actionCallbackResults = [];
        const successfulActions = [];
        let hasErrors = false;
        let successCount = 0;
        for (const payload of payloads){
            const result = await dispatch($0b6866794de633f9$var$resolveConversationAction({
                conversationId: conversationId,
                messageId: messageId,
                payload: payload,
                actionContentProcessor: actionContentProcessor,
                skipSuccessOptimisticAssistantResponse: skipSuccessOptimisticAssistantResponse,
                skipExperienceTracking: true
            }));
            actionCallbackResults.push(result);
            // Track success: result is defined means action succeeded
            if (result !== undefined) {
                successCount++;
                successfulActions.push(payload.context);
            } else if (!actionContentProcessor) // Action with no processor returns undefined on success
            successCount++;
            else // Action with processor returned undefined = failure
            hasErrors = true;
        }
        if (hasErrors) experienceTracker.fail({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            error: new Error('Some bulk actions failed'),
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length,
                successCount: successCount,
                failureCount: payloads.length - successCount
            }
        });
        else experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).BULK_RESOLVE_CONVERSATION_ACTIONS,
            attributes: {
                conversationId: conversationId,
                actionCount: payloads.length
            }
        });
        return actionCallbackResults;
    });
const $0b6866794de633f9$var$deleteConversation = ({ conversationId: conversationId })=>async ({ dispatch: dispatch, getState: getState }, { assistanceService: assistanceService, experienceTracker: experienceTracker })=>{
        experienceTracker.start({
            name: (0, $16lEl.ExperienceName).CLEAR_CHAT,
            id: conversationId,
            attributes: {
                conversationId: conversationId
            }
        });
        await getState().conversations[conversationId]?.storeAbortController?.abort();
        try {
            await assistanceService.deleteChat(conversationId);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).CLEAR_CHAT,
                error: error
            });
            throw error;
        }
        (0, $c6GJD.default).getExperimentValue('rovo_chat_perf_init_load_optimization', 'isBackgroundConversationsFetchEnabled', false) ? await dispatch($0b6866794de633f9$var$fetchConversationChannelsData()) : await dispatch($0b6866794de633f9$var$initConversationChannelsData());
        experienceTracker.succeed({
            name: (0, $16lEl.ExperienceName).CLEAR_CHAT
        });
    };
/**
 * ************************************************************
 * Store
 * ************************************************************
 */ const $0b6866794de633f9$var$actions = {
    abortRequests: $0b6866794de633f9$var$abortRequests,
    addAgentMessage: $0b6866794de633f9$var$addAgentMessage,
    addErrorMessage: $0b6866794de633f9$var$addErrorMessage,
    answerNow: $0b6866794de633f9$var$answerNow,
    bulkResolveConversationActions: $0b6866794de633f9$var$bulkResolveConversationActions,
    clearFollowUpMessages: $0b6866794de633f9$var$clearFollowUpMessages,
    createConversationOptimistically: $0b6866794de633f9$var$createConversationOptimistically,
    createSeededConversation: $0b6866794de633f9$var$createSeededConversation,
    deleteConversation: $0b6866794de633f9$var$deleteConversation,
    getChat: $0b6866794de633f9$var$fetchConversation,
    handleChatOpenPubsubAction: $0b6866794de633f9$var$handleChatOpenPubsubAction,
    hydrateConversationWithExternalParams: $0b6866794de633f9$var$hydrateConversationWithExternalParams,
    initConversationChannelsData: $0b6866794de633f9$var$initConversationChannelsData,
    fetchConversationChannelsData: $0b6866794de633f9$var$fetchConversationChannelsData,
    setConversationData: $0b6866794de633f9$var$setConversationData,
    removeMessage: $0b6866794de633f9$var$removeMessage,
    resolveConversationAction: $0b6866794de633f9$var$resolveConversationAction,
    sendMessage: $0b6866794de633f9$var$sendMessage,
    sendMessageConfirmedTools: $0b6866794de633f9$var$sendMessageConfirmedTools,
    setSelectedConversation: $0b6866794de633f9$var$setSelectedConversation,
    updateConversation: $0b6866794de633f9$var$updateConversation,
    removeConversationFromStore: $0b6866794de633f9$var$removeConversationFromStore,
    reconnectToInProgressStream: $0b6866794de633f9$var$reconnectToInProgressStream
};
const $0b6866794de633f9$var$chatStore = (0, $2CHXX.createChatStore)($0b6866794de633f9$var$actions);
/**
 * ************************************************************
 * Container
 * ************************************************************
 */ const $0b6866794de633f9$var$storeInit = ()=>async ({ dispatch: dispatch }, { setChatStatus: setChatStatus, skipAutoConversationSelection: skipAutoConversationSelection })=>{
        (0, $1yaYZ.addSentryBreadcrumb)('ChatStoreContainer: storeInit');
        setChatStatus('launching');
        const initConversationWithMetrics = async ()=>{
            (0, $1K4cm.interactionMetrics).initializeChannels.start();
            await dispatch($0b6866794de633f9$var$initConversationChannelsData({
                isInitialLoad: true,
                autoSelectConversation: !skipAutoConversationSelection
            }));
            (0, $1K4cm.interactionMetrics).initializeChannels.stop();
        };
        // Init conversation hydrates the chat store with conversation from URL or Storage
        // and fetches conversations list (however, fetching conversations list is performed "in the background")
        // conversations list is fetched to be later on displayed in the sidebar/conversation list to remove/minimize
        // visual delay when user opens the side-navigation; or in full-screen mode to fetch conversations as early as possible;
        const initConversation = async ()=>{
            dispatch($0b6866794de633f9$var$hydrateConversationWithExternalParams({
                autoSelectConversation: !skipAutoConversationSelection
            }));
            (0, $1K4cm.interactionMetrics).initializeChannels.start();
            await dispatch($0b6866794de633f9$var$fetchConversationChannelsData({
                isInitialLoad: true
            }));
            (0, $1K4cm.interactionMetrics).initializeChannels.stop();
        };
        (0, $c6GJD.default).getExperimentValue('rovo_chat_perf_init_load_optimization', 'isBackgroundConversationsFetchEnabled', false) ? initConversation() : initConversationWithMetrics();
        (0, $1yaYZ.addSentryBreadcrumb)('ChatStoreContainer: storeInit completed');
    };
const $0b6866794de633f9$var$storeInitOnUpdate = ()=>{
    return ()=>{};
};
const $0b6866794de633f9$var$chatStoreContainerOptions = {
    onInit: $0b6866794de633f9$var$storeInit,
    onUpdate: $0b6866794de633f9$var$storeInitOnUpdate
};
const $0b6866794de633f9$export$9b7b433b0520b82b = (0, $FOT9i.createContainer)($0b6866794de633f9$var$chatStore, $0b6866794de633f9$var$chatStoreContainerOptions);
/**
 * ************************************************************
 * Main Hook
 * ************************************************************
 */ const $0b6866794de633f9$var$publicStateSelector = (state)=>{
    return {
        ...state,
        checkActiveConversationMatchesSource: (id)=>{
            return (0, $cteoa.checkActiveConversationMatchesSource)(state, id);
        }
    };
};
const $0b6866794de633f9$export$5ca9bbfceeb3b458 = (0, $9zUhf.createHook)($0b6866794de633f9$var$chatStore, {
    selector: $0b6866794de633f9$var$publicStateSelector
});
const $0b6866794de633f9$export$b8d7540a5f22fede = (0, $9zUhf.createActionsHook)($0b6866794de633f9$var$chatStore);
module.exports["ChatStoreContainer"] = $0b6866794de633f9$export$9b7b433b0520b82b;
module.exports["useChatStore"] = $0b6866794de633f9$export$5ca9bbfceeb3b458;
module.exports["useChatStoreActions"] = $0b6866794de633f9$export$b8d7540a5f22fede;

});

parcelRegister("8IKbl", function(module, exports) {
const $e66d55c2753a8f61$export$d48e9af4e05f2a7 = 'google-calendar-event-create';
const $e66d55c2753a8f61$export$a43abf6a24956d01 = 'google-doc-create';
const $e66d55c2753a8f61$export$21d5a0caed6ec45a = 'slack-send-channel-message';
const $e66d55c2753a8f61$export$ca1dbd7b2bdea0b9 = 'github-pull-request-comment';
const $e66d55c2753a8f61$export$5265054aab70a085 = 'sharepoint-document-create';
const $e66d55c2753a8f61$export$51cf89863fa35443 = {
    'google-calendar-event-create': {
        stg: '57a5a90f-ab9c-4f1c-b661-3267fb23b5f2',
        prod: '57a5a90f-ab9c-4f1c-b661-3267fb23b5f2'
    },
    'google-doc-create': {
        stg: 'ari:cloud:ecosystem::extension/2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1/3b53863d-a6bb-4818-91da-4de04f975f48/static/create-gdrive-document',
        prod: 'ari:cloud:ecosystem::extension/ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7/c50f3d56-68fc-4c3c-8191-6717f173dc54/static/create-gdrive-document'
    },
    'slack-send-channel-message': {
        stg: '698c49a4-8c14-448d-a7c6-766298a5f22e',
        prod: '698c49a4-8c14-448d-a7c6-766298a5f22e'
    },
    'github-pull-request-comment': {
        stg: '88344c12-d3a8-4f9b-85ca-9c905de23570',
        prod: '88344c12-d3a8-4f9b-85ca-9c905de23570'
    },
    'sharepoint-document-create': {
        stg: 'c910d167-3796-4b72-b144-0a9a0c4ef8cc',
        prod: 'c910d167-3796-4b72-b144-0a9a0c4ef8cc'
    }
};
const $e66d55c2753a8f61$export$9036027f2f20417a = (actionKey)=>{
    return actionKey in $e66d55c2753a8f61$export$51cf89863fa35443;
};
const $e66d55c2753a8f61$export$709b8cb02beb8ef9 = (actionKey)=>{
    switch(actionKey){
        case $e66d55c2753a8f61$export$d48e9af4e05f2a7:
            return 'google-calendar';
        case $e66d55c2753a8f61$export$a43abf6a24956d01:
            return 'google-doc';
        case $e66d55c2753a8f61$export$21d5a0caed6ec45a:
            return 'slack';
        case $e66d55c2753a8f61$export$ca1dbd7b2bdea0b9:
            return 'github';
        case $e66d55c2753a8f61$export$5265054aab70a085:
            return 'sharepoint';
        default:
            return '';
    }
};
const $e66d55c2753a8f61$export$4081752c8da17394 = {
    // Atlassian Projects
    CreateProjectProgressUpdate: 'atlassian-project-atlassian-atlassian-project-create-progress-up',
    // Jira
    UpdateWorkItemFields: 'jira-atlassian-work-item-update-single-field',
    UpdateWorkItemAllFieldTypes: 'jira-atlassian-work-item-update-all-field-types-bulk',
    JiraFindIssues: 'jira-find-issues',
    JiraCreateIssue: 'jira-issue-create',
    JiraCreateIssueBulk: 'jira-issue-create-bulk',
    JiraSmartIssueCreateAllField: 'jira-atlassian-work-item-create-all-field-types',
    JiraIssueTransition: 'jira-issue-transition-bulk',
    JiraEpicsSuggest: 'jira-epics-suggest',
    JiraIssueDelete: 'jira-issue-delete',
    JiraIssueMove: 'jira-issue-move',
    JiraIssueAssign: 'jira-issue-assign-bulk',
    JiraVersionCreate: 'jira-version-create',
    JiraWorkflowEditor: 'jira-workflow-operations',
    // Confluence
    ConfluencePageCreate: 'confluence-page-create',
    ConfluencePageComment: 'confluence-page-comment',
    ConfluencePageAddLabel: 'confluence-label-create',
    // JSM
    JsmCreateRequest: 'jsm-create-request',
    JsmCreateRequestV2: 'jsm-create-request-v2',
    JsmCreateEmbeddedRequest: 'help-form-submit',
    JsmCreateSurvey: 'jsm-create-survey',
    JsmLivechat: 'jsm-livechat',
    JsmCreateSpace: 'jsm-create-space',
    // Deep Research
    DeepResearchCreatePageAction: 'deep-research-report-confluence-export',
    // Studio
    StudioTriggerSolutionPlan: 'studio-trigger-solution-plan',
    StudioUpdateAgentDraft: 'studio-atlassian-studio-update-agent-draft',
    StudioWorkspaceUpdateAgentDraft: 'studio-atlassian-workspace-update-draft-agent',
    StudioAutomationTriggerRuleBuild: 'studio-automation-trigger-rule-build',
    UpdateAgentConfigurationTool: 'UpdateAgentConfigurationTool',
    StudioLandingPageRedirect: 'studio-landing-page-redirect',
    // Plans
    JiraPlansUpdateWorkSource: 'jira-atlassian-plan-update-work-sources',
    JiraPlansCreateProgramBoard: 'jira-plan-add-program-board-plugin',
    JiraPlansDeleteProgramBoard: 'Jira-Plan-Delete-Program-Board-Plugin',
    JiraPlansCreateWorkItem: 'jira-atlassian-plan-create-work-item',
    JiraPlansCreateRelease: 'Jira-Plan-Create-Release-Plugin',
    JiraPlansManageFeatures: 'jira-atlassian-plan-set-release-enabled',
    JiraPlansAddDependency: 'jira-atlassian-plan-add-work-item-dependencies',
    JiraPlansRemoveDependency: 'jira-atlassian-plan-remove-work-item-dependencies',
    // Capacity Planning
    ManageCapacityPlan: 'capacity-plan-update-single-action',
    // Others
    StoreRecommendationCard: 'store-recommendation-card',
    RequireInformationTool: 'RequireInformationTool',
    HiringManagerTool: 'HiringManagerTool'
};
const $e66d55c2753a8f61$export$f4709e6eb43898ae = {
    DynamicAction: 'dynamicAction',
    McpTool: 'mcpTool'
};
const $e66d55c2753a8f61$export$dc0b7ce6d28cc1a4 = Object.values($e66d55c2753a8f61$export$4081752c8da17394);
const $e66d55c2753a8f61$export$a70752a3aa5d7b44 = 'generic-external-action-error';
const $e66d55c2753a8f61$export$4017c867f2f7bb4 = 'jira-find-issues';
const $e66d55c2753a8f61$export$9f87ddd99a91f353 = 'jira-issue-create';
const $e66d55c2753a8f61$export$5c33591a322b3632 = 'jira-issue-create-bulk';
const $e66d55c2753a8f61$export$d94c92560b8e6d9 = 'jira-atlassian-work-item-create-all-field-types';
const $e66d55c2753a8f61$export$ae7170c1349b8d03 = 'jsm-create-request';
const $e66d55c2753a8f61$export$bd97f2d43b42e54b = 'jsm-create-request-v2';
const $e66d55c2753a8f61$export$d8b6e8d910775d71 = 'help-form-submit';
const $e66d55c2753a8f61$export$63066a4ea024d6dc = 'jsm-livechat';
const $e66d55c2753a8f61$export$12df73851574d597 = 'jira-issue-transition-bulk';
const $e66d55c2753a8f61$export$3409cf7709732f7a = 'jira-epics-suggest';
const $e66d55c2753a8f61$export$28eab0a47cd4bdb7 = 'jira-issue-delete';
const $e66d55c2753a8f61$export$7814024c83fb6ff0 = 'jira-issue-move';
const $e66d55c2753a8f61$export$1621b7bb3a34aaf8 = 'jira-issue-assign-bulk';
const $e66d55c2753a8f61$export$5d140de35a141589 = 'jira-version-create';
const $e66d55c2753a8f61$export$9c43c5b52e38bd7b = 'capacity-plan-update-single-action';
const $e66d55c2753a8f61$export$7daabf9beae1e394 = 'jira-workflow-operations';
const $e66d55c2753a8f61$export$b34d7535a3731e6 = 'confluence-page-create';
const $e66d55c2753a8f61$export$5eead95dddb4d85e = 'confluence-page-comment';
const $e66d55c2753a8f61$export$dd1d4f1078af0323 = 'confluence-page-rename';
const $e66d55c2753a8f61$export$ea076e5315cd0441 = 'confluence-label-create';
const $e66d55c2753a8f61$export$2d6387634f79866d = 'confluence-page-move';
const $e66d55c2753a8f61$export$c35e156d5b3ba839 = 'deep-research-report-confluence-export';
const $e66d55c2753a8f61$export$6509c2efb7cf2a1a = 'RequireInformationTool';
const $e66d55c2753a8f61$export$32fdd722a8ead9f4 = 'HiringManagerTool';
const $e66d55c2753a8f61$export$1b06fd861ab5ff79 = 'studio-trigger-solution-plan';
const $e66d55c2753a8f61$export$7f87d37407a70a70 = 'studio-atlassian-studio-update-agent-draft';
const $e66d55c2753a8f61$export$e118b34b65e65120 = 'studio-atlassian-workspace-update-draft-agent';
const $e66d55c2753a8f61$export$1d1c24f8fb60d008 = 'UpdateAgentConfigurationTool';
const $e66d55c2753a8f61$export$5f46fda2a8a95615 = 'jsm-invoke-orchestrator-agent';
const $e66d55c2753a8f61$export$a1766d72cd6b3386 = 'jsm-atlassian-project-create-jsm-survey';
const $e66d55c2753a8f61$export$8dfa199a737d630f = 'jsm-atlassian-project-create-jsm-queue';
const $e66d55c2753a8f61$export$459b808fe2e5243c = 'studio-automation-trigger-rule-build';
const $e66d55c2753a8f61$export$5b672baa753f5e11 = 'jira-atlassian-plan-update-work-sources';
const $e66d55c2753a8f61$export$cbc8657dfb60324e = 'jira-plan-add-program-board-plugin';
const $e66d55c2753a8f61$export$5eaeb9a94b1424d1 = 'Jira-Plan-Delete-Program-Board-Plugin';
const $e66d55c2753a8f61$export$aa0b02e94003e760 = 'jira-atlassian-plan-create-work-item';
const $e66d55c2753a8f61$export$fc48d7aa308f4ddd = 'jira-atlassian-plan-set-release-enabled';
const $e66d55c2753a8f61$export$82a76d32e0a5ed52 = 'jira-atlassian-plan-add-work-item-dependencies';
const $e66d55c2753a8f61$export$a27ffbabb22373cc = 'jira-atlassian-plan-remove-work-item-dependencies';
const $e66d55c2753a8f61$export$17ce344f9afefd3f = 'Jira-Plan-Create-Release-Plugin';
const $e66d55c2753a8f61$export$b392dc810180e703 = 'store-recommendation-card';
const $e66d55c2753a8f61$export$1d10a8f57c7c69ae = 'jira-ham-ai-insights-preview';
const $e66d55c2753a8f61$export$ef8aa45067b257a9 = [
    $e66d55c2753a8f61$export$4017c867f2f7bb4,
    $e66d55c2753a8f61$export$9f87ddd99a91f353,
    $e66d55c2753a8f61$export$3409cf7709732f7a,
    $e66d55c2753a8f61$export$28eab0a47cd4bdb7,
    $e66d55c2753a8f61$export$7814024c83fb6ff0
];
module.exports["actionKeyToActionId"] = $e66d55c2753a8f61$export$51cf89863fa35443;
module.exports["isDynamicAction"] = $e66d55c2753a8f61$export$9036027f2f20417a;
module.exports["mapActionToProduct"] = $e66d55c2753a8f61$export$709b8cb02beb8ef9;
module.exports["ActionKeys"] = $e66d55c2753a8f61$export$4081752c8da17394;
module.exports["ActionPredicateKeys"] = $e66d55c2753a8f61$export$f4709e6eb43898ae;
module.exports["JIRA_FIND_ISSUES_KEY"] = $e66d55c2753a8f61$export$4017c867f2f7bb4;
module.exports["JIRA_ISSUE_CREATE_KEY"] = $e66d55c2753a8f61$export$9f87ddd99a91f353;
module.exports["JIRA_BULK_ISSUE_CREATE_KEY"] = $e66d55c2753a8f61$export$5c33591a322b3632;
module.exports["JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY"] = $e66d55c2753a8f61$export$d94c92560b8e6d9;
module.exports["JSM_CREATE_REQUEST_KEY"] = $e66d55c2753a8f61$export$ae7170c1349b8d03;
module.exports["JSM_CREATE_REQUEST_V2_KEY"] = $e66d55c2753a8f61$export$bd97f2d43b42e54b;
module.exports["JSM_CREATE_EMBEDDED_REQUEST_KEY"] = $e66d55c2753a8f61$export$d8b6e8d910775d71;
module.exports["JSM_LIVECHAT_KEY"] = $e66d55c2753a8f61$export$63066a4ea024d6dc;
module.exports["JIRA_ISSUE_TRANSITION_KEY"] = $e66d55c2753a8f61$export$12df73851574d597;
module.exports["JIRA_EPICS_SUGGEST_KEY"] = $e66d55c2753a8f61$export$3409cf7709732f7a;
module.exports["JIRA_ISSUE_DELETE_KEY"] = $e66d55c2753a8f61$export$28eab0a47cd4bdb7;
module.exports["JIRA_ISSUE_MOVE_KEY"] = $e66d55c2753a8f61$export$7814024c83fb6ff0;
module.exports["JIRA_ISSUE_ASSIGN_KEY"] = $e66d55c2753a8f61$export$1621b7bb3a34aaf8;
module.exports["JIRA_VERSION_CREATE_KEY"] = $e66d55c2753a8f61$export$5d140de35a141589;
module.exports["JIRA_WORKFLOW_EDITOR"] = $e66d55c2753a8f61$export$7daabf9beae1e394;
module.exports["CONFLUENCE_PAGE_CREATE_KEY"] = $e66d55c2753a8f61$export$b34d7535a3731e6;
module.exports["CONFLUENCE_PAGE_COMMENT_KEY"] = $e66d55c2753a8f61$export$5eead95dddb4d85e;
module.exports["CONFLUENCE_PAGE_RENAME_KEY"] = $e66d55c2753a8f61$export$dd1d4f1078af0323;
module.exports["CONFLUENCE_PAGE_ADD_LABEL_KEY"] = $e66d55c2753a8f61$export$ea076e5315cd0441;
module.exports["CONFLUENCE_PAGE_MOVE_KEY"] = $e66d55c2753a8f61$export$2d6387634f79866d;
module.exports["DEEP_RESEARCH_CREATE_PAGE_ACTION_KEY"] = $e66d55c2753a8f61$export$c35e156d5b3ba839;
module.exports["REQUIRE_INFORMATION_TOOL"] = $e66d55c2753a8f61$export$6509c2efb7cf2a1a;
module.exports["STUDIO_TRIGGER_SOLUTION_PLAN_KEY"] = $e66d55c2753a8f61$export$1b06fd861ab5ff79;
module.exports["STUDIO_ATLASSIAN_STUDIO_UPDATE_AGENT_DRAFT_KEY"] = $e66d55c2753a8f61$export$7f87d37407a70a70;
module.exports["STUDIO_ATLASSIAN_WORKSPACE_UPDATE_DRAFT_AGENT_KEY"] = $e66d55c2753a8f61$export$e118b34b65e65120;
module.exports["UPDATE_AGENT_CONFIGURATION_TOOL_KEY"] = $e66d55c2753a8f61$export$1d1c24f8fb60d008;
module.exports["JSM_JOURNEY_BUILDER_KEY"] = $e66d55c2753a8f61$export$5f46fda2a8a95615;
module.exports["JSM_CREATE_SURVEY_KEY"] = $e66d55c2753a8f61$export$a1766d72cd6b3386;
module.exports["JSM_QUEUE_UPDATED_KEY"] = $e66d55c2753a8f61$export$8dfa199a737d630f;
module.exports["STUDIO_AUTOMATION_TRIGGER_RULE_BUILD_KEY"] = $e66d55c2753a8f61$export$459b808fe2e5243c;
module.exports["JIRA_PLANS_UPDATE_WORK_SOURCE_KEY"] = $e66d55c2753a8f61$export$5b672baa753f5e11;
module.exports["JIRA_PLANS_ADD_PROGRAM_BOARD_KEY"] = $e66d55c2753a8f61$export$cbc8657dfb60324e;
module.exports["JIRA_PLANS_DELETE_PROGRAM_BOARD_KEY"] = $e66d55c2753a8f61$export$5eaeb9a94b1424d1;
module.exports["JIRA_PLANS_CREATE_WORK_ITEM_KEY"] = $e66d55c2753a8f61$export$aa0b02e94003e760;
module.exports["JIRA_PLANS_MANAGE_FEATURES_KEY"] = $e66d55c2753a8f61$export$fc48d7aa308f4ddd;
module.exports["JIRA_PLANS_ADD_DEPENDENCY_KEY"] = $e66d55c2753a8f61$export$82a76d32e0a5ed52;
module.exports["JIRA_PLANS_REMOVE_DEPENDENCY_KEY"] = $e66d55c2753a8f61$export$a27ffbabb22373cc;
module.exports["JIRA_PLANS_CREATE_RELEASE_KEY"] = $e66d55c2753a8f61$export$17ce344f9afefd3f;
module.exports["STORE_RECOMMENDATION_ACTION_KEY"] = $e66d55c2753a8f61$export$b392dc810180e703;
module.exports["JIRA_HAM_AI_INSIGHTS_PREVIEW_KEY"] = $e66d55c2753a8f61$export$1d10a8f57c7c69ae;

});

parcelRegister("1K4cm", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");

const $bbc0ec2f964cbf02$var$SEND_MESSAGE_METRICS_KEY = 'ai-mate.send-message';
const $bbc0ec2f964cbf02$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY = 'ai-mate.time-to-first-answer-part';
const $bbc0ec2f964cbf02$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY = 'ai-mate.time-to-first-action-part';
const $bbc0ec2f964cbf02$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY = 'ai-mate.time-to-action-completion';
const $bbc0ec2f964cbf02$var$BETWEEN_CHUNKS_LATENCY_METRICS_KEY = 'ai-mate.between-chunks-latency';
// Reconnection metrics
const $bbc0ec2f964cbf02$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY = 'ai-mate.reconnect.time-to-connect-to-stream';
const $bbc0ec2f964cbf02$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY = 'ai-mate.reconnect.time-to-first-chunk-received';
const $bbc0ec2f964cbf02$export$86db56030b57ba34 = {
    initializeChannels: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.initialize-channels'
    }),
    timeToRenderMessageContent: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.time-to-render-message-content'
    }),
    timeToRenderFinalResponse: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.time-to-render-final-response'
    }),
    sendConfirmedToolsTimeToFinishStream: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-finish-stream'
    }),
    sendConfirmedToolsTimeToFirstAnswerPart: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part'
    }),
    messageCompositionTime: (0, $kyiqo.metrics).interaction({
        key: 'ai-mate.message-composition-time'
    })
};
const $bbc0ec2f964cbf02$export$72bdd99dfc759d06 = (baseName, { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, isRovoCustomAgent: isRovoCustomAgent })=>{
    if (isRovoCustomAgent) return `${baseName}.rovo-custom-agent`;
    if (deepResearchEnabled) return `${baseName}.deep-research`;
    if (thinkDeeperEnabled) return `${baseName}.think-deeper`;
    return baseName;
};
const $bbc0ec2f964cbf02$export$1e4d1659c4209dbf = {
    createSendMessageMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$SEND_MESSAGE_METRICS_KEY, params)
        });
    },
    createTimeToFirstAnswerPartMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_FIRST_ANSWER_PART_METRICS_KEY, params)
        });
    },
    createTimeToFirstActionPartMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_FIRST_ACTION_PART_METRICS_KEY, params)
        });
    },
    createTimeToActionCompletionMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_ACTION_COMPLETION_METRICS_KEY, params)
        });
    },
    createBetweenChunksLatencyMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$BETWEEN_CHUNKS_LATENCY_METRICS_KEY, params)
        });
    }
};
const $bbc0ec2f964cbf02$export$924cdb4a6542ccd = {
    createTimeToConnectToStreamMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_CONNECT_TO_STREAM_METRICS_KEY, params)
        });
    },
    createTimeToResumeStreamMetrics: (params)=>{
        return (0, $kyiqo.metrics).interaction({
            key: $bbc0ec2f964cbf02$export$72bdd99dfc759d06($bbc0ec2f964cbf02$var$TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY, params)
        });
    }
};
const $bbc0ec2f964cbf02$export$4841ee9a7190fdf6 = {
    createDeadAirIntervalMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.dead-air-interval'
        });
    },
    createDeadAirMaxMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.dead-air-max'
        });
    }
};
const $bbc0ec2f964cbf02$export$d077ccae10682bac = {
    createViewDeadAirMetrics: ()=>{
        return (0, $kyiqo.metrics).interaction({
            key: 'ai-mate.view-dead-air'
        });
    }
};
module.exports["interactionMetrics"] = $bbc0ec2f964cbf02$export$86db56030b57ba34;
module.exports["messageLatencyMetrics"] = $bbc0ec2f964cbf02$export$1e4d1659c4209dbf;
module.exports["reconnectionMetrics"] = $bbc0ec2f964cbf02$export$924cdb4a6542ccd;
module.exports["deadAirMetrics"] = $bbc0ec2f964cbf02$export$4841ee9a7190fdf6;
module.exports["viewDeadAirMetrics"] = $bbc0ec2f964cbf02$export$d077ccae10682bac;

});

parcelRegister("1cjt9", function(module, exports) {
const $5f7f03ab221db6a4$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC',
    actor_type: 'AGENT',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
module.exports["DEFAULT_AGENT"] = $5f7f03ab221db6a4$export$48783720d93c2d26;

});

parcelRegister("deF0K", function(module, exports) {
// ============================================================================
// ACTIONS that are shared between Confluence and Jira
// ============================================================================

var $dh538 = parcelRequire("dh538");


var $bPHr8 = parcelRequire("bPHr8");


var $3vCSA = parcelRequire("3vCSA");


var $htiKQ = parcelRequire("htiKQ");


var $9bF5n = parcelRequire("9bF5n");

const $665803f9684f4c9f$export$992a8e659d5a1252 = (action)=>typeof action === 'object' && action !== null && 'key' in action;
const $665803f9684f4c9f$export$74f7c5137689c9a9 = (action)=>(0, $3vCSA.isConfluenceCreatableAction)(action) || (0, $htiKQ.isJiraCreatableAction)(action) || (0, $9bF5n.isJsmCreatableAction)(action) || (0, $3vCSA.isDynamicUiCreatableAction)(action);
const $665803f9684f4c9f$export$95acec44a3c80403 = (action)=>(0, $3vCSA.isConfluenceUpdatableAction)(action) || (0, $htiKQ.isJiraUpdatableAction)(action) || (0, $9bF5n.isJsmUpdatableAction)(action);
const $665803f9684f4c9f$export$473ed8cdfdfcd6f4 = (action)=>$665803f9684f4c9f$export$74f7c5137689c9a9(action) || $665803f9684f4c9f$export$95acec44a3c80403(action);
const $665803f9684f4c9f$export$a4e95791cb217646 = (action)=>{
    return (0, $3vCSA.getConfluenceContentType)(action) ?? (0, $htiKQ.getJiraContentType)(action) ?? (0, $9bF5n.getJsmContentType)(action) ?? 'unknown';
};
const $665803f9684f4c9f$export$154eb84770532af2 = (action)=>(0, $3vCSA.isConfluenceStreamAction)(action) || (0, $htiKQ.isJiraStreamAction)(action) || (0, $9bF5n.isJsmStreamAction)(action);
const $665803f9684f4c9f$export$1382aef9948f8fc7 = (action)=>(0, $3vCSA.isConfluencePreviewCardAction)(action) || (0, $htiKQ.isJiraPreviewCardAction)(action) || (0, $9bF5n.isJsmPreviewCardAction)(action) || (0, $3vCSA.isDynamicUiCreatableAction)(action);
const $665803f9684f4c9f$export$681cf9ea58de88fd = (action, identifier)=>{
    if (!(0, $dh538.fg)('jira_aifc_enabled')) return (0, $3vCSA.generateRovoReceiverId)(action, identifier ?? '');
    if (!$665803f9684f4c9f$export$992a8e659d5a1252(action)) return undefined;
    if ((0, $htiKQ.isJiraAction)(action)) return (0, $htiKQ.generateJiraReceiverId)(action);
    if ((0, $9bF5n.isJsmAction)(action) && (0, $dh538.fg)('surveys-aifc')) return (0, $9bF5n.generateJsmReceiverId)(action);
    return (0, $3vCSA.generateRovoReceiverId)(action, identifier ?? '');
};
const $665803f9684f4c9f$export$ea699f0d7930d4d4 = ({ action: action, isContentPreviewSupported: isContentPreviewSupported })=>{
    if ((0, $dh538.fg)('aifc_create_enabled')) return !$665803f9684f4c9f$export$154eb84770532af2({
        key: action.key
    }) && !(0, $htiKQ.isJiraCreatableAction)({
        key: action.key
    }) && !(0, $9bF5n.isJsmCreatableAction)({
        key: action.key
    });
    if (!isContentPreviewSupported && !(0, $dh538.fg)('aifc_create_enabled')) return !$665803f9684f4c9f$export$1382aef9948f8fc7({
        key: action.key
    });
    return true;
};
function $665803f9684f4c9f$export$d94ea083820ef679(messages, invocationId) {
    return messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && !!msg.content.message.message.actions?.some((action)=>action.invocationId === invocationId));
}
module.exports["isCreatableAction"] = $665803f9684f4c9f$export$74f7c5137689c9a9;
module.exports["isUpdatableAction"] = $665803f9684f4c9f$export$95acec44a3c80403;
module.exports["isAIFCAction"] = $665803f9684f4c9f$export$473ed8cdfdfcd6f4;
module.exports["getAIFCContentType"] = $665803f9684f4c9f$export$a4e95791cb217646;
module.exports["isSupportedStreamAction"] = $665803f9684f4c9f$export$154eb84770532af2;
module.exports["isPreviewCardAction"] = $665803f9684f4c9f$export$1382aef9948f8fc7;
module.exports["generateRovoReceiverId"] = $665803f9684f4c9f$export$681cf9ea58de88fd;
module.exports["findMessageByInvocationId"] = $665803f9684f4c9f$export$d94ea083820ef679;

});

parcelRegister("3vCSA", function(module, exports) {

var $fgOJ7 = parcelRequire("fgOJ7");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");

const $0c322a09d1b57883$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
function $0c322a09d1b57883$export$6da360af78d7e3dd(data) {
    return typeof data === 'object' && data !== null && 'id' in data;
}
function $0c322a09d1b57883$export$3147e11228ebc102(action) {
    return $0c322a09d1b57883$export$6da360af78d7e3dd(action.data);
}
const $0c322a09d1b57883$export$440c8d4309cb1c9 = (data)=>{
    if (data?.id) return `${window.location.origin}/remix/ui/${encodeURIComponent(data.id)}`;
    return null;
};
const $0c322a09d1b57883$export$7afb9b8acd50eb4e = 'aifc-confluence-page-create';
function $0c322a09d1b57883$export$77c5629325e9aaaf(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'adf' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$b632d4bc1af2f7d3 = 'aifc-deep-research-confluence-page-create';
function $0c322a09d1b57883$export$3bd74956949aecbc(data) {
    return typeof data === 'object' && data !== null && 'title' in data && 'content' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$d6ad19367a51fe7a(data) {
    return typeof data === 'object' && data !== null && 'contentId' in data;
}
const $0c322a09d1b57883$export$88028308fe524b8a = 'aifc-confluence-page-update';
const $0c322a09d1b57883$export$bb3d6eff667f4678 = 'aifc-adf-update';
function $0c322a09d1b57883$export$4f41f9d38097cf0a(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
function $0c322a09d1b57883$export$1cf42b66f457bc6c(data) {
    return typeof data === 'object' && data !== null && 'toolCalls' in data && 'contentId' in data && typeof data.toolCalls === 'string' && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$279c9cc61f7f510a = 'aifc-confluence-whiteboard-create';
function $0c322a09d1b57883$export$392158ed2444b56b(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$823e13f43093123d = 'aifc-confluence-slides-create';
function $0c322a09d1b57883$export$ae4ad515c9dd259d(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$49b21a7401bcc85 = 'aifc-confluence-slides-update';
function $0c322a09d1b57883$export$3d6de0a3c3e39cbf(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$d5d2204eeb3fde50 = 'aifc-confluence-whiteboard-update';
function $0c322a09d1b57883$export$35d2029c1a7b307c(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$771989b0afde4911 = 'aifc-confluence-whiteboard-to-page';
const $0c322a09d1b57883$export$325918e7af3a74aa = 'confluence-whiteboard-brainstorming';
function $0c322a09d1b57883$export$48e8bcda6802129c(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$e3c19505945cf210 = 'confluence-whiteboard-diagramming';
const $0c322a09d1b57883$export$c8f288feec1641d9 = 'aifc-confluence-whiteboard-diagramming';
function $0c322a09d1b57883$export$f3a918f4f62365b2(data) {
    return typeof data === 'object' && data !== null && 'content' in data && 'diagramType' in data && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$9f1bd612d6abcf5c = 'aifc-confluence-database-create';
function $0c322a09d1b57883$export$4dec930442f5ade2(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'title' in data && typeof data.title === 'string' && 'contentId' in data && typeof data.contentId === 'string';
}
const $0c322a09d1b57883$export$ee0a705006a79cfe = 'aifc-confluence-database-update';
function $0c322a09d1b57883$export$dbed60ca289ab1f3(data) {
    return typeof data === 'object' && data !== null && 'document' in data && 'contentId' in data;
}
const $0c322a09d1b57883$export$691e9b05e574e32c = 'aifc-confluence-space-create';
function $0c322a09d1b57883$export$545244afe3ae2546(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$af91dd9bf235f890 = 'aifc-confluence-space-update';
function $0c322a09d1b57883$export$38f648644a8b3072(data) {
    return typeof data === 'object' && data !== null && 'jsonSpace' in data;
}
const $0c322a09d1b57883$export$9f62c3ae716c44b2 = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3
]);
const $0c322a09d1b57883$export$aba0c096f5cdcaca = new Set([
    $0c322a09d1b57883$export$279c9cc61f7f510a
]);
const $0c322a09d1b57883$export$b9c5aef93dba02df = new Set([
    $0c322a09d1b57883$export$823e13f43093123d
]);
const $0c322a09d1b57883$export$45a7157715c10f20 = new Set([
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$var$SPACE_CREATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$691e9b05e574e32c
]);
const $0c322a09d1b57883$var$DYNAMIC_UI_KEYS = new Set([
    $0c322a09d1b57883$export$740b9b28cb05ebd6
]);
const $0c322a09d1b57883$var$CREATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$export$9f62c3ae716c44b2,
    ...$0c322a09d1b57883$export$aba0c096f5cdcaca,
    ...$0c322a09d1b57883$export$b9c5aef93dba02df,
    ...$0c322a09d1b57883$export$45a7157715c10f20,
    ...$0c322a09d1b57883$var$SPACE_CREATE_ACTIONS
]);
const $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$88028308fe524b8a,
    $0c322a09d1b57883$export$bb3d6eff667f4678
]);
const $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$d5d2204eeb3fde50,
    $0c322a09d1b57883$export$325918e7af3a74aa,
    $0c322a09d1b57883$export$e3c19505945cf210,
    $0c322a09d1b57883$export$c8f288feec1641d9
]);
const $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$49b21a7401bcc85
]);
const $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$ee0a705006a79cfe
]);
const $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS = new Set([
    $0c322a09d1b57883$export$af91dd9bf235f890
]);
const $0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS = new Set([
    ...$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS,
    ...$0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS
]);
const $0c322a09d1b57883$export$6c0ed26dac146a75 = (action)=>$0c322a09d1b57883$export$9f62c3ae716c44b2.has(action.key);
const $0c322a09d1b57883$export$eac4577c3e50732a = (action)=>$0c322a09d1b57883$var$CREATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$53f0114d9f187b14 = (action)=>$0c322a09d1b57883$var$DYNAMIC_UI_KEYS.has(action.key);
const $0c322a09d1b57883$export$dfda1ac7e19cab7b = (action)=>$0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$dcbfc8a9b613cd00 = (action)=>$0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$5d2d4e8984b13e00 = (action)=>$0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$399c9116e9984ca3 = (action)=>$0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(action.key);
const $0c322a09d1b57883$export$73dc9ed6ed2373f = (action)=>$0c322a09d1b57883$var$UPDATABLE_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$54716060fc6e52ee = (action)=>$0c322a09d1b57883$export$eac4577c3e50732a(action) || $0c322a09d1b57883$export$73dc9ed6ed2373f(action);
// ============================================================================
// CONFLUENCE PREVIEW CARDS
// ============================================================================
const $0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    $0c322a09d1b57883$export$7afb9b8acd50eb4e,
    $0c322a09d1b57883$export$b632d4bc1af2f7d3,
    $0c322a09d1b57883$export$279c9cc61f7f510a,
    $0c322a09d1b57883$export$823e13f43093123d,
    $0c322a09d1b57883$export$49b21a7401bcc85,
    $0c322a09d1b57883$export$771989b0afde4911,
    $0c322a09d1b57883$export$9f1bd612d6abcf5c
]);
const $0c322a09d1b57883$export$5cb5e5f4b4ce0a33 = (action)=>$0c322a09d1b57883$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
const $0c322a09d1b57883$export$681cf9ea58de88fd = (action, selectedPreviewContentId)=>{
    if (!action?.key) return;
    switch(action.key){
        case $0c322a09d1b57883$export$279c9cc61f7f510a:
        case $0c322a09d1b57883$export$823e13f43093123d:
        case $0c322a09d1b57883$export$49b21a7401bcc85:
            return (0, $6nGJw.getConfluenceWhiteboardClientId)(selectedPreviewContentId);
        case $0c322a09d1b57883$export$9f1bd612d6abcf5c:
            return (0, $fgOJ7.getConfluenceDatabaseClientId)(selectedPreviewContentId);
        default:
            return (0, $eL1ct.getConfluenceEditorClientId)(selectedPreviewContentId);
    }
};
const $0c322a09d1b57883$export$bb9f6b0763834612 = (action)=>{
    const actionKey = action.key;
    if ($0c322a09d1b57883$export$9f62c3ae716c44b2.has(actionKey) || $0c322a09d1b57883$var$PAGE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-page';
    if ($0c322a09d1b57883$export$aba0c096f5cdcaca.has(actionKey) || $0c322a09d1b57883$var$WHITEBOARD_UPDATE_ACTIONS.has(actionKey)) return 'confluence-whiteboard';
    if ($0c322a09d1b57883$export$b9c5aef93dba02df.has(actionKey) || $0c322a09d1b57883$var$SLIDES_UPDATE_ACTIONS.has(actionKey)) return 'confluence-slide';
    if ($0c322a09d1b57883$export$45a7157715c10f20.has(actionKey) || $0c322a09d1b57883$var$DATABASE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-database';
    if ($0c322a09d1b57883$var$SPACE_CREATE_ACTIONS.has(actionKey) || $0c322a09d1b57883$var$SPACE_UPDATE_ACTIONS.has(actionKey)) return 'confluence-space';
    return undefined;
};
// This mapping should contain the type guards of those actions that support data
// accumulation as defined below in `getPrimaryAccumulatedValue`.
const $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS = {
    [$0c322a09d1b57883$export$7afb9b8acd50eb4e]: $0c322a09d1b57883$export$77c5629325e9aaaf,
    [$0c322a09d1b57883$export$b632d4bc1af2f7d3]: $0c322a09d1b57883$export$3bd74956949aecbc,
    [$0c322a09d1b57883$export$9f1bd612d6abcf5c]: $0c322a09d1b57883$export$4dec930442f5ade2,
    [$0c322a09d1b57883$export$279c9cc61f7f510a]: $0c322a09d1b57883$export$392158ed2444b56b,
    [$0c322a09d1b57883$export$823e13f43093123d]: $0c322a09d1b57883$export$ae4ad515c9dd259d
};
const $0c322a09d1b57883$export$b95f9369e33f3b4a = (key)=>{
    return key in $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS;
};
const $0c322a09d1b57883$export$898d9c03b4eb5dd5 = (key)=>{
    return $0c322a09d1b57883$var$CONFLUENCE_AIFC_ACCUMULATED_DATA_TYPE_GUARDS[key];
};
const $0c322a09d1b57883$export$240debd921ff9f65 = (action)=>{
    if (!action.data) return undefined;
    if (action.key === $0c322a09d1b57883$export$7afb9b8acd50eb4e && $0c322a09d1b57883$export$77c5629325e9aaaf(action.data)) {
        const key = 'adf';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$b632d4bc1af2f7d3 && $0c322a09d1b57883$export$3bd74956949aecbc(action.data)) {
        const key = 'content';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$279c9cc61f7f510a && $0c322a09d1b57883$export$392158ed2444b56b(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$823e13f43093123d && $0c322a09d1b57883$export$ae4ad515c9dd259d(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    } else if (action.key === $0c322a09d1b57883$export$9f1bd612d6abcf5c && $0c322a09d1b57883$export$4dec930442f5ade2(action.data)) {
        const key = 'document';
        return {
            key: key,
            value: action.data[key]
        };
    }
    return undefined;
};
const $0c322a09d1b57883$var$getAccumulatedData = (prevAction, nextAction)=>{
    const prevPrimary = $0c322a09d1b57883$export$240debd921ff9f65(prevAction);
    const nextPrimary = $0c322a09d1b57883$export$240debd921ff9f65(nextAction);
    if (!prevPrimary || !nextPrimary || prevPrimary.key !== nextPrimary.key) return undefined;
    return {
        [nextPrimary.key]: String(prevPrimary.value ?? '') + String(nextPrimary.value ?? '')
    };
};
const $0c322a09d1b57883$export$64e13fa6a74f5f86 = (prevAction, nextAction)=>{
    if (prevAction.data && nextAction.data) {
        const accumulatedData = $0c322a09d1b57883$var$getAccumulatedData(prevAction, nextAction);
        if (accumulatedData !== undefined) {
            const updatedData = {
                ...nextAction.data,
                ...accumulatedData
            };
            return {
                ...prevAction,
                data: updatedData,
                status: nextAction.status
            };
        }
    }
    return {
        ...prevAction,
        data: nextAction.data,
        status: nextAction.status
    };
};
module.exports["DYNAMIC_UI_CREATE_KEY"] = $0c322a09d1b57883$export$740b9b28cb05ebd6;
module.exports["isDynamicUiCreateData"] = $0c322a09d1b57883$export$6da360af78d7e3dd;
module.exports["isDynamicUiCreateAction"] = $0c322a09d1b57883$export$3147e11228ebc102;
module.exports["buildDynamicUiPageUrl"] = $0c322a09d1b57883$export$440c8d4309cb1c9;
module.exports["CONFLUENCE_AIFC_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$7afb9b8acd50eb4e;
module.exports["isConfluenceAIFCPageCreateActionData"] = $0c322a09d1b57883$export$77c5629325e9aaaf;
module.exports["CONFLUENCE_AIFC_DEEP_RESEARCH_PAGE_CREATE_KEY"] = $0c322a09d1b57883$export$b632d4bc1af2f7d3;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionData"] = $0c322a09d1b57883$export$3bd74956949aecbc;
module.exports["isConfluenceAIFCDeepResearchPageCreateActionPrepare"] = $0c322a09d1b57883$export$d6ad19367a51fe7a;
module.exports["AIFC_ADF_UPDATE_KEY"] = $0c322a09d1b57883$export$bb3d6eff667f4678;
module.exports["isAIFCADFUpdateActionData"] = $0c322a09d1b57883$export$1cf42b66f457bc6c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY"] = $0c322a09d1b57883$export$279c9cc61f7f510a;
module.exports["isConfluenceAIFCWhiteboardCreateActionData"] = $0c322a09d1b57883$export$392158ed2444b56b;
module.exports["CONFLUENCE_AIFC_SLIDES_CREATE_KEY"] = $0c322a09d1b57883$export$823e13f43093123d;
module.exports["isConfluenceAIFCSlidesCreateActionData"] = $0c322a09d1b57883$export$ae4ad515c9dd259d;
module.exports["CONFLUENCE_AIFC_SLIDES_UPDATE_KEY"] = $0c322a09d1b57883$export$49b21a7401bcc85;
module.exports["isConfluenceAIFCSlidesUpdateActionData"] = $0c322a09d1b57883$export$3d6de0a3c3e39cbf;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY"] = $0c322a09d1b57883$export$d5d2204eeb3fde50;
module.exports["isConfluenceAIFCWhiteboardUpdateActionData"] = $0c322a09d1b57883$export$35d2029c1a7b307c;
module.exports["CONFLUENCE_AIFC_WHITEBOARD_TO_PAGE_KEY"] = $0c322a09d1b57883$export$771989b0afde4911;
module.exports["CONFLUENCE_WHITEBOARD_BRAINSTORMING_KEY"] = $0c322a09d1b57883$export$325918e7af3a74aa;
module.exports["isConfluenceWhiteboardBrainstormingActionData"] = $0c322a09d1b57883$export$48e8bcda6802129c;
module.exports["LEGACY_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$e3c19505945cf210;
module.exports["AIFC_CONFLUENCE_WHITEBOARD_DIAGRAMMING_KEY"] = $0c322a09d1b57883$export$c8f288feec1641d9;
module.exports["isConfluenceWhiteboardDiagrammingActionData"] = $0c322a09d1b57883$export$f3a918f4f62365b2;
module.exports["CONFLUENCE_AIFC_DATABASE_CREATE_KEY"] = $0c322a09d1b57883$export$9f1bd612d6abcf5c;
module.exports["isConfluenceAIFCDatabaseCreateActionData"] = $0c322a09d1b57883$export$4dec930442f5ade2;
module.exports["CONFLUENCE_AIFC_DATABASE_UPDATE_KEY"] = $0c322a09d1b57883$export$ee0a705006a79cfe;
module.exports["isConfluenceAIFCDatabaseUpdateActionData"] = $0c322a09d1b57883$export$dbed60ca289ab1f3;
module.exports["CONFLUENCE_AIFC_SPACE_CREATE_KEY"] = $0c322a09d1b57883$export$691e9b05e574e32c;
module.exports["isConfluenceAIFCSpaceCreateActionData"] = $0c322a09d1b57883$export$545244afe3ae2546;
module.exports["CONFLUENCE_AIFC_SPACE_UPDATE_KEY"] = $0c322a09d1b57883$export$af91dd9bf235f890;
module.exports["isConfluenceAIFCSpaceUpdateActionData"] = $0c322a09d1b57883$export$38f648644a8b3072;
module.exports["PAGE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$9f62c3ae716c44b2;
module.exports["WHITEBOARD_CREATE_ACTIONS"] = $0c322a09d1b57883$export$aba0c096f5cdcaca;
module.exports["DATABASE_CREATE_ACTIONS"] = $0c322a09d1b57883$export$45a7157715c10f20;
module.exports["isConfluencePageCreateAction"] = $0c322a09d1b57883$export$6c0ed26dac146a75;
module.exports["isConfluenceCreatableAction"] = $0c322a09d1b57883$export$eac4577c3e50732a;
module.exports["isDynamicUiCreatableAction"] = $0c322a09d1b57883$export$53f0114d9f187b14;
module.exports["isConfluencePageUpdateAction"] = $0c322a09d1b57883$export$dfda1ac7e19cab7b;
module.exports["isConfluenceWhiteboardUpdateAction"] = $0c322a09d1b57883$export$dcbfc8a9b613cd00;
module.exports["isConfluenceDatabaseUpdateAction"] = $0c322a09d1b57883$export$399c9116e9984ca3;
module.exports["isConfluenceUpdatableAction"] = $0c322a09d1b57883$export$73dc9ed6ed2373f;
module.exports["isConfluenceStreamAction"] = $0c322a09d1b57883$export$54716060fc6e52ee;
module.exports["isConfluencePreviewCardAction"] = $0c322a09d1b57883$export$5cb5e5f4b4ce0a33;
module.exports["generateRovoReceiverId"] = $0c322a09d1b57883$export$681cf9ea58de88fd;
module.exports["getConfluenceContentType"] = $0c322a09d1b57883$export$bb9f6b0763834612;
module.exports["isAccumulatedAction"] = $0c322a09d1b57883$export$b95f9369e33f3b4a;
module.exports["getAccumulatedActionTypeGuard"] = $0c322a09d1b57883$export$898d9c03b4eb5dd5;
module.exports["getPrimaryAccumulatedValue"] = $0c322a09d1b57883$export$240debd921ff9f65;
module.exports["customActionUpdater"] = $0c322a09d1b57883$export$64e13fa6a74f5f86;

});

parcelRegister("htiKQ", function(module, exports) {
// ============================================================================
// JIRA SMART ISSUE CREATE
// ============================================================================

var $8IKbl = parcelRequire("8IKbl");


var $eX3ET = parcelRequire("eX3ET");

const $97b023c268fae936$export$5f099b7754a7652a = [
    (0, $8IKbl.JIRA_FIND_ISSUES_KEY),
    (0, $8IKbl.JIRA_ISSUE_CREATE_KEY),
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_V2_KEY),
    (0, $8IKbl.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $8IKbl.JIRA_ISSUE_TRANSITION_KEY),
    (0, $8IKbl.JIRA_EPICS_SUGGEST_KEY),
    (0, $8IKbl.JIRA_ISSUE_DELETE_KEY),
    (0, $8IKbl.JIRA_ISSUE_MOVE_KEY),
    (0, $8IKbl.JIRA_ISSUE_ASSIGN_KEY),
    (0, $8IKbl.JIRA_VERSION_CREATE_KEY)
];
const $97b023c268fae936$export$29b82f3d15178d30 = new Set($97b023c268fae936$export$5f099b7754a7652a);
const $97b023c268fae936$export$211f4719f56285e9 = new Set([
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $97b023c268fae936$export$530aa0daf5811c30 = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && $97b023c268fae936$export$29b82f3d15178d30.has(action?.['key']);
};
const $97b023c268fae936$export$b4d5023312147fc4 = (action)=>$97b023c268fae936$export$530aa0daf5811c30(action) && $97b023c268fae936$export$211f4719f56285e9.has(action.key);
const $97b023c268fae936$export$b5050b797265a8be = (action)=>false;
const $97b023c268fae936$export$a1a30289a72c78b1 = (action)=>false;
const $97b023c268fae936$export$6fe601f4a243e8f4 = (action)=>{
    if (!$97b023c268fae936$export$530aa0daf5811c30(action)) return undefined;
    if ($97b023c268fae936$export$b4d5023312147fc4(action)) return 0, $eX3ET.JIRA_SMART_CREATE_TABLE_CLIENT_ID;
    return undefined;
};
const $97b023c268fae936$export$1643c639e4c073b8 = (action)=>{
    const actionKey = action.key;
    if ($97b023c268fae936$export$211f4719f56285e9.has(actionKey)) return 'jira-issue-table';
    return undefined;
};
// ============================================================================
// JIRA PREVIEW CARDS
// ============================================================================
const $97b023c268fae936$var$PREVIEW_CARD_ACTION_KEYS = new Set([
    (0, $8IKbl.JIRA_SMART_ISSUE_CREATE_ALL_FIELDS_KEY)
]);
const $97b023c268fae936$export$4a1398b92436f797 = (action)=>$97b023c268fae936$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJiraAction"] = $97b023c268fae936$export$530aa0daf5811c30;
module.exports["isJiraCreatableAction"] = $97b023c268fae936$export$b4d5023312147fc4;
module.exports["isJiraUpdatableAction"] = $97b023c268fae936$export$b5050b797265a8be;
module.exports["isJiraStreamAction"] = $97b023c268fae936$export$a1a30289a72c78b1;
module.exports["generateJiraReceiverId"] = $97b023c268fae936$export$6fe601f4a243e8f4;
module.exports["getJiraContentType"] = $97b023c268fae936$export$1643c639e4c073b8;
module.exports["isJiraPreviewCardAction"] = $97b023c268fae936$export$4a1398b92436f797;

});

parcelRegister("9bF5n", function(module, exports) {
// ============================================================================
// JSM CREATE SURVEY
// ============================================================================

var $dh538 = parcelRequire("dh538");


var $8IKbl = parcelRequire("8IKbl");


var $b9NdB = parcelRequire("b9NdB");

const $b06f6240a2781a94$export$4d5c499af23159fb = (0, $b9NdB.client)('jsm-queue-settings');



var $3OJcK = parcelRequire("3OJcK");

const $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP = {
    [(0, $8IKbl.JSM_QUEUE_UPDATED_KEY)]: {
        clientId: (0, $b06f6240a2781a94$export$4d5c499af23159fb),
        contentType: 'jsm-queue-updated'
    }
};
const $7fdb7cabde039026$export$fd2af7ce2e351879 = [
    (0, $8IKbl.JSM_CREATE_EMBEDDED_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_KEY),
    (0, $8IKbl.JSM_CREATE_REQUEST_V2_KEY),
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY),
    (0, $8IKbl.JSM_QUEUE_UPDATED_KEY)
];
const $7fdb7cabde039026$export$7b875f28b9805c0c = new Set($7fdb7cabde039026$export$fd2af7ce2e351879);
const $7fdb7cabde039026$export$3fcc5475955435c4 = new Set([
    (0, $8IKbl.JSM_CREATE_SURVEY_KEY),
    (0, $8IKbl.JSM_QUEUE_UPDATED_KEY)
]);
const $7fdb7cabde039026$export$98885adfb17a807b = (action)=>{
    return typeof action === 'object' && action !== null && 'key' in action && $7fdb7cabde039026$export$7b875f28b9805c0c.has(action?.['key']);
};
const $7fdb7cabde039026$export$29f39e9429d6b955 = (action)=>$7fdb7cabde039026$export$98885adfb17a807b(action) && $7fdb7cabde039026$export$3fcc5475955435c4.has(action.key);
const $7fdb7cabde039026$export$ae7904ebe7bd5bb0 = (action)=>false;
const $7fdb7cabde039026$export$f4d25026329e5a91 = (action)=>false;
const $7fdb7cabde039026$export$af2b121ccb8f1449 = (action)=>{
    if (!$7fdb7cabde039026$export$98885adfb17a807b(action)) return undefined;
    if ((0, $dh538.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP[action.key];
        if (embedView) return embedView.clientId;
    }
    if ($7fdb7cabde039026$export$29f39e9429d6b955(action)) return 0, $3OJcK.JSM_CREATE_SURVEY_CLIENT_ID;
    return undefined;
};
const $7fdb7cabde039026$export$292f03726a3f6528 = (action)=>{
    const actionKey = action.key;
    if ((0, $dh538.fg)('solution_composer_master')) {
        // Embed view actions — driven by lookup map
        const embedView = $7fdb7cabde039026$var$JSM_EMBED_VIEW_MAP[actionKey];
        if (embedView) return embedView.contentType;
    }
    if ($7fdb7cabde039026$export$3fcc5475955435c4.has(actionKey)) return 'jsm-create-survey';
    return undefined;
};
// ============================================================================
// JSM PREVIEW CARDS
// ============================================================================
const $7fdb7cabde039026$var$PREVIEW_CARD_ACTION_KEYS = new Set([]);
const $7fdb7cabde039026$export$c8683ba29b03d037 = (action)=>$7fdb7cabde039026$var$PREVIEW_CARD_ACTION_KEYS.has(action.key);
module.exports["isJsmAction"] = $7fdb7cabde039026$export$98885adfb17a807b;
module.exports["isJsmCreatableAction"] = $7fdb7cabde039026$export$29f39e9429d6b955;
module.exports["isJsmUpdatableAction"] = $7fdb7cabde039026$export$ae7904ebe7bd5bb0;
module.exports["isJsmStreamAction"] = $7fdb7cabde039026$export$f4d25026329e5a91;
module.exports["generateJsmReceiverId"] = $7fdb7cabde039026$export$af2b121ccb8f1449;
module.exports["getJsmContentType"] = $7fdb7cabde039026$export$292f03726a3f6528;
module.exports["isJsmPreviewCardAction"] = $7fdb7cabde039026$export$c8683ba29b03d037;

});

parcelRegister("4eSde", function(module, exports) {

var $16lEl = parcelRequire("16lEl");


var $dgaTK = parcelRequire("dgaTK");

const $487e3aa6cdc75eb3$export$24a03a39abc3110e = ()=>{
    const subExperienceCollect = (0, $dgaTK.collectAllWithSubExperienceAttributes)([
        (0, $16lEl.ExperienceName).AIFC_MESSAGE,
        (0, $16lEl.ExperienceName).AIFC_ALL_DATA_HANDLED
    ]);
    return (events, experience)=>{
        // If AIFC_INITIAL_DATA_RECEIVED fails (timeout or error), fail AIFC_GENERATE_CONTENT
        (0, $dgaTK.failExperienceOnSubExperienceFail)((0, $16lEl.ExperienceName).AIFC_INITIAL_DATA_RECEIVED, experience, events);
        subExperienceCollect(events, experience);
    };
};
module.exports["createAifcExperienceCollect"] = $487e3aa6cdc75eb3$export$24a03a39abc3110e;

});

parcelRegister("eWKku", function(module, exports) {

var $1yaYZ = parcelRequire("1yaYZ");


var $fgOJ7 = parcelRequire("fgOJ7");


var $eL1ct = parcelRequire("eL1ct");


var $6nGJw = parcelRequire("6nGJw");


var $hHa70 = parcelRequire("hHa70");


var $gdg5T = parcelRequire("gdg5T");


var $15h8H = parcelRequire("15h8H");

var $75cf7fb40a3fb800$export$680ab500cb1105eb = /*#__PURE__*/ function(StreamLifecycleState) {
    StreamLifecycleState["COMPLETED"] = "completed";
    StreamLifecycleState["ERRORED"] = "errored";
    StreamLifecycleState["ABORTED"] = "aborted";
    return StreamLifecycleState;
}({});
const $75cf7fb40a3fb800$export$ff6a2981a5436d75 = (status, streamId, content)=>{
    if (!content) return;
    const api = (0, $15h8H.getBrowserBridgeAPI)();
    const id = String(content.id);
    const receiverId = (()=>{
        switch(content.type){
            case 'page':
                return (0, $eL1ct.getConfluenceEditorClientId)(id);
            case 'database':
                return (0, $fgOJ7.getConfluenceDatabaseClientId)(id);
            case 'whiteboard':
                return (0, $6nGJw.getConfluenceWhiteboardClientId)(id);
            default:
                return undefined;
        }
    })();
    try {
        if (!receiverId) return;
        switch(status){
            case "completed":
                api.send((0, $gdg5T.RovoStreamCompletedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "errored":
                api.send((0, $gdg5T.RovoStreamErroredCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            case "aborted":
                api.send((0, $gdg5T.RovoStreamAbortedCommand), {
                    streamId: streamId,
                    contentId: content.id,
                    senderId: (0, $hHa70.ROVO_CHAT_CLIENT_ID),
                    receiverId: receiverId
                });
                break;
            default:
                (0, $1yaYZ.logException)({
                    exception: new Error(`Unknown stream lifecycle state: ${status}`),
                    name: 'UnknownStreamLifecycleState'
                });
        }
    } catch (error) {
        (0, $1yaYZ.logException)({
            exception: error,
            name: 'SendStreamLifecycleCommandError'
        });
    }
};
module.exports["StreamLifecycleState"] = $75cf7fb40a3fb800$export$680ab500cb1105eb;
module.exports["broadcastStreamStatus"] = $75cf7fb40a3fb800$export$ff6a2981a5436d75;

});

parcelRegister("ceMRi", function(module, exports) {
/**
 * Minimum interval threshold in milliseconds.
 * Intervals at or below this threshold are excluded from dead air tracking.
 */ const $c9147b3ca7c52e0c$export$a47f8ff651baafd3 = 20;
const $c9147b3ca7c52e0c$export$1dad78007a379433 = (intervalMs)=>{
    return intervalMs <= $c9147b3ca7c52e0c$export$a47f8ff651baafd3;
};
module.exports["shouldExcludeInterval"] = $c9147b3ca7c52e0c$export$1dad78007a379433;

});

parcelRegister("cteoa", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $deF0K = parcelRequire("deF0K");


var $4pEXC = parcelRequire("4pEXC");


var $16lEl = parcelRequire("16lEl");


var $ljUdP = parcelRequire("ljUdP");


var $flpNp = parcelRequire("flpNp");


var $aclUh = parcelRequire("aclUh");


var $2CHXX = parcelRequire("2CHXX");


var $bPHr8 = parcelRequire("bPHr8");


var $9vgbT = parcelRequire("9vgbT");

const $6bf7a89ae376c5c9$export$ed5572b558d71438 = (ari)=>{
    if (!ari) return null;
    // see go/ari for possible values
    // Example:
    // ari:third-party:amplitude.amplitude::remote-link/org/{orgId}/chart/{chartId}
    // -> amplitude
    const ariParts = ari.split(':');
    if (ariParts.length < 3) return null;
    return ariParts[2];
};



var $iEWar = parcelRequire("iEWar");

const $658a05ad0cb6a20b$export$567fc7097e064344 = ()=>String(Math.floor(Math.random() * 1000000));
const $658a05ad0cb6a20b$export$b043b11900276452 = ({ broadcastStreamStatus: broadcastStreamStatus, chatContextStoreActions: chatContextStoreActions, contentContextValue: contentContextValue, targetId: targetId, assistantMessageId: assistantMessageId })=>{
    return (status)=>{
        let contentTarget;
        // Only use targetId when aifc_multiple_context is enabled
        if ((0, $dh538.fg)('aifc_multiple_context')) contentTarget = chatContextStoreActions.getTarget(contentContextValue, targetId);
        else contentTarget = chatContextStoreActions.getTarget(contentContextValue);
        broadcastStreamStatus?.(status, assistantMessageId, contentTarget ? {
            id: contentTarget.id,
            type: contentTarget.type
        } : undefined);
    };
};
const $658a05ad0cb6a20b$export$bb0ca99caffb8502 = (messages, messageId)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message,
                        content: ''
                    }
                },
                streamingComplete: false
            }
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$d812e3ec408e3b14 = (messages, messageId, answerGenerationType)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message
                    }
                },
                streamingComplete: false
            },
            answerGenerationType: answerGenerationType
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$14aeb537f795ee1a = (messages, messageId, answerNowStatus)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            answerNowStatus: answerNowStatus
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$f9095c96f8c4be7e = (messages, messageId, subAgentMessage)=>{
    return messages.map((chatItem)=>{
        if ((0, $bPHr8.isStoreAssistant)(chatItem) && $658a05ad0cb6a20b$var$getStoreMessageId(chatItem) === messageId) return {
            ...chatItem,
            content: {
                ...chatItem.content,
                message: {
                    ...chatItem.content.message,
                    message: {
                        ...chatItem.content.message.message
                    }
                },
                streamingComplete: false
            },
            dynamicLayoutSubAgentMessages: [
                ...chatItem.dynamicLayoutSubAgentMessages || [],
                subAgentMessage
            ]
        };
        return chatItem;
    });
};
const $658a05ad0cb6a20b$export$a89606c68db527fb = (streamMessage)=>{
    return {
        messageContent: streamMessage.message?.content,
        messageTemplate: streamMessage.message?.message_template
    };
};
const $658a05ad0cb6a20b$export$5782d74d68fa92c6 = (error, prefix = '', actionLoggableNameIfActionExecutionFailed)=>{
    let status_code, message_template, timeout;
    const message = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Unknown error';
    let prefixedMessage = prefix ? `${prefix}: ${message}` : message;
    let errorType;
    let traceId;
    if (error instanceof (0, $iEWar.StreamErrorException)) {
        status_code = error.detail.message.status_code;
        message_template = error.detail.message.message_template;
        timeout = error.detail.metadata?.timeout;
        errorType = 'StreamErrorException';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $flpNp.ApiError)) {
        status_code = error.errorAttributes.statusCode;
        message_template = error.errorAttributes.errorCode;
        errorType = 'ApiError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $iEWar.MessageActionError)) {
        // Prefer showing only the raw API error message (without codes) to end users
        const rawErrorMessage = error.cause && 'errorAttributes' in error.cause && typeof error.cause.errorAttributes === 'object' && error.cause.errorAttributes !== null && 'rawErrorMessage' in error.cause.errorAttributes ? error.cause.errorAttributes.rawErrorMessage : undefined;
        if (typeof rawErrorMessage === 'string') prefixedMessage = prefix ? `${prefix}: ${rawErrorMessage}` : rawErrorMessage;
    }
    if (error instanceof (0, $iEWar.StreamGeneratorError)) {
        errorType = 'StreamGeneratorError';
        traceId = error.errorAttributes.traceId;
    }
    if (error instanceof (0, $iEWar.DeepResearchError)) {
        message_template = error.message_template;
        errorType = 'DeepResearchError';
        traceId = error.errorAttributes.traceId;
    }
    return {
        type: 'ERROR',
        content: prefixedMessage,
        time_created: new Date().toLocaleString(),
        status_code: status_code,
        message_template: message_template,
        timeout: timeout,
        id: $658a05ad0cb6a20b$export$567fc7097e064344(),
        errorType: errorType,
        traceId: traceId,
        storeActionExecutionError: actionLoggableNameIfActionExecutionFailed ? {
            actionLoggableName: actionLoggableNameIfActionExecutionFailed
        } : undefined
    };
};
const $658a05ad0cb6a20b$export$fa05b63813f8a225 = (content)=>({
        type: 'HUMAN',
        content: content
    });
const $658a05ad0cb6a20b$export$2250e3c2fe6e53e5 = (...args)=>({
        type: 'HUMAN',
        content: (0, $aclUh.createHumanMessage)(...args)
    });
const $658a05ad0cb6a20b$export$bd3c429f5e3d2c3e = (content)=>({
        type: 'ASSISTANT',
        content: content
    });
const $658a05ad0cb6a20b$export$f509fd4645870a6e = (args)=>({
        type: 'ASSISTANT',
        content: {
            type: 'FINAL_RESPONSE',
            message: {
                message: {
                    role: 'ASSISTANT',
                    id: args.id,
                    conversation_channel_id: args.conversationId,
                    content: args.content,
                    time_created: new Date().toISOString(),
                    user_ari: 'unknown',
                    plugin_invocations: [],
                    author: {
                        named_id: args.agentNamedId || 'ai_mate_agent',
                        name: 'unknown',
                        actor_type: 'AGENT',
                        ari: null,
                        id: 'unknown'
                    }
                }
            }
        }
    });
const $658a05ad0cb6a20b$var$getStoreMessageId = (storeMessage)=>{
    if ((0, $bPHr8.isStoreAssistant)(storeMessage)) return (0, $aclUh.getId)(storeMessage.content);
    return storeMessage.content.id;
};
const $658a05ad0cb6a20b$export$64b557ae352795d6 = (chat, messageId)=>chat.findIndex((storeMessage)=>(0, $bPHr8.isStoreMessage)(storeMessage) && messageId ? $658a05ad0cb6a20b$var$getStoreMessageId(storeMessage) === messageId : true);
const $658a05ad0cb6a20b$var$updateStoreMessage = ({ chat: chat, messageId: messageId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>{
    // If the chat is empty, return it as is - prevents the 'in' of 'undefined' errors we were seeing
    // TODO: Take this into account with upcoming refactor
    if (!chat.length) return chat;
    const targetIndex = useIndex || $658a05ad0cb6a20b$export$64b557ae352795d6(chat, messageId);
    const targetStoreMessage = chat[targetIndex];
    if (targetIndex < 0 || !(0, $bPHr8.isStoreMessage)(targetStoreMessage)) throw new Error(`Attempting to update a non StoreMessage (${updateType})`);
    if ($658a05ad0cb6a20b$var$getStoreMessageId(targetStoreMessage) !== messageId) throw new Error(`Attempting to update a store message at the wrong index (${updateType})`);
    const newStoreMessage = updateFunction(targetStoreMessage);
    const newChat = [
        ...chat
    ];
    newChat.splice(targetIndex, 1, newStoreMessage);
    return newChat;
};
const $658a05ad0cb6a20b$var$updateStoreAssistant = ({ chat: chat, promptId: promptId, updateFunction: updateFunction, updateType: updateType, useIndex: useIndex })=>$658a05ad0cb6a20b$var$updateStoreMessage({
        chat: chat,
        messageId: promptId,
        updateFunction: (storeMessage)=>{
            if (!(0, $bPHr8.isStoreAssistant)(storeMessage)) throw new Error(`Attempting to update a non StoreAssistant (${updateType})`);
            return updateFunction(storeMessage);
        },
        updateType: updateType,
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$6e5609c05ab74cc7 = ({ chat: chat, answerId: answerId, answerPart: answerPart, useIndex: useIndex })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                }
            }),
        updateType: 'Add Answer Part',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$4287833726c64095 = ({ chat: chat, answerId: answerId, answerPart: answerPart, markdownData: markdownData, useIndex: useIndex })=>{
    const { key: key, content: content, loading: loading } = markdownData;
    const loadingKey = `${key}-loading`;
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addAnswerPart)(storeAssistant.content, answerPart),
                    streamingComplete: false
                },
                markdownData: {
                    ...storeAssistant.markdownData,
                    [key]: (storeAssistant.markdownData?.[key] || '') + content,
                    [loadingKey]: loading ? 'true' : 'false'
                }
            }),
        updateType: 'Add Answer Part With Markdown Data',
        useIndex: useIndex
    });
};
const $658a05ad0cb6a20b$export$13b6a4e4e3704011 = ({ chat: chat, messageId: messageId, actionPart: actionPart, useIndex: useIndex, actionUpdaterOverride: actionUpdaterOverride })=>{
    const findMessage = chat.findIndex((message)=>(0, $bPHr8.isStoreAssistant)(message) && (0, $aclUh.getId)(message.content) === messageId);
    const actionIndex = findMessage > 0 ? findMessage : chat.length - 1;
    const index = useIndex || actionIndex;
    return $658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: messageId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...(0, $aclUh.addActionPart)(storeAssistant.content, actionPart, actionUpdaterOverride)
                }
            }),
        updateType: 'Add Action Part',
        useIndex: index
    });
};
const $658a05ad0cb6a20b$export$4499bf045ea6bd06 = ({ markdownData: markdownData, type: type, index: index })=>{
    return markdownData?.[`${type}-${index}`];
};
const $658a05ad0cb6a20b$export$60e170089d1b35dd = ({ chat: chat, answerId: answerId, content: content, useIndex: useIndex, humanMessageId: humanMessageId, markdownData: markdownData, onMessageIdChanged: onMessageIdChanged })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeMessage)=>{
            const oldId = $658a05ad0cb6a20b$var$getStoreMessageId(storeMessage);
            const newId = content.message.message.id;
            if (oldId !== newId) onMessageIdChanged?.(oldId, newId);
            return {
                ...storeMessage,
                content: {
                    ...content,
                    streamingComplete: false
                },
                humanMessageId: humanMessageId,
                markdownData: markdownData
            };
        },
        updateType: 'Replace Answer Data',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$ba29913b663b084c = ({ chat: chat, oldId: oldId, newId: newId })=>chat.map((message)=>{
        if ((0, $bPHr8.isStoreHuman)(message) && message.content.id === oldId) return {
            ...message,
            content: {
                ...message.content,
                id: newId
            }
        };
        return message;
    });
const $658a05ad0cb6a20b$export$f279e50afd80e7d8 = ({ chat: chat, oldId: oldId, newId: newId })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: oldId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                content: {
                    ...storeAssistant.content,
                    message: {
                        ...storeAssistant.content.message,
                        message: {
                            ...storeAssistant.content.message.message,
                            id: newId
                        }
                    }
                }
            }),
        updateType: 'Update Store Assistant Message ID'
    });
const $658a05ad0cb6a20b$export$680d2bb5b9579c57 = (chat)=>chat.map((message)=>{
        if ((0, $bPHr8.isStoreAssistant)(message) && !message.content.streamingComplete) return {
            ...message,
            content: {
                ...message.content,
                streamingComplete: true
            },
            // Clear answerNowStatus when streaming completes (success, error, or abort)
            answerNowStatus: undefined
        };
        return message;
    });
const $658a05ad0cb6a20b$export$24d2e7dc410ce2e5 = (chat, startFromMessageId, messageCount = 1)=>{
    const messageIndex = $658a05ad0cb6a20b$export$64b557ae352795d6(chat, startFromMessageId);
    if (messageIndex < 0) return [];
    const messageHistory = chat.slice(Math.max(0, messageIndex - messageCount), messageIndex + 1);
    return messageHistory;
};
const $658a05ad0cb6a20b$export$b53f205a52449551 = ({ lastAgentMessageStatus: lastAgentMessageStatus })=>({
        status: (0, $bPHr8.CHAT_STORE_STATUS).idle,
        traces: [],
        storeAbortController: undefined,
        ...lastAgentMessageStatus !== undefined && {
            lastAgentMessageStatus: lastAgentMessageStatus
        }
    });
const $658a05ad0cb6a20b$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        content: (0, $aclUh.removeSensitiveData)(message.content)
    });
const $658a05ad0cb6a20b$export$a2ff1144002a6147 = (state, id)=>{
    return state.conversations[id];
};
const $658a05ad0cb6a20b$export$80b847bfebcaa3fd = (state, id)=>{
    return !!id && state.conversations[state.currentConversationId]?.sourceId === id;
};
const $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c = (messages)=>{
    return $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreHuman));
};
const $658a05ad0cb6a20b$export$2813a13604911e2d = (messages)=>{
    try {
        const last = $658a05ad0cb6a20b$export$296de88ccac4bedb(messages, (0, $bPHr8.isStoreAssistant));
        return last?.content.message.message.id;
    } catch  {
        return undefined;
    }
};
const $658a05ad0cb6a20b$export$1ba374c59efc126c = (messages)=>{
    return $658a05ad0cb6a20b$export$d9047a7a8ec8ea5c(messages)?.content.requestId;
};
const $658a05ad0cb6a20b$export$7fd69d5cdd838542 = (messages, messageId)=>{
    let index = -1;
    const result = messages.find((item, i)=>{
        index = i;
        return (0, $bPHr8.isStoreAssistant)(item) && (0, $aclUh.getId)(item.content) === messageId;
    });
    return result ? {
        result: result,
        index: index
    } : {
        result: false,
        index: index
    };
};
const $658a05ad0cb6a20b$export$3dfca8d0ecaaf31f = ({ messages: messages, messageId: messageId, searchType: searchType })=>{
    const startIndex = messages.findIndex((item)=>{
        switch(item.type){
            case 'HUMAN':
                return item.content.id === messageId;
            case 'ASSISTANT':
                return item.content.message.message.id === messageId;
            case 'FOLLOW_UP':
                return String(item.id) === messageId;
            default:
                return false;
        }
    });
    for(let i = startIndex; i >= 0; i--){
        if (messages[i].type === searchType) return messages[i];
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$1a288f9aecfed8b4 = (messages, agentMessageId)=>{
    try {
        const agentMessage = $658a05ad0cb6a20b$export$7fd69d5cdd838542(messages, agentMessageId).result;
        if (agentMessage && (0, $bPHr8.isStoreAssistant)(agentMessage)) {
            const foundId = $658a05ad0cb6a20b$export$3dfca8d0ecaaf31f({
                messages: messages,
                messageId: agentMessageId,
                searchType: 'HUMAN'
            })?.content.id;
            return foundId ? String(foundId) : undefined;
        }
    } catch  {
        return undefined;
    }
};
const $658a05ad0cb6a20b$export$1cdaa2c4089128bd = (chat, requestId)=>{
    const lastHumanMessage = $658a05ad0cb6a20b$export$296de88ccac4bedb(chat, (0, $bPHr8.isStoreHuman));
    // Skip if there is no last human message or if the requestId is already set
    if (!lastHumanMessage || !requestId || !!lastHumanMessage.content.requestId) return chat;
    const newHumanMessage = {
        ...lastHumanMessage,
        content: {
            ...lastHumanMessage.content,
            requestId: requestId
        }
    };
    const newChat = [
        ...chat
    ];
    newChat[newChat.lastIndexOf(lastHumanMessage)] = newHumanMessage;
    return newChat;
};
const $658a05ad0cb6a20b$export$b178621992ef9541 = (conversationId)=>conversationId === (0, $2CHXX.EMPTY_CONVERSATION_ID) || conversationId === undefined;
const $658a05ad0cb6a20b$export$3902b208060a7183 = (chatStatus, conversationStatus)=>{
    return chatStatus === 'launching' || conversationStatus === (0, $bPHr8.CHAT_STORE_STATUS).loadingChat;
};
const $658a05ad0cb6a20b$export$2126c56dcace27e4 = ({ chat: chat, type: type, index: index })=>{
    const lastIndex = chat.map((item)=>item.type).lastIndexOf(type);
    return lastIndex === index;
};
const $658a05ad0cb6a20b$export$d669251a312339ff = (chat, type)=>{
    const lastIndex = chat.map((item)=>item.type).indexOf(type);
    if (lastIndex >= 0) return chat[lastIndex];
};
const $658a05ad0cb6a20b$export$296de88ccac4bedb = (array, predicate)=>{
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return array[i];
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$8855a8be7bd3e9f8 = (array, predicate)=>{
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i])) return i;
    }
    return -1;
};
const $658a05ad0cb6a20b$export$ab93cd1ecacda8ec = (messages, conversation)=>{
    const assistantMessage = messages.find((message)=>(0, $bPHr8.isStoreAssistant)(message));
    return conversation?.sourceAgentId ?? assistantMessage?.content.message.message.author_id;
};
const $658a05ad0cb6a20b$export$25a2389a84d1a0a0 = (timeStamp, conversationId)=>{
    // More detail on djb2 hash function https://theartincode.stanis.me/008-djb2/
    let hash = 5381;
    if (!timeStamp || !conversationId) return hash;
    const concat = conversationId + timeStamp;
    for(let i = 0; i < concat.length; i++)// Update the hash value
    hash = (hash << 5) + hash + concat.charCodeAt(i); // hash * 33 + c
    // Ensure the hash is a positive integer
    return hash >>> 0;
};
const $658a05ad0cb6a20b$export$eca740b13a7a3080 = (conversationId)=>String($658a05ad0cb6a20b$export$25a2389a84d1a0a0(new Date().toISOString(), conversationId));
const $658a05ad0cb6a20b$export$9de2c1973de15b05 = (sources)=>{
    if (!sources) return {};
    const citedProductList = {};
    sources.forEach((source)=>{
        const productName = (0, $6bf7a89ae376c5c9$export$ed5572b558d71438)(source.ari);
        if (productName) citedProductList[productName] = (citedProductList[productName] ?? 0) + 1;
    });
    return citedProductList;
};
const $658a05ad0cb6a20b$export$66fc5003b23b7a8c = (sources)=>{
    if (!sources) return {};
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
// Helper function to escape special regex characters
function $658a05ad0cb6a20b$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const $658a05ad0cb6a20b$export$bb73d89e7217c465 = ({ streamMessage: streamMessage, boundaryStart: boundaryStart, boundaryEnd: boundaryEnd, replacementContent: replacementContent })=>{
    let processedStreamMessage = streamMessage;
    let boundaryContents = [];
    let messageContent = (0, $ljUdP.isStreamResponse)(streamMessage) ? streamMessage.message.message.content : streamMessage.message.content;
    if (!messageContent) return {
        processedStreamMessage: processedStreamMessage,
        boundaryContents: boundaryContents
    };
    if (typeof messageContent === 'string') {
        const regex = new RegExp(`${$658a05ad0cb6a20b$var$escapeRegExp(boundaryStart)}(.*?)${$658a05ad0cb6a20b$var$escapeRegExp(boundaryEnd)}`, 'gs');
        let match;
        let newContent = messageContent;
        let found = false;
        while((match = regex.exec(messageContent)) !== null){
            boundaryContents.push(match[1]);
            newContent = newContent.replace(match[0], replacementContent ?? '');
            found = true;
        }
        if (found) {
            if ((0, $ljUdP.isStreamResponse)(processedStreamMessage)) processedStreamMessage.message.message.content = newContent;
            else processedStreamMessage.message.content = newContent;
        }
    }
    return {
        processedStreamMessage: processedStreamMessage,
        boundaryContents: boundaryContents
    };
};
const $658a05ad0cb6a20b$export$b77ba8e4ec693266 = (jsonString)=>{
    try {
        const parsed = JSON.parse(jsonString);
        if ((0, $4pEXC.isAdfContent)(parsed)) return true;
        return false;
    } catch  {
        return false;
    }
};
const $658a05ad0cb6a20b$var$serviceDeskSourceRegex = /https:\/\/[a-zA-Z0-9_.-]+\/servicedesk\/customer\//g;
const $658a05ad0cb6a20b$export$b9ac6250c4aba7c6 = (pluginOutput)=>{
    return $658a05ad0cb6a20b$var$serviceDeskSourceRegex.test(pluginOutput);
};
const $658a05ad0cb6a20b$export$c37d58cb6fcaff84 = ()=>[
        {
            key: 'expand',
            startTag: "\u259E",
            endTag: "\u259A",
            placeholderTag: '[^expand^]',
            isEnabled: (0, $dh538.fg)('di_chat_stream_expands')
        },
        {
            key: 'chart',
            startTag: "\u25F4",
            endTag: "\u25F6",
            placeholderTag: '[^chart^]',
            isEnabled: true
        }
    ];
const $658a05ad0cb6a20b$export$11d94ded1c502e7b = ({ streamMessage: streamMessage, currentLoadingKey: currentLoadingKey, previousKey: previousKey, componentType: componentType })=>{
    const componentConfig = $658a05ad0cb6a20b$export$c37d58cb6fcaff84().find((c)=>c.key === componentType);
    if (!componentConfig) return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: currentLoadingKey,
        previousKey: previousKey,
        markdownData: null
    };
    const { startTag: startTag, endTag: endTag, placeholderTag: placeholderTag, key: key } = componentConfig;
    const messageContent = streamMessage.message.content;
    let streamingMarkdownContent = '';
    let newLoadingKey = currentLoadingKey;
    let newPreviousKey = previousKey;
    let markdownData = null;
    if (typeof messageContent === 'string') {
        const hasCloseTag = messageContent.includes(endTag);
        if (hasCloseTag && currentLoadingKey && currentLoadingKey.startsWith(`${key}-`)) {
            const [contentBeforeCloseTag, contentAfterCloseTag] = messageContent.split(endTag);
            streamingMarkdownContent = contentBeforeCloseTag;
            streamMessage.message.content = contentAfterCloseTag;
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: false
            };
            newPreviousKey = currentLoadingKey;
            newLoadingKey = null;
        } else if (messageContent.includes(startTag) && !currentLoadingKey) {
            const currentCount = previousKey == null ? -1 : parseInt(previousKey.substring(`${key}-`.length), 10);
            newLoadingKey = `${key}-${currentCount + 1}`;
            const [contentBeforeOpenTag, contentAfterOpenTag] = messageContent.split(startTag);
            streamMessage.message.content = contentBeforeOpenTag + placeholderTag;
            streamingMarkdownContent = contentAfterOpenTag;
            markdownData = {
                key: newLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = newLoadingKey;
        } else if (currentLoadingKey) {
            streamingMarkdownContent = messageContent;
            streamMessage.message.content = '';
            markdownData = {
                key: currentLoadingKey,
                content: streamingMarkdownContent,
                loading: true
            };
            newPreviousKey = currentLoadingKey;
        }
    }
    return {
        processedStreamMessage: streamMessage,
        currentLoadingKey: newLoadingKey,
        previousKey: newPreviousKey,
        markdownData: markdownData
    };
};
const $658a05ad0cb6a20b$export$f0a9473b2d3b8f30 = ()=>{
    let currentLoadingKeys = {};
    let previousKeys = {};
    return (streamMessage)=>{
        let processedStreamMessage = streamMessage;
        let newCurrentLoadingKeys = {
            ...currentLoadingKeys
        };
        let newPreviousKeys = {
            ...previousKeys
        };
        let markdownData = null;
        let processedComponentType = null;
        for (const component of $658a05ad0cb6a20b$export$c37d58cb6fcaff84()){
            if (!component.isEnabled) continue;
            const currentLoadingKey = currentLoadingKeys[component.key] || null;
            const previousKey = previousKeys[component.key] || null;
            const result = $658a05ad0cb6a20b$export$11d94ded1c502e7b({
                streamMessage: processedStreamMessage,
                currentLoadingKey: currentLoadingKey,
                previousKey: previousKey,
                componentType: component.key
            });
            if (result.markdownData) {
                processedStreamMessage = result.processedStreamMessage;
                newCurrentLoadingKeys[component.key] = result.currentLoadingKey;
                newPreviousKeys[component.key] = result.previousKey;
                markdownData = result.markdownData;
                processedComponentType = component.key;
                break; // Only process one component type per call
            }
        }
        currentLoadingKeys = newCurrentLoadingKeys;
        previousKeys = newPreviousKeys;
        return {
            processedStreamMessage: processedStreamMessage,
            markdownData: markdownData,
            processedComponentType: processedComponentType
        };
    };
};
function $658a05ad0cb6a20b$export$5ab2d78f2e4dba11(message, context) {
    if (!(0, $ljUdP.isActionExecutedSuccessfully)(message)) return 'errored';
    return (0, $ljUdP.isActionResolutionCancelled)(context) ? 'cancelled' : 'finished';
}
const $658a05ad0cb6a20b$export$886a0387c1c465f5 = (error)=>{
    if (!error) return false;
    // Server-sent error chunks are wrapped as StreamErrorException and should be excluded
    if (error instanceof (0, $iEWar.StreamErrorException)) return false;
    // Any ApiError (or object exposing errorAttributes.statusCode) comes from the HTTP layer, so exclude
    if (error instanceof (0, $flpNp.ApiError) || error?.errorAttributes?.statusCode) return false;
    const message = error?.message;
    // When the backend terminates the stream abruptly we get a JSON parsing error, so we treat it as server-side
    // See onversation-assistant-service/src/services/assistance-service/read-json-stream/index.ts
    if (typeof message === 'string' && message.startsWith('Error Processing Stream Data')) return false;
    // Whatever remains is considered a client/network error
    return true;
};
const $658a05ad0cb6a20b$export$24c718731d9a7b6a = (messages, predicate)=>{
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg)) {
            const actionParts = msg.content.message?.message?.actions ?? [];
            const action = $658a05ad0cb6a20b$export$296de88ccac4bedb(actionParts, predicate);
            if (action) return action;
        }
    }
    return undefined;
};
const $658a05ad0cb6a20b$export$acbf6433e9af643f = (allMessages, conversationId, traceId, chatContextStoreActions, experienceTracker, getMessages, setMessages, sendMessageLatencyMetrics, cancelStreamingMetrics, commonExperienceAttributes, productKey)=>{
    // Some products do not require first response to be an action,
    // so exit early when we're not within Confluence
    if (productKey !== 'confluence') return true;
    const humanMessageCount = allMessages.filter((0, $bPHr8.isStoreHuman)).length;
    // Only execute on the first human message within the staging area
    if (chatContextStoreActions.getIsStagingArea() && humanMessageCount === 1) {
        const firstAssistantResponse = allMessages.find((0, $bPHr8.isStoreAssistant));
        const firstAction = firstAssistantResponse?.content?.message?.message?.actions?.[0];
        const hasCreatableAction = (0, $deF0K.isCreatableAction)({
            key: firstAction?.key ?? ''
        });
        const authUrl = (0, $9vgbT.extractOutboundAuthLink)(firstAssistantResponse?.content?.message?.message?.content ?? '');
        // Experience handling for the scenario where there
        // should be an action returned but there was not
        if (!hasCreatableAction) {
            // If authUrl is present, abort the experience
            if (authUrl) experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                reason: 'authentication-required',
                attributes: commonExperienceAttributes
            });
            else {
                // Otherwise, fail the experience & show an error in the UI
                const noActionError = new (0, $iEWar.NoActionInvokedError)("The content couldn't be created. Please try again", {
                    traceId: traceId
                });
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).AIFC_GENERATE_CONTENT,
                    error: noActionError,
                    attributes: {
                        ...commonExperienceAttributes,
                        reason: 'no-action-invoked'
                    }
                });
                const messages = getMessages(conversationId);
                // This is to show the error in the UI
                setMessages(conversationId, [
                    ...messages,
                    $658a05ad0cb6a20b$export$5782d74d68fa92c6(noActionError)
                ]);
                // Stop metrics before returning
                sendMessageLatencyMetrics.cancel();
                cancelStreamingMetrics();
                return false;
            }
        }
    }
    return true;
};
const $658a05ad0cb6a20b$export$82b32799d0ea512c = ({ streamMessage: streamMessage, messageId: messageId, conversationId: conversationId, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    let processedStreamMessage = streamMessage;
    const markdownData = {};
    if ((0, $dh538.fg)('rovo_enable_data_sculptor')) {
        const dataSculptorMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
            streamMessage: processedStreamMessage,
            boundaryStart: '[^sculptor:start^]',
            boundaryEnd: '[^sculptor:end^]',
            replacementContent: '[^sculptor^]'
        });
        processedStreamMessage = dataSculptorMsg.processedStreamMessage;
        dataSculptorMsg.boundaryContents.forEach((content, index)=>{
            markdownData[`sculptor-${index}`] = content;
        });
    }
    const expandOpenTag = "\u259E";
    const expandCloseTag = "\u259A";
    const expandPlaceholder = '[^expand^]';
    const expandMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: processedStreamMessage,
        boundaryStart: expandOpenTag,
        boundaryEnd: expandCloseTag,
        replacementContent: expandPlaceholder
    });
    processedStreamMessage = expandMsg.processedStreamMessage;
    expandMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`expand-${index}`] = content;
    });
    if (expandMsg?.boundaryContents && expandMsg.boundaryContents.length > 0) sendAnalyticsEvent({
        eventType: 'track',
        action: 'viewed',
        actionSubject: 'expandComponent',
        attributes: {
            messageId: messageId,
            conversationId: conversationId,
            expandCount: expandMsg.boundaryContents.length,
            timestamp: new Date().toISOString(),
            isFinalResponse: true
        }
    });
    const chartOpenTag = "\u25F4";
    const chartCloseTag = "\u25F6";
    const chartPlaceholder = '[^chart^]';
    const chartMsg = $658a05ad0cb6a20b$export$bb73d89e7217c465({
        streamMessage: processedStreamMessage,
        boundaryStart: chartOpenTag,
        boundaryEnd: chartCloseTag,
        replacementContent: chartPlaceholder
    });
    processedStreamMessage = chartMsg.processedStreamMessage;
    chartMsg.boundaryContents.forEach((content, index)=>{
        markdownData[`chart-${index}`] = content;
    });
    if (chartMsg?.boundaryContents && chartMsg.boundaryContents.length > 0) sendAnalyticsEvent({
        eventType: 'track',
        action: 'extracted',
        actionSubject: 'vizPluginChart',
        attributes: {
            messageId: messageId,
            conversationId: conversationId,
            chartCount: chartMsg.boundaryContents.length,
            timestamp: new Date().toISOString()
        }
    });
    return {
        processedStreamMessage: processedStreamMessage,
        markdownData: markdownData
    };
};
const $658a05ad0cb6a20b$export$e3f334fc6effa531 = ({ chat: chat, answerId: answerId, useIndex: useIndex, memory: memory })=>$658a05ad0cb6a20b$var$updateStoreAssistant({
        chat: chat,
        promptId: answerId,
        updateFunction: (storeAssistant)=>({
                ...storeAssistant,
                memory: memory
            }),
        updateType: 'Add memory',
        useIndex: useIndex
    });
const $658a05ad0cb6a20b$export$2244b7838be162ca = (response)=>{
    const sources = response.message?.message?.sources;
    const pluginInvocations = response.message?.message?.plugin_invocations;
    const minionOutputs = response.message?.message?.minion_outputs;
    const pluginsInvoked = [];
    const skillsInvoked = [];
    let usesJsm = false;
    pluginInvocations?.forEach((pi)=>{
        if (pi.plugin_name) pluginsInvoked.push(pi.plugin_name);
        if (pi.plugin_output && $658a05ad0cb6a20b$export$b9ac6250c4aba7c6(pi.plugin_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    const executedStratusSkill = (minionOutputs && minionOutputs.some((output)=>output.skill_type === 'STRATUS')) ?? false;
    minionOutputs?.flat().forEach((output)=>{
        pluginsInvoked.push(output.minion_id);
        skillsInvoked.push({
            minionId: output.minion_id,
            skillName: output.skill_alias,
            skillType: output.skill_type,
            invocationType: output.directly_invoked ? 'explicit' : 'implicit',
            internalTools: output.internal_tools?.map((tool)=>({
                    name: tool.name,
                    isConsequential: tool.is_consequential
                })) ?? []
        });
        if (output.minion_output && $658a05ad0cb6a20b$export$b9ac6250c4aba7c6(output.minion_output) && (0, $dh538.fg)('rovo_chat_analytics_source_extended')) usesJsm = true;
    });
    return {
        citedProductList: $658a05ad0cb6a20b$export$9de2c1973de15b05(sources),
        sourceProducts: $658a05ad0cb6a20b$export$66fc5003b23b7a8c(sources),
        pluginsInvoked: pluginsInvoked,
        skillsInvoked: skillsInvoked,
        executedStratusSkill: executedStratusSkill,
        messageActions: response.message?.message?.actions?.map((action)=>action.key),
        responseSources: (0, $dh538.fg)('rovo_chat_analytics_source_extended') ? sources?.map((x)=>x.ari).filter(Boolean) : undefined,
        usesJsm: (0, $dh538.fg)('rovo_chat_analytics_source_extended') ? usesJsm : undefined,
        scenarioId: response.message?.message?.scenario?.id
    };
};
module.exports["generateId"] = $658a05ad0cb6a20b$export$567fc7097e064344;
module.exports["createBroadcastStreamLifecycle"] = $658a05ad0cb6a20b$export$b043b11900276452;
module.exports["clearStoreAssistantMessageContent"] = $658a05ad0cb6a20b$export$bb0ca99caffb8502;
module.exports["updateStoreAssistantMessageAnswerGenerationType"] = $658a05ad0cb6a20b$export$d812e3ec408e3b14;
module.exports["updateStoreAssistantMessageAnswerNowStatus"] = $658a05ad0cb6a20b$export$14aeb537f795ee1a;
module.exports["addSubAgentMessageToStoreAssistantMessage"] = $658a05ad0cb6a20b$export$f9095c96f8c4be7e;
module.exports["getTraceFromStreamMessage"] = $658a05ad0cb6a20b$export$a89606c68db527fb;
module.exports["createStoreError"] = $658a05ad0cb6a20b$export$5782d74d68fa92c6;
module.exports["createStoreHumanWithContent"] = $658a05ad0cb6a20b$export$fa05b63813f8a225;
module.exports["createStoreHuman"] = $658a05ad0cb6a20b$export$2250e3c2fe6e53e5;
module.exports["createStoreAssistantWithContent"] = $658a05ad0cb6a20b$export$bd3c429f5e3d2c3e;
module.exports["createStoreAssistant"] = $658a05ad0cb6a20b$export$f509fd4645870a6e;
module.exports["findStoreMessageIndex"] = $658a05ad0cb6a20b$export$64b557ae352795d6;
module.exports["addAnswerPart"] = $658a05ad0cb6a20b$export$6e5609c05ab74cc7;
module.exports["addAnswerPartWithMarkdownData"] = $658a05ad0cb6a20b$export$4287833726c64095;
module.exports["addActionPart"] = $658a05ad0cb6a20b$export$13b6a4e4e3704011;
module.exports["getMarkdownDataByType"] = $658a05ad0cb6a20b$export$4499bf045ea6bd06;
module.exports["replaceAnswerData"] = $658a05ad0cb6a20b$export$60e170089d1b35dd;
module.exports["updateHumanMessageId"] = $658a05ad0cb6a20b$export$ba29913b663b084c;
module.exports["updateStoreAssistantMessageId"] = $658a05ad0cb6a20b$export$f279e50afd80e7d8;
module.exports["markStreamingMessagesAsComplete"] = $658a05ad0cb6a20b$export$680d2bb5b9579c57;
module.exports["getMessageHistory"] = $658a05ad0cb6a20b$export$24d2e7dc410ce2e5;
module.exports["clearStatus"] = $658a05ad0cb6a20b$export$b53f205a52449551;
module.exports["removeSensitiveData"] = $658a05ad0cb6a20b$export$efd4f6b5d168b654;
module.exports["getConversation"] = $658a05ad0cb6a20b$export$a2ff1144002a6147;
module.exports["checkActiveConversationMatchesSource"] = $658a05ad0cb6a20b$export$80b847bfebcaa3fd;
module.exports["findLast"] = $658a05ad0cb6a20b$export$296de88ccac4bedb;
module.exports["getLastAgentMessageID"] = $658a05ad0cb6a20b$export$2813a13604911e2d;
module.exports["getAgentMessageById"] = $658a05ad0cb6a20b$export$7fd69d5cdd838542;
module.exports["getAssociatedHumanMessageId"] = $658a05ad0cb6a20b$export$1a288f9aecfed8b4;
module.exports["addRequestIdToLatestHumanMessage"] = $658a05ad0cb6a20b$export$1cdaa2c4089128bd;
module.exports["isEmptyConversation"] = $658a05ad0cb6a20b$export$b178621992ef9541;
module.exports["isChatLoading"] = $658a05ad0cb6a20b$export$3902b208060a7183;
module.exports["getFirstMessageOfType"] = $658a05ad0cb6a20b$export$d669251a312339ff;
module.exports["findLastIndex"] = $658a05ad0cb6a20b$export$8855a8be7bd3e9f8;
module.exports["getSourceAgentId"] = $658a05ad0cb6a20b$export$ab93cd1ecacda8ec;
module.exports["generateTmpMessageId"] = $658a05ad0cb6a20b$export$eca740b13a7a3080;
module.exports["constructCitedProductList"] = $658a05ad0cb6a20b$export$9de2c1973de15b05;
module.exports["constructSourceProducts"] = $658a05ad0cb6a20b$export$66fc5003b23b7a8c;
module.exports["extractMarkdownContent"] = $658a05ad0cb6a20b$export$bb73d89e7217c465;
module.exports["isValidAdfJsonString"] = $658a05ad0cb6a20b$export$b77ba8e4ec693266;
module.exports["containsServiceDeskSource"] = $658a05ad0cb6a20b$export$b9ac6250c4aba7c6;
module.exports["createStreamMarkdownProcessor"] = $658a05ad0cb6a20b$export$f0a9473b2d3b8f30;
module.exports["deriveInvocationStatus"] = $658a05ad0cb6a20b$export$5ab2d78f2e4dba11;
module.exports["isClientSideStreamingError"] = $658a05ad0cb6a20b$export$886a0387c1c465f5;
module.exports["findLastAssistantAction"] = $658a05ad0cb6a20b$export$24c718731d9a7b6a;
module.exports["handleStagingAreaActionValidation"] = $658a05ad0cb6a20b$export$acbf6433e9af643f;
module.exports["processStreamResponseMarkdown"] = $658a05ad0cb6a20b$export$82b32799d0ea512c;
module.exports["addMemorytoLatestAssistantMessage"] = $658a05ad0cb6a20b$export$e3f334fc6effa531;
module.exports["extractStreamMeta"] = $658a05ad0cb6a20b$export$2244b7838be162ca;

});

parcelRegister("9vgbT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $jEzab = parcelRequire("jEzab");


var $72hrp = parcelRequire("72hrp");

const $842f00fe6a20cb59$export$4124b3cbf6d26820 = ({ useSmartCreationChatStoreApi: useSmartCreationChatStoreApi })=>{
    const { activeConversation: activeConversation } = useSmartCreationChatStoreApi();
    const [chatMessages] = (0, $jEzab.useChatMessages)({
        conversationId: activeConversation?.id
    });
    return (0, $42omo.useMemo)(()=>{
        if (!(0, $dh538.fg)('aifc_show_connected_apps_auth_login_screen')) return null;
        if (chatMessages.length === 0) return null;
        const lastAssistantMessage = (0, $72hrp.findLastAssistantMessage)(chatMessages);
        if (!lastAssistantMessage) return null;
        return $842f00fe6a20cb59$export$74c2c8fe0412025(lastAssistantMessage?.content?.message?.message?.content ?? '');
    }, [
        chatMessages
    ]);
};
function $842f00fe6a20cb59$export$74c2c8fe0412025(content) {
    if (!content) return null;
    let textContent;
    if (typeof content === 'object') textContent = JSON.stringify(content);
    else textContent = content;
    const regex = /https:\/\/id\.(stg\.internal\.)?atlassian\.com\/outboundAuth\/start[^\s)"]*/g;
    const matches = textContent.match(regex);
    return matches ? matches[0] : null;
}
module.exports["useLastAssistantMessageAuthLink"] = $842f00fe6a20cb59$export$4124b3cbf6d26820;
module.exports["extractOutboundAuthLink"] = $842f00fe6a20cb59$export$74c2c8fe0412025;

});

parcelRegister("72hrp", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $3wgAM = parcelRequire("3wgAM");


var $deF0K = parcelRequire("deF0K");


var $bPHr8 = parcelRequire("bPHr8");

function $f56e0f5c5904b36b$export$17828fb10c7c5928(messages, messageId) {
    return messages.find((msg)=>(0, $bPHr8.isStoreAssistant)(msg) && msg.content.message.message.id === messageId);
}
function $f56e0f5c5904b36b$export$c5f84c389beb0191(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((0, $deF0K.isCreatableAction))) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$551dda091e9d40ca(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg) && (msg.content.message.message.actions || []).some((0, $deF0K.isAIFCAction))) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$6f9d326b409b8a89(messages) {
    for(let i = messages.length - 1; i >= 0; i--){
        const msg = messages[i];
        if ((0, $bPHr8.isStoreAssistant)(msg)) return msg;
    }
    return undefined;
}
function $f56e0f5c5904b36b$export$e839ab847bfd35fb(message) {
    const action = message.content.message.message.actions?.find((0, $deF0K.isCreatableAction));
    const contentId = action?.data?.contentId;
    // always make it a string since the final response sometimes returns a number and re-renders the iframe.
    return contentId === undefined ? undefined : String(contentId);
}
function $f56e0f5c5904b36b$export$460905b2c4dc18c9(message) {
    return message?.content?.message?.message?.actions?.[0];
}
function $f56e0f5c5904b36b$export$b05803156e5015b6(message) {
    const action = message?.content?.message?.message?.actions?.find((0, $deF0K.isCreatableAction));
    return action?.data?.title;
}
function $f56e0f5c5904b36b$export$4382776317fc294f(message) {
    if (!message) return undefined;
    const aifcAction = message?.content?.message?.message?.actions?.find((0, $deF0K.isAIFCAction));
    if (aifcAction) {
        const status = aifcAction?.status?.toLowerCase();
        if (status === 'preparing' || status === 'streaming') return status;
        // 'Planned' is the same as a final response. If we see it, assume streaming is complete.
        if (status === 'planned' || status === 'finished' || status === 'cancelled' || message.content.streamingComplete) return 'complete';
    }
    return undefined;
}
function $f56e0f5c5904b36b$var$getStableMessageParts(message) {
    const action = message.content.message.message.actions?.find((0, $deF0K.isCreatableAction));
    const actionData = action?.data;
    // We just pick the parts we care about directly from the message
    // We avoid ADF since that is streamed and changes all the time.
    return {
        messageId: message.content.message.message.id,
        streamingComplete: message.content.streamingComplete,
        action: actionData ? (0, (/*@__PURE__*/$parcel$interopDefault($3wgAM)))(actionData, [
            'contentId',
            'title'
        ]) : undefined,
        status: action?.status
    };
}
function $f56e0f5c5904b36b$export$c90c71e0e0065a6(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))($f56e0f5c5904b36b$var$getStableMessageParts(a), $f56e0f5c5904b36b$var$getStableMessageParts(b));
}
module.exports["findMessageById"] = $f56e0f5c5904b36b$export$17828fb10c7c5928;
module.exports["findLastMessageWithCreateAction"] = $f56e0f5c5904b36b$export$c5f84c389beb0191;
module.exports["findLastMessageWithAIFCAction"] = $f56e0f5c5904b36b$export$551dda091e9d40ca;
module.exports["findLastAssistantMessage"] = $f56e0f5c5904b36b$export$6f9d326b409b8a89;
module.exports["extractContentId"] = $f56e0f5c5904b36b$export$e839ab847bfd35fb;
module.exports["getFirstMessageAction"] = $f56e0f5c5904b36b$export$460905b2c4dc18c9;
module.exports["extractTitle"] = $f56e0f5c5904b36b$export$b05803156e5015b6;
module.exports["getAIFCActionStatus"] = $f56e0f5c5904b36b$export$4382776317fc294f;
module.exports["areMessagesEqual"] = $f56e0f5c5904b36b$export$c90c71e0e0065a6;

});

parcelRegister("dgaTK", function(module, exports) {
const $c70599da8b0bb884$export$51ee55de82fed0a0 = (subExperienceNameToCheck, mainExperienceToFail, events)=>{
    const subExperienceFailEvent = events.find((event)=>event.action === 'taskFail' && event.name === subExperienceNameToCheck);
    if (subExperienceFailEvent) mainExperienceToFail.fail({
        error: subExperienceFailEvent.error,
        attributes: subExperienceFailEvent.attributes
    });
};
const $c70599da8b0bb884$export$da415d22ae15cf08 = (subExperiences)=>{
    const subExperienceNameSet = new Set(subExperiences);
    const mergedAttributes = {};
    return (events, experience)=>{
        // all subExperiences must succeed for the parent experience to succeed
        // a failure/abort to any subExperience will fail/abort the parent experience
        events.forEach((event)=>{
            if (subExperienceNameSet.has(event.name)) switch(event.action){
                case 'taskSuccess':
                    if (subExperienceNameSet.delete(event.name)) Object.assign(mergedAttributes, event.attributes ?? {});
                    break;
                case 'taskFail':
                    if ('error' in event) experience.fail({
                        error: event.error,
                        attributes: event.attributes
                    });
                    break;
                case 'taskAbort':
                    experience.abort({
                        reason: `${event.name} aborted`,
                        attributes: {
                            ...event.attributes,
                            childAbortReason: event.reason
                        }
                    });
                    break;
            }
        });
        if (subExperienceNameSet.size === 0) experience.succeed(mergedAttributes);
    };
};
module.exports["failExperienceOnSubExperienceFail"] = $c70599da8b0bb884$export$51ee55de82fed0a0;
module.exports["collectAllWithSubExperienceAttributes"] = $c70599da8b0bb884$export$da415d22ae15cf08;

});

parcelRegister("iEWar", function(module, exports) {
const $39527fcfea4df9b6$var$generateTraceId = ()=>`${Date.now().toString(16)}-${Math.floor(Math.random() * 1e4).toString(16)}`;
class $39527fcfea4df9b6$export$7ed16f132715a198 extends Error {
    constructor(message, params){
        const { detail: detail, traceId: traceId } = params;
        super(message);
        this.detail = void 0;
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.detail = detail;
        this.errorAttributes = {
            errorCode: this.detail.message.message_template,
            statusCode: this.detail.message.status_code,
            rawErrorMessage: this.detail.message.content,
            // in case there is no traceId, we generate one in FE
            // and make it distinguishable from BE generated traceId
            // appended by random 5 digit number
            traceId: traceId ?? `StreamError-${$39527fcfea4df9b6$var$generateTraceId()}`,
            requestId: this.detail.metadata?.request_id,
            latestStreamMessageType: this.detail.type,
            latestStreamMessageMillisOffset: this.detail.millisOffset
        };
    }
}
class $39527fcfea4df9b6$export$7a01d8a5a5a1ae0a extends Error {
    constructor(message, params, cause){
        super(message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.cause = cause;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamGenerator-${$39527fcfea4df9b6$var$generateTraceId()}`,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
    }
}
class $39527fcfea4df9b6$export$cdcaebd3b25a3ac3 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            traceId: params.traceId ?? `NoFinalResponse-${$39527fcfea4df9b6$var$generateTraceId()}`
        };
    }
}
class $39527fcfea4df9b6$export$a4ff042cd5c23500 extends Error {
    constructor(params){
        super(params.message);
        this.errorAttributes = void 0;
        this.cause = void 0;
        this.name = this.constructor.name;
        this.errorAttributes = {
            conversationId: params.conversationId,
            messageId: params.messageId,
            invocationId: params.invocationId,
            actionKey: params.actionKey
        };
        if (params.cause) this.cause = params.cause;
    }
}
class $39527fcfea4df9b6$export$17fb3253ebc25334 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        this.errorAttributes = {
            traceId: params.traceId ?? `NoActionInvoked-${$39527fcfea4df9b6$var$generateTraceId()}`
        };
    }
}
class $39527fcfea4df9b6$export$f2869f2905168ef1 extends Error {
    constructor(message, params = {}){
        super(message);
        this.errorAttributes = void 0;
        this.message_template = void 0;
        this.name = this.constructor.name;
        this.message_template = 'DEEP_RESEARCH_ERROR';
        this.errorAttributes = {
            errorCode: 'DEEP_RESEARCH_ERROR',
            traceId: params.traceId ?? `DeepResearch-${$39527fcfea4df9b6$var$generateTraceId()}`,
            requestId: params.requestId
        };
    }
}
class $39527fcfea4df9b6$export$83cef568563975a4 extends Error {
    constructor(message, params){
        super(message);
        this.errorAttributes = void 0;
        this.agentMessageId = void 0;
        this.conversationId = void 0;
        this.answerIndex = void 0;
        this.lastEventId = void 0;
        this.name = this.constructor.name;
        this.agentMessageId = params.agentMessageId;
        this.conversationId = params.conversationId;
        this.answerIndex = params.answerIndex;
        this.lastEventId = params.lastEventId;
        this.errorAttributes = {
            traceId: params.traceId ?? `StreamReconnection-${$39527fcfea4df9b6$var$generateTraceId()}`,
            errorCode: 'STREAM_RECONNECTION_NEEDED',
            originalError: params.originalError.message,
            latestStreamMessageType: params.detail?.type,
            latestStreamMessageMillisOffset: params.detail?.millisOffset
        };
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
    }
}
module.exports["StreamErrorException"] = $39527fcfea4df9b6$export$7ed16f132715a198;
module.exports["StreamGeneratorError"] = $39527fcfea4df9b6$export$7a01d8a5a5a1ae0a;
module.exports["NoFinalResponseError"] = $39527fcfea4df9b6$export$cdcaebd3b25a3ac3;
module.exports["MessageActionError"] = $39527fcfea4df9b6$export$a4ff042cd5c23500;
module.exports["NoActionInvokedError"] = $39527fcfea4df9b6$export$17fb3253ebc25334;
module.exports["DeepResearchError"] = $39527fcfea4df9b6$export$f2869f2905168ef1;
module.exports["StreamDisconnectedError"] = $39527fcfea4df9b6$export$83cef568563975a4;

});


//# sourceMappingURL=FullPageEditorComponent.844f43dc.js.map
